export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `BigInt` scalar type represents non-fractional signed whole numeric values.
   * BigInt can represent values between -(2^53) + 1 and 2^53 - 1.
   */
  BigInt: any;
  /** A date string formatted as YYYY-MM-DD, indicating the beginning of a week */
  LocalWeek: any;
  /** A date string formatted as YYYY-MM-DD */
  LocalDate: any;
  /** an id for a calendar */
  CalendarId: any;
  /** A time string, in 24 hour time */
  LocalTime: any;
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Query = {
  __typename: "Query";
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Undocumented interface to fetch nodes by ids as defined in graphql-relay node.js */
  nodes: Array<Maybe<Node>>;
  viewer: Viewer;
};

export type QueryNodeArgs = {
  id: Scalars["ID"];
};

export type QueryNodesArgs = {
  ids: Array<Scalars["ID"]>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars["ID"];
};

/** The base node for all queries */
export type Viewer = Node & {
  __typename: "Viewer";
  /** Calendar Insights */
  calendarInsights: CalendarInsightsErrorable;
  /** Search external groups against a query string */
  groupQueryResult: ExternalGroupSearchResultErrorable;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Non-User Defrag Email Survey Response */
  nonUserDefragEmailResponse: NonUserDefragEmailResponseErrorable;
  /** Search org persons against a query string */
  orgPersonQueryResultErrorable: OrgPersonQueryResultErrorable;
  /** Search persons against a query string */
  personQueryResultErrorable: PersonQueryResultErrorable;
  /** Search external rooms against a query string */
  roomQueryResult: ExternalRoomSearchResultErrorable;
  /** The details of a booked scheduling link time. */
  schedulingLinkBooking?: Maybe<PublicBookingErrorable>;
  /** All the content for a scheduling link, including the available times. */
  schedulingLinkDetails?: Maybe<SchedulingLinkDetailsErrorable>;
  sudo?: Maybe<Sudo>;
  /** Search teams within an org */
  teamQueryResultErrorable: TeamQueryResultErrorable;
  /** A Clockwise user */
  user?: Maybe<User>;
  /** Check whether a given user shortname is available to be set */
  validateUserShortname: Scalars["Boolean"];
  /** Checks that a verification code is valid and which external client it will connect */
  verificationCodeResponse?: Maybe<VerificationCodeResponse>;
};

/** The base node for all queries */
export type ViewerGroupQueryResultArgs = {
  excludeCalendars?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  limit?: InputMaybe<Scalars["Int"]>;
  orgRelayId: Scalars["ID"];
  query: Scalars["String"];
};

/** The base node for all queries */
export type ViewerNonUserDefragEmailResponseArgs = {
  emailInstanceId: Scalars["String"];
};

/** The base node for all queries */
export type ViewerOrgPersonQueryResultErrorableArgs = {
  excludeCalendars?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  limit?: InputMaybe<Scalars["Int"]>;
  orgRelayId: Scalars["ID"];
  query: Scalars["String"];
};

/** The base node for all queries */
export type ViewerPersonQueryResultErrorableArgs = {
  excludeCalendars?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  limit?: InputMaybe<Scalars["Int"]>;
  orgRelayId: Scalars["ID"];
  query: Scalars["String"];
};

/** The base node for all queries */
export type ViewerRoomQueryResultArgs = {
  excludeCalendars: Array<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  orgRelayId?: InputMaybe<Scalars["ID"]>;
  query: Scalars["String"];
};

/** The base node for all queries */
export type ViewerSchedulingLinkBookingArgs = {
  bookingId: Scalars["String"];
};

/** The base node for all queries */
export type ViewerSchedulingLinkDetailsArgs = {
  body?: InputMaybe<ZonedDayTimeSlotRangeInput>;
  linkName: Scalars["String"];
  slug: Scalars["String"];
};

/** The base node for all queries */
export type ViewerTeamQueryResultErrorableArgs = {
  excludeMyTeams?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  orgRelayId: Scalars["ID"];
  query: Scalars["String"];
};

/** The base node for all queries */
export type ViewerValidateUserShortnameArgs = {
  shortname: Scalars["String"];
};

export type CalendarInsightsErrorable = CalendarInsights | GraphEntityError;

/** Insights about the fetched calendar */
export type CalendarInsights = {
  __typename: "CalendarInsights";
  aggregateStats: Array<AggregateCalendarStats>;
  topCollaborators?: Maybe<Array<Maybe<Scalars["String"]>>>;
  userStats: CalendarFocusTimeStats;
};

/** Aggregate Calendar Stats */
export type AggregateCalendarStats = Node & {
  __typename: "AggregateCalendarStats";
  distribution: Array<Maybe<FocusTimeMeetingDistribution>>;
  /** The ID of an object */
  id: Scalars["ID"];
  job: Scalars["String"];
  role: Scalars["String"];
  stats: CalendarFocusTimeStats;
};

/** Focus Time Meeting Distribution */
export type FocusTimeMeetingDistribution = Node & {
  __typename: "FocusTimeMeetingDistribution";
  focusTimeHours: Scalars["Int"];
  /** The ID of an object */
  id: Scalars["ID"];
  meetingHours: Scalars["Int"];
  percentage: Scalars["Float"];
  weight: Scalars["Int"];
};

/** Calendar Focus Time Stats */
export type CalendarFocusTimeStats = {
  __typename: "CalendarFocusTimeStats";
  adHocMeetingMinutes: Scalars["Int"];
  externalMeetingMinutes: Scalars["Int"];
  focusMinutes: Scalars["Int"];
  fragmentedMinutes: Scalars["Int"];
  meetingMinutes: Scalars["Int"];
  oneOnOneMeetingMinutes: Scalars["Int"];
  teamSyncMeetingMinutes: Scalars["Int"];
};

/** An error wrapper */
export type GraphEntityError = {
  __typename: "GraphEntityError";
  body?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
  statusCode?: Maybe<Scalars["Int"]>;
};

export type ExternalGroupSearchResultErrorable = ExternalGroupSearchResult | GraphEntityError;

/** Result of searching for external groups */
export type ExternalGroupSearchResult = {
  __typename: "ExternalGroupSearchResult";
  groups: Array<ExternalGroupSearchMetadata>;
  inputQuery: Scalars["String"];
};

/** Metadata about an external group */
export type ExternalGroupSearchMetadata = {
  __typename: "ExternalGroupSearchMetadata";
  emailAddress: Scalars["String"];
  groupSize: Scalars["Int"];
};

export type NonUserDefragEmailResponseErrorable = GraphEntityError | NonUserDefragEmailResponse;

/** Response to non-user defrag email survey */
export type NonUserDefragEmailResponse = Node & {
  __typename: "NonUserDefragEmailResponse";
  additionalInformation?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  responseType: NonUserDefragEmailResponseType;
};

export enum NonUserDefragEmailResponseType {
  No = "No",
  NotSure = "NotSure",
  Yes = "Yes",
}

export type OrgPersonQueryResultErrorable = GraphEntityError | OrgPersonQueryResult;

/** Search results for org persons */
export type OrgPersonQueryResult = {
  __typename: "OrgPersonQueryResult";
  /** Persons that match the query */
  persons: Array<Maybe<OrgPerson>>;
  /** The input query string */
  query: Scalars["String"];
};

/** DESCRIBE NEW FIELD HERE */
export type OrgPerson = Node & {
  __typename: "OrgPerson";
  calendarAliases: Array<Scalars["String"]>;
  eligibleForTeams?: Maybe<Scalars["Boolean"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  isYou: Scalars["Boolean"];
  personId: Scalars["String"];
  primaryBillingGroupIdErrorable?: Maybe<PrimaryBillingGroupIdErrorable>;
  primaryCalendarId: Scalars["String"];
  profile?: Maybe<UserProfile>;
  redirectPersonId?: Maybe<Scalars["String"]>;
  signUpMillis?: Maybe<Scalars["BigInt"]>;
  userId?: Maybe<Scalars["String"]>;
};

export type PrimaryBillingGroupIdErrorable = GraphEntityError | PrimaryBillingGroupId;

export type PrimaryBillingGroupId = {
  __typename: "PrimaryBillingGroupId";
  primaryBillingGroupId?: Maybe<Scalars["String"]>;
};

/** A User Profile includes just the basic information about a Calendar User (not necessarily a Clockwise user) */
export type UserProfile = {
  __typename: "UserProfile";
  /** The URL for a User's profile image */
  externalImageUrl?: Maybe<Scalars["String"]>;
  /** A user's last name */
  familyName?: Maybe<Scalars["String"]>;
  /** A user's first name */
  givenName?: Maybe<Scalars["String"]>;
};

export type PersonQueryResultErrorable = GraphEntityError | PersonQueryResult;

/** Search results for persons */
export type PersonQueryResult = {
  __typename: "PersonQueryResult";
  /** Persons that match the query */
  persons: Array<Maybe<Person>>;
  /** The input query string */
  query: Scalars["String"];
};

/** A person */
export type Person = Node & {
  __typename: "Person";
  /** The emails of the person */
  emails: Array<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  isOutsideOrg: Scalars["Boolean"];
  isUser: Scalars["Boolean"];
  isYou: Scalars["Boolean"];
  /** The primary email of the person */
  primaryEmail: Scalars["String"];
  /** The profile of the person, may be null */
  profile?: Maybe<UserProfile>;
  userId?: Maybe<Scalars["String"]>;
};

export type ExternalRoomSearchResultErrorable = ExternalRoomSearchResult | GraphEntityError;

/** Result of searching for a room by name */
export type ExternalRoomSearchResult = {
  __typename: "ExternalRoomSearchResult";
  /** Whether the result of the query is cacheable (e.g. was there an error) */
  cacheable: Scalars["Boolean"];
  rooms: Array<Room>;
  searchQuery: Scalars["String"];
};

/** A room */
export type Room = Node & {
  __typename: "Room";
  estimatedCapacity?: Maybe<Scalars["Int"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** @deprecated Not populated, always null */
  locationId?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  orgId: Scalars["String"];
  reportedCapacity?: Maybe<Scalars["Int"]>;
  roomId: Scalars["String"];
};

export type PublicBookingErrorable = GraphEntityError | PublicBooking;

/** Detailed of a scheduling link booking */
export type PublicBooking = {
  __typename: "PublicBooking";
  attendeeEmail: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  endTime: Scalars["String"];
  id: Scalars["ID"];
  locationType: BookingLocationType;
  meetingName: Scalars["String"];
  ownerEmail: Scalars["String"];
  ownerProfile: UserProfile;
  /** Details of the scheduling link this booking was created with */
  schedulingLinkDetails?: Maybe<SchedulingLinkDetails>;
  startTime: Scalars["String"];
};

/** Detailed of a scheduling link booking */
export type PublicBookingSchedulingLinkDetailsArgs = {
  endDate: Scalars["String"];
  startDate: Scalars["String"];
  timeZone: Scalars["String"];
};

export enum BookingLocationType {
  InDescription = "InDescription",
  Meet = "Meet",
  Zoom = "Zoom",
}

/** Meeting title, owner name, duration, other details, and suggested times of a scheduling link. */
export type SchedulingLinkDetails = {
  __typename: "SchedulingLinkDetails";
  /** The user shortname for the owner of this Scheduling Link */
  linkName: Scalars["String"];
  /** The user profile of the meeting owner */
  ownerProfile: UserProfile;
  publicMeetingSettings: PublicMeetingSettings;
  /** The slug for this SchedulingLink, unique for the given user linkName */
  slug: Scalars["String"];
  suggestedSlotsByDate: Array<SuggestedSlotsByDate>;
};

/** Public settings of a scheduling link for use by the scheduling link page. */
export type PublicMeetingSettings = {
  __typename: "PublicMeetingSettings";
  bookingTimeBufferHours: Scalars["Int"];
  description?: Maybe<Scalars["String"]>;
  durationMinutes: Scalars["Int"];
  endOfAvailability: EventTime;
  highlightBestTimes: Scalars["Boolean"];
  id: Scalars["ID"];
  locationType: PublicLinkLocationType;
  name: Scalars["String"];
};

/** A rich description of a time */
export type EventTime = {
  __typename: "EventTime";
  /** String representation of the date or datetime */
  dateOrDateTime: Scalars["String"];
  /** Time represented in milliseconds (DateTime is ) */
  millis: Scalars["Float"];
  /** Timezone offset in minutes */
  offsetMinutes?: Maybe<Scalars["Float"]>;
  /** Standard IANA timezone string */
  timeZone?: Maybe<Scalars["String"]>;
  /** The type of date */
  type: EventTimeType;
};

export enum EventTimeType {
  Date = "Date",
  DateTime = "DateTime",
}

export enum PublicLinkLocationType {
  InDescription = "InDescription",
  Meet = "Meet",
  Zoom = "Zoom",
}

export type SuggestedSlotsByDate = {
  __typename: "SuggestedSlotsByDate";
  date: Scalars["String"];
  suggestedSlots: Array<SuggestedSlot>;
};

/** Start and end time of a suggested slot. */
export type SuggestedSlot = {
  __typename: "SuggestedSlot";
  tag?: Maybe<Tag>;
  timeRange: TimeRangeNonNull;
};

export enum Tag {
  Best = "Best",
  Inconvenient = "Inconvenient",
}

/** A time range with non null times */
export type TimeRangeNonNull = Node & {
  __typename: "TimeRangeNonNull";
  /** The end time in the range, non null */
  endTime: EventTime;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The start time in the range, non null */
  startTime: EventTime;
};

export type ZonedDayTimeSlotRangeInput = {
  dayTimeSlotRange: DayTimeSlotRangeInput;
  timeZone?: InputMaybe<Scalars["String"]>;
};

export type DayTimeSlotRangeInput = {
  maxSlot: DayTimeSlotInput;
  minSlot: DayTimeSlotInput;
};

export type DayTimeSlotInput = {
  date: Scalars["String"];
  timeSlot: TimeSlot;
};

/** A time slot */
export enum TimeSlot {
  T_00_00 = "T_00_00",
  T_00_30 = "T_00_30",
  T_01_00 = "T_01_00",
  T_01_30 = "T_01_30",
  T_02_00 = "T_02_00",
  T_02_30 = "T_02_30",
  T_03_00 = "T_03_00",
  T_03_30 = "T_03_30",
  T_04_00 = "T_04_00",
  T_04_30 = "T_04_30",
  T_05_00 = "T_05_00",
  T_05_30 = "T_05_30",
  T_06_00 = "T_06_00",
  T_06_30 = "T_06_30",
  T_07_00 = "T_07_00",
  T_07_30 = "T_07_30",
  T_08_00 = "T_08_00",
  T_08_30 = "T_08_30",
  T_09_00 = "T_09_00",
  T_09_30 = "T_09_30",
  T_10_00 = "T_10_00",
  T_10_30 = "T_10_30",
  T_11_00 = "T_11_00",
  T_11_30 = "T_11_30",
  T_12_00 = "T_12_00",
  T_12_30 = "T_12_30",
  T_13_00 = "T_13_00",
  T_13_30 = "T_13_30",
  T_14_00 = "T_14_00",
  T_14_30 = "T_14_30",
  T_15_00 = "T_15_00",
  T_15_30 = "T_15_30",
  T_16_00 = "T_16_00",
  T_16_30 = "T_16_30",
  T_17_00 = "T_17_00",
  T_17_30 = "T_17_30",
  T_18_00 = "T_18_00",
  T_18_30 = "T_18_30",
  T_19_00 = "T_19_00",
  T_19_30 = "T_19_30",
  T_20_00 = "T_20_00",
  T_20_30 = "T_20_30",
  T_21_00 = "T_21_00",
  T_21_30 = "T_21_30",
  T_22_00 = "T_22_00",
  T_22_30 = "T_22_30",
  T_23_00 = "T_23_00",
  T_23_30 = "T_23_30",
}

export type SchedulingLinkDetailsErrorable = GraphEntityError | SchedulingLinkDetails;

export type Sudo = Node & {
  __typename: "Sudo";
  /** Org domains that are explicitly removed from the whitelist. */
  blacklistedDomains: Array<Maybe<Scalars["String"]>>;
  /** Last update times for the chrome app */
  chromeAppUpdateTimes?: Maybe<ChromeAppUpdateTimes>;
  /** All emails for all users */
  claimedEmails: Array<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  listCliCommands?: Maybe<CliCommandListErrorable>;
  modifyUser?: Maybe<UserAndExtendedInfo>;
  resetFlowState?: Maybe<FlowState>;
  waitlistEnabled: Scalars["Boolean"];
  waitlistUsers: Array<WaitlistedUser>;
  /** An array of whitelisted domains that get you a preview of the app. */
  whitelistedDomains?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** An array of explicitly whitelisted users. */
  whitelistedUsers: Array<Maybe<Scalars["String"]>>;
};

export type SudoResetFlowStateArgs = {
  email?: InputMaybe<Scalars["String"]>;
};

export type ChromeAppUpdateTimes = {
  __typename: "ChromeAppUpdateTimes";
  /** Last update of the chrome app with immediate priority */
  forceTime?: Maybe<Scalars["BigInt"]>;
  /** Last update of the chrome app with idle priority */
  idleTime?: Maybe<Scalars["BigInt"]>;
};

export type CliCommandListErrorable = CliCommandList | GraphEntityError;

export type CliCommandList = {
  __typename: "CliCommandList";
  list: Array<CliCommand>;
};

/** The schema for a CLI command */
export type CliCommand = Node & {
  __typename: "CliCommand";
  /** The ID of an object */
  id: Scalars["ID"];
  name: Scalars["String"];
  options: Array<CliOption>;
};

/** The schema for an option of a CLI command */
export type CliOption = {
  __typename: "CliOption";
  description: Scalars["String"];
  name: Scalars["String"];
  type: CliOptionType;
};

export enum CliOptionType {
  Boolean = "Boolean",
  String = "String",
}

export type UserAndExtendedInfo = {
  __typename: "UserAndExtendedInfo";
  /** User's feature grid */
  featureStatesJson?: Maybe<Scalars["String"]>;
  /** Org's current accounting period */
  orgAccountingPeriod?: Maybe<OrgAccountingPeriodErrorable>;
  /** User's subscriptions */
  subscriptions?: Maybe<PaymentSubscriptionListErrorable>;
  /** User */
  user?: Maybe<User>;
  /** User's teams */
  userTeams?: Maybe<TeamListErrorable>;
};

export type OrgAccountingPeriodErrorable = GraphEntityError | OrgAccountingPeriod;

/** Freemium Org accounting period info */
export type OrgAccountingPeriod = {
  __typename: "OrgAccountingPeriod";
  enforcementStarted: Scalars["Boolean"];
  enforcementState: EnforcementStateEnum;
  periodRange: DateRange;
  quotaMax: Scalars["Int"];
  quotaUsed: Scalars["Int"];
};

export enum EnforcementStateEnum {
  ApproachingLimit = "ApproachingLimit",
  NoEnforcement = "NoEnforcement",
  ReachedLimit = "ReachedLimit",
}

/** DESCRIBE NEW FIELD HERE */
export type DateRange = {
  __typename: "DateRange";
  maxDate: Scalars["String"];
  minDate: Scalars["String"];
};

export type PaymentSubscriptionListErrorable = GraphEntityError | PaymentSubscriptionList;

export type PaymentSubscriptionList = {
  __typename: "PaymentSubscriptionList";
  list: Array<PaymentSubscription>;
};

/** A product subscription under an org for a particular subjectt */
export type PaymentSubscription = Node & {
  __typename: "PaymentSubscription";
  endMillis: Scalars["Int"];
  /** The ID of an object */
  id: Scalars["ID"];
  productType?: Maybe<ProductTypeEnum>;
  seatCount: Scalars["Int"];
  startMillis: Scalars["Int"];
  subjectUrn: Urn;
  type?: Maybe<SubscriptionTypeEnum>;
};

export enum ProductTypeEnum {
  BusinessNonStandard = "Business_NonStandard",
  BusinessStandard = "Business_Standard",
  EnterpriseNonStandard = "Enterprise_NonStandard",
  EnterpriseStandard = "Enterprise_Standard",
  ProNonStandard = "Pro_NonStandard",
  ProStandard = "Pro_Standard",
}

/** A Uniform Resource Name */
export type Urn = Node & {
  __typename: "Urn";
  /** The ID of an object */
  id: Scalars["ID"];
  scope?: Maybe<Urn>;
  type?: Maybe<UrnType>;
  value?: Maybe<Scalars["String"]>;
};

export enum UrnType {
  Date = "Date",
  Email = "Email",
  Event = "Event",
  FlowState = "FlowState",
  Guest = "Guest",
  Org = "Org",
  Phone = "Phone",
  Services = "Services",
  Setting = "Setting",
  Team = "Team",
  Teammate = "Teammate",
  TimeZone = "TimeZone",
  User = "User",
  WorkingGroup = "WorkingGroup",
  WorkingHours = "WorkingHours",
  WorkOsOrg = "WorkOsOrg",
}

export enum SubscriptionTypeEnum {
  Expired = "Expired",
  FreemiumOrg = "FreemiumOrg",
  LegacyPrePaywall = "LegacyPrePaywall",
  PaidBillingGroup = "PaidBillingGroup",
  PaidOrgPro = "PaidOrgPro",
  PaidTeamPro = "PaidTeamPro",
  PaidUserPro = "PaidUserPro",
  SelfServePremiumOrgQ42020 = "SelfServePremiumOrgQ42020",
  SelfServePremiumTeamQ12021 = "SelfServePremiumTeamQ12021",
}

/** A person who uses our app */
export type User = Node & {
  __typename: "User";
  /** The user's bucket o' booleans for the chrome extension */
  chromeExtensionFlagsErrorable?: Maybe<FlagsErrorable>;
  createdTime?: Maybe<Scalars["BigInt"]>;
  /** A user's collection of data sources */
  dataSources?: Maybe<DataSourceConnection>;
  emails: Array<Scalars["String"]>;
  /** The profile image of the user */
  externalImageUrl?: Maybe<Scalars["String"]>;
  /** The last name of the user */
  familyName?: Maybe<Scalars["String"]>;
  /** The collection of flow states for the user */
  flowStates?: Maybe<FlowStateConnection>;
  /** The first name of the user */
  givenName?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  jwtIssuedTime?: Maybe<Scalars["BigInt"]>;
  /** A user's configurable id, like a username, for their scheduling links. Unique among all Clockwise users. */
  linkNameErrorable?: Maybe<LinkNameErrorable>;
  /** Settings of a given scheduling link for consumption by the owner of the link */
  meetingSettingsErrorable?: Maybe<MeetingSettingsErrorable>;
  /** A list of primary email/org urns for this user */
  members?: Maybe<Array<Maybe<Urn>>>;
  /** The collection of orgs the user belongs to */
  orgs: OrgConnection;
  schedulingLinks?: Maybe<Array<SchedulingLink>>;
  /** The user's bucket o' booleans for the services */
  servicesFlagsErrorable?: Maybe<FlagsErrorable>;
  /** Status of the user */
  status?: Maybe<UserStatusEnum>;
  /** The user's bucket o' booleans for the web app */
  webAppFlagsErrorable?: Maybe<FlagsErrorable>;
};

/** A person who uses our app */
export type UserDataSourcesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
};

/** A person who uses our app */
export type UserFlowStatesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A person who uses our app */
export type UserLinkNameErrorableArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  createLinkNameIfNone?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A person who uses our app */
export type UserMeetingSettingsErrorableArgs = {
  slug: Scalars["String"];
};

/** A person who uses our app */
export type UserOrgsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orgRelayId?: InputMaybe<Scalars["String"]>;
};

/** A person who uses our app */
export type UserSchedulingLinksArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  createLinkNameIfNone?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export type FlagsErrorable = Flags | GraphEntityError;

/** bucket o' booleans */
export type Flags = Node & {
  __typename: "Flags";
  flags?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** The ID of an object */
  id: Scalars["ID"];
};

/** A connection to a list of items. */
export type DataSourceConnection = {
  __typename: "DataSourceConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DataSourceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DataSourceEdge = {
  __typename: "DataSourceEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<DataSource>;
};

/** A data source */
export type DataSource = Node & {
  __typename: "DataSource";
  /** List of calendarIds associated with this datasource */
  calendarIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** The email associated with a data source */
  email?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The name of the data source */
  name?: Maybe<Scalars["String"]>;
  /**
   * The provider of the data source
   * @deprecated use type enum instead
   */
  provider?: Maybe<Scalars["Int"]>;
  state?: Maybe<DataSourceStatus>;
  /**
   * The status of the data source
   * @deprecated use state enum instead
   */
  status?: Maybe<Scalars["Int"]>;
  /** other calendars this data-source is syncing to, if any */
  syncTargets?: Maybe<Array<Maybe<CrawlTarget>>>;
  type?: Maybe<DataSourceProvider>;
  /** The username associated with a data source */
  username?: Maybe<Scalars["String"]>;
};

export enum DataSourceStatus {
  Okay = "Okay",
  RequiresReAuth = "RequiresReAuth",
}

/** a calendar that another calendar's events are synced to */
export type CrawlTarget = {
  __typename: "CrawlTarget";
  /** The target calendarId */
  calendarId?: Maybe<Scalars["String"]>;
  /** The target emailAddress */
  emailAddress?: Maybe<Scalars["String"]>;
};

export enum DataSourceProvider {
  Google = "Google",
  Office365 = "Office365",
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]>;
};

/** A connection to a list of items. */
export type FlowStateConnection = {
  __typename: "FlowStateConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FlowStateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FlowStateEdge = {
  __typename: "FlowStateEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<FlowState>;
};

/** A state for a flow defined by a flowKey for a given user/org */
export type FlowState = Node & {
  __typename: "FlowState";
  /** The current status of the flow */
  current?: Maybe<FlowStatus>;
  /** The key for looking up the state */
  flowKey?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The pending/next status of the flow */
  pending?: Maybe<FlowStatus>;
  /** The previous state of the flow */
  previousState?: Maybe<Scalars["String"]>;
};

/** A state for a flow defined by a flowKey for a given user/org */
export type FlowStatus = Node & {
  __typename: "FlowStatus";
  /** Any associated error with the current state */
  errorMessage?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** A percentage of completion for the state */
  percentComplete?: Maybe<Scalars["Float"]>;
  /** The current state of flow */
  state?: Maybe<Scalars["String"]>;
};

export type LinkNameErrorable = GraphEntityError | LinkName;

export type LinkName = {
  __typename: "LinkName";
  /** A user's configurable id, like a username, for their scheduling links. Unique among all Clockwise users. */
  linkName?: Maybe<Scalars["String"]>;
};

export type MeetingSettingsErrorable = GraphEntityError | MeetingSettings;

/** A scheduling link settings */
export type MeetingSettings = {
  __typename: "MeetingSettings";
  allowFifteenMinuteMarkBooking: Scalars["Boolean"];
  availabilityType: AvailabilityType;
  bookableHours: BookableHoursEnum;
  bookingTimeBufferHours: Scalars["Int"];
  bookOnNoMeetingDay: Scalars["Boolean"];
  description?: Maybe<Scalars["String"]>;
  highlightBestTimes: Scalars["Boolean"];
  id?: Maybe<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  locationSettings: LocationSettings;
  name: Scalars["String"];
  /** Will be non-empty for an existing MeetingSetting, will be empty for a new MeetingSetting */
  slug: Scalars["String"];
  timingSettings: TimingSettings;
};

export enum AvailabilityType {
  BalanceAvailabilityAndFocus = "BalanceAvailabilityAndFocus",
  MaximizeAvailability = "MaximizeAvailability",
  MaximizeFocusTime = "MaximizeFocusTime",
}

export enum BookableHoursEnum {
  MeetingHours = "MeetingHours",
  WorkingHours = "WorkingHours",
}

/** Location details of a scheduling link */
export type LocationSettings = {
  __typename: "LocationSettings";
  locationDetails?: Maybe<Scalars["String"]>;
  locationType: LinkLocationType;
};

export enum LinkLocationType {
  InDescription = "InDescription",
  Meet = "Meet",
  Zoom = "Zoom",
}

export type TimingSettings = {
  __typename: "TimingSettings";
  durationMinutes: Scalars["Int"];
  periodType: PeriodType;
  timeRange: LinkTimeRange;
};

export enum PeriodType {
  Range = "Range",
  RollingWindow = "RollingWindow",
}

export type LinkTimeRange = {
  __typename: "LinkTimeRange";
  rangeEndTime?: Maybe<Scalars["String"]>;
  /** @deprecated use rangeEndTime */
  rangeEndTimeMillis?: Maybe<Scalars["Int"]>;
  rangeStartTime?: Maybe<Scalars["String"]>;
  /** @deprecated use rangeStartTime */
  rangeStartTimeMillis?: Maybe<Scalars["Int"]>;
  timeZone?: Maybe<Scalars["String"]>;
  windowSizeDays?: Maybe<Scalars["Int"]>;
};

/** A connection to a list of items. */
export type OrgConnection = {
  __typename: "OrgConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrgEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrgEdge = {
  __typename: "OrgEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<Org>;
};

/** A collection of users with the same email domain. */
export type Org = Node & {
  __typename: "Org";
  /**
   * A list of all active people in org
   * @deprecated Use currentOrgPersons
   */
  activeOrgPersons: OrgPersonListErrorable;
  /** Details of a users Asana account (never actual credentials) and related settings */
  asanaAccountErrorable: AsanaAccountErrorable;
  /** Autopilot events for the user */
  autopilotEventsResponse: AutopilotEventsResponseErrorable;
  /** Autopilot onboarding suggestions for the user */
  autopilotOnboardingSuggestionsResponse: AutopilotOnboardingSuggestionsResponseErrorable;
  /** a billing group for given id */
  billingGroupForId: BillingGroupErrorable;
  /** a list of billing groups for current org */
  billingGroups: BillingGroupListErrorable;
  /** Calculates smart hold events without reserving them on a user calendar */
  calculateSmartHoldsErrorable?: Maybe<SmartHoldCalculationResultErrorable>;
  /** The calendar status for a given calendarId */
  calendarStatusErrorable: CalendarStatusErrorable;
  /** Teammate time stats for a given time period */
  calendarTimeStats?: Maybe<CalendarTimeStats>;
  /** Teammate time stats for a given time period and set of calendars */
  calendarTimeStatsList?: Maybe<CalendarTimeStatsListErrorable>;
  /**
   * For a given user and event can an event be rescheduled
   * @deprecated use canScheduleResponse
   */
  canRescheduleEvent: Scalars["Boolean"];
  /** For a given user and event can an event be resheduled or put on autopilot */
  canScheduleResponse?: Maybe<CanScheduleResponseListErrorable>;
  /**
   * Teammate time stats with other teammates for a given time period
   * @deprecated In favor of new Errorable version
   */
  collaboratorStats?: Maybe<CollaboratorStats>;
  /** Errorable teammate time stats with other teammates for a given time period */
  collaboratorStatsErrorable?: Maybe<CollaboratorStatsErrorable>;
  /** Compute pain points on an event's currently scheduled slot */
  computeCurrentSlotImpactErrorable: CurrentScheduledSlotImpactErrorable;
  /** Crawl status for calendarIds in this org */
  crawledCalendarInfo?: Maybe<CrawledCalendarInfo>;
  /** Crawl status for given calendarIds */
  crawledCalendarInfoForCalendars?: Maybe<CrawledCalendarInfo>;
  crawlTest?: Maybe<OrgCrawlTest>;
  createdTime?: Maybe<Scalars["BigInt"]>;
  /** A list of all `active` users in an org */
  currentOrgPersons: OrgPersonListErrorable;
  /** The domains associated with this org */
  domains?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** The user's event coloring settings for the org */
  eventColoringSettingsErrorable: EventColoringSettingsErrorable;
  /**
   * Event with a given id on the given calendar (unlike
   * forceFetchEventParentErrorable does not do a pull from Google for the latest info)
   */
  eventForCalendar: EventErrorable;
  /** Event parents and event parent bases */
  eventParentBaseWrapperByDates: EventParentBaseWrapperErrorable;
  /**
   * Event parents and event parent bases by week
   * @deprecated In favor of object version which is supported by both Apollo and Relay
   */
  eventParentBaseWrapperByWeeks: EventParentBaseWrapperByWeekListErrorable;
  /** Event parents and event parent bases by week */
  eventParentBaseWrapperByWeeksObject: EventParentBaseWrapperByWeekObjectListErrorable;
  /** An org's collection of events from all queried calendars and dates */
  eventParentsByDates: EventParentConnection;
  /** An org's collection of events from all queried calendars and dates */
  eventParentWrappersByDatesErrorable: EventParentWrapperConnectionErrorable;
  /** A list of all experiment strings enabled for this org */
  experiments?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** External groups for emails */
  externalGroups: ExternalGroupListErrorable;
  featureGrid: FeatureGridErrorable;
  /** The user's feed suggestion results */
  feedSuggestionsErrorable: FeedSuggestionResultsErrorable;
  /** Fetch heatmap for set of calendar ids for time range */
  fetchHeatmapErrorable: HeatmapResultErrorable;
  /** The collection of flow states for the user */
  flowStates?: Maybe<FlowStateConnection>;
  /** The total number of hours saved across an org */
  focusTimeSavedInHours: Scalars["Int"];
  /** Focus Time stats for the user */
  focusTimeStats: FocusTimeStatsErrorable;
  /** Force fetch an event from Google (does a pull from Google to ensure the event has latest info) */
  forceFetchEventParentErrorable: EventParentErrorable;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The meeting hours for the current org, a set of users (via userIds), or any set of non-users (via calendarIds) */
  meetingHoursQueryResult?: Maybe<MeetingHoursQueryResult>;
  /** The name of the org */
  name?: Maybe<Scalars["String"]>;
  /** The next defrag time for the current org */
  nextDefragTime?: Maybe<DefragTimeErrorable>;
  /** Onboarding checklist for a user */
  onboardingChecklist: OnboardingChecklist;
  /** List of a user's one on ones */
  oneOnOnesForCalendar: EventListErrorable;
  /** Optimistic savings for a user, used to determine how much time can be saved in a week */
  optimisticSavingsErrorable?: Maybe<OptimisticSavingsErrorable>;
  /** Optimistic savings for current user for next week */
  optimisticSavingsForCurrentUserNextWeekErrorable?: Maybe<OptimisticSavingsErrorable>;
  orgAccountingPeriod: OrgAccountingPeriodErrorable;
  /** The collection of flow states for the org */
  orgFlowStates?: Maybe<FlowStateListErrorable>;
  /** The default meeting hours for the current org */
  orgMeetingHours?: Maybe<OrgMeetingHours>;
  /** Overview of organization-wide Clockwise usage */
  orgOverview?: Maybe<OrgOverviewErrorable>;
  orgPersonForUserErrorable: OrgPersonErrorable;
  /** Object defining a list of org persons and how to paginate the list */
  orgPersonListPaginatedErrorable: OrgPersonListPaginatedErrorable;
  /** Pending org invites outstanding */
  pendingInvites?: Maybe<OrgInviteConnection>;
  /** A collection of teammates, suggestions, invitees and you */
  personCorpusErrorable: PersonListErrorable;
  personForUserErrorable: PersonErrorable;
  /** Look up persons by calendar id */
  personsByCalendarIdsErrorable: PersonListErrorable;
  /** Look up persons by user id */
  personsByUserIdsErrorable: PersonListErrorable;
  /** The users primary calendar in this org */
  primaryOrgCalendar: Scalars["String"];
  /** The users email thats part of this org */
  primaryOrgEmail: Scalars["String"];
  /** Primary team for user */
  primaryTeam?: Maybe<TeamErrorable>;
  /** A list of profile time zones */
  profileTimeZonesErrorable: ProfileTimeZoneListErrorable;
  /** List of public Slack channels for the slack workspace for a given Clockwise team */
  publicChannelsForSlackForTeam: SlackChannelListErrorable;
  /** A set of rescheduling suggestions for the given query */
  reschedulingResponseErrorable: SchedulingResponseErrorable;
  /** A rewind history for a calendarId/week */
  rewindHistoryErrorable: RewindHistoryErrorable;
  /** External rooms for the given ids */
  rooms: RoomListErrorable;
  /** A set of scheduling suggestions for the given query */
  schedulingResponseErrorable: SchedulingResponseErrorable;
  /** The collection of settings for this user in this org */
  settings?: Maybe<SettingConnection>;
  /** The user's shadow calendar settings for the org */
  shadowCalendarSettingsErrorable: ShadowCalendarSettingsErrorable;
  /** Slack Settings for a given team */
  slackAccountForTeamErrorable?: Maybe<SlackAccountErrorable>;
  /** The user's list of Slack Accounts */
  slackAccountsErrorable: SlackAccountListErrorable;
  /** The user's list of Slack Account Settings */
  slackSettingsErrorable: SlackSettingsListErrorable;
  smartHoldEventInfo: SmartHoldEventInfoErrorable;
  /** A link, which expires in 5 minutes, that can be used to configure sso for a billing group. */
  ssoAdminPortalLink?: Maybe<SsoAdminPortalLinkErrorable>;
  /** Suggestions for scheduling a high priority moving with defrag */
  suggestDefragForHighPriorityMeeting?: Maybe<DefragConflictResolutionErrorable>;
  /** Suggested invites to make for this org */
  suggestedInvites?: Maybe<SuggestedOrgInviteConnection>;
  /** The suggested and selected room preferences */
  suggestedRoomPreferences: SuggestedRoomPreferencesErrorable;
  /** A list of all suggested teams for user */
  suggestedTeams: SuggestedTeamListErrorable;
  /** Working preferences for a teammate */
  summarizedWorkingPreferences?: Maybe<SummarizedWorkingPreferences>;
  /** Event with a given id on the given calendar */
  syncedOriginEvent: EventErrorable;
  /** Fetches (most recent) tailored defrag summary */
  tailoredDefragCardSummary?: Maybe<TailoredDefragCardSummaryErrorable>;
  /** Calendar statuses for everyone on the team */
  teamCalendarStatusErrorable: CalendarStatusListErrorable;
  /** A team for org from given teamId */
  teamForTeamId?: Maybe<TeamErrorable>;
  /** Team health score for calendars for a given time period */
  teamHealthScoreForCalendarsErrorable?: Maybe<TeamHealthScoreErrorable>;
  /** Team health scorefor team for a given time period */
  teamHealthScoreForTeamErrorable?: Maybe<TeamHealthScoreErrorable>;
  /** Team health score for team for a given time period */
  teamHealthScoreForTeamWithSubTeamsErrorable?: Maybe<TeamHealthScoreWithSubTeamsErrorable>;
  /** Team health score just for user for a given time period */
  teamHealthScoreJustForUserErrorable?: Maybe<TeamHealthScoreErrorable>;
  /** Overall settings for a team */
  teamSettings: TeamSettingsErrorable;
  /** A list of all teams for org */
  teamsForOrg: TeamListErrorable;
  /** User's settings for a team */
  teamUserSettings: TeamUserSettingsErrorable;
  /** The user's team */
  userDefinedTeam?: Maybe<UserDefinedTeam>;
  /** The users's goals */
  userGoals?: Maybe<GoalConnection>;
  /** The meeting hours for the current user */
  userMeetingHours?: Maybe<UserMeetingHours>;
  /** The current user's profile */
  userPerson?: Maybe<PersonErrorable>;
  /** The user responses from the onboarding survey */
  userSurveyResponseErrorable: UserSurveyResponseListErrorable;
  /** The user responses wrapped by ID for the onboarding survey */
  userSurveyResponseWrapperErrorable: UserSurveyResponseWrapperErrorable;
  /** A list of all teams for user */
  userTeams: TeamListErrorable;
  /** The working hours for the current user */
  userWorkingHours?: Maybe<UserWorkingHours>;
  /** The user work address for this org */
  workAddressForUser: AddressErrorable;
  /** Working groups for this user for this org */
  workingGroups: WorkingGroupConnection;
  /** The working hours for any given set of users */
  workingHoursQueryResult?: Maybe<WorkingHoursQueryResult>;
  /** Connected account-level zoom account for org */
  zoomAccount?: Maybe<ZoomAccountErrorable>;
  /** Connected user-level zoom account for org */
  zoomUserLevelAccount?: Maybe<ZoomAccountErrorable>;
};

/** A collection of users with the same email domain. */
export type OrgAutopilotEventsResponseArgs = {
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgBillingGroupForIdArgs = {
  billingGroupId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgCalculateSmartHoldsErrorableArgs = {
  week: Scalars["LocalWeek"];
};

/** A collection of users with the same email domain. */
export type OrgCalendarStatusErrorableArgs = {
  calendarId: Scalars["String"];
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgCalendarTimeStatsArgs = {
  calendarId: Scalars["String"];
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgCalendarTimeStatsListArgs = {
  calendarIds: Array<Scalars["String"]>;
  dates: Array<Scalars["LocalDate"]>;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgCanRescheduleEventArgs = {
  calendarIds?: InputMaybe<Array<Scalars["String"]>>;
  eventParentRelayId?: InputMaybe<Scalars["ID"]>;
};

/** A collection of users with the same email domain. */
export type OrgCanScheduleResponseArgs = {
  calendarIds?: InputMaybe<Array<Scalars["String"]>>;
  externalEventIds: Array<InputMaybe<Scalars["String"]>>;
};

/** A collection of users with the same email domain. */
export type OrgCollaboratorStatsArgs = {
  calendarId: Scalars["String"];
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgCollaboratorStatsErrorableArgs = {
  calendarId: Scalars["String"];
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgComputeCurrentSlotImpactErrorableArgs = {
  externalEventId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgCrawledCalendarInfoForCalendarsArgs = {
  calendarIds: Array<Scalars["String"]>;
};

/** A collection of users with the same email domain. */
export type OrgEventForCalendarArgs = {
  calendarId: Scalars["String"];
  externalEventId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgEventParentBaseWrapperByDatesArgs = {
  calendarIds: Array<Scalars["String"]>;
  dates: Array<Scalars["LocalDate"]>;
  includeAllDay?: InputMaybe<Scalars["Boolean"]>;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgEventParentBaseWrapperByWeeksArgs = {
  calendarIds: Array<Scalars["String"]>;
  includeAllDay?: InputMaybe<Scalars["Boolean"]>;
  timeZone: Scalars["String"];
  weekStartDates: Array<Scalars["LocalDate"]>;
};

/** A collection of users with the same email domain. */
export type OrgEventParentBaseWrapperByWeeksObjectArgs = {
  calendarIds: Array<Scalars["String"]>;
  includeAllDay?: InputMaybe<Scalars["Boolean"]>;
  timeZone: Scalars["String"];
  weekStartDates: Array<Scalars["LocalDate"]>;
};

/** A collection of users with the same email domain. */
export type OrgEventParentsByDatesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  calendarIds: Array<Scalars["String"]>;
  dates: Array<Scalars["Date"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgEventParentWrappersByDatesErrorableArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  calendarIds: Array<Scalars["String"]>;
  dates: Array<Scalars["LocalDate"]>;
  first?: InputMaybe<Scalars["Int"]>;
  includeAllDay?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgExternalGroupsArgs = {
  emails: Array<Scalars["String"]>;
};

/** A collection of users with the same email domain. */
export type OrgFeedSuggestionsErrorableArgs = {
  debugFetchDate?: InputMaybe<Scalars["BigInt"]>;
  suggestionRelayIds?: InputMaybe<Scalars["String"]>;
};

/** A collection of users with the same email domain. */
export type OrgFetchHeatmapErrorableArgs = {
  calendarIds: Array<Scalars["String"]>;
  dateRange: DateRangeInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgFlowStatesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgForceFetchEventParentErrorableArgs = {
  calendarId: Scalars["String"];
  externalEventId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgMeetingHoursQueryResultArgs = {
  nonUserCalendarIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  resolveOverrides?: InputMaybe<Scalars["Boolean"]>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

/** A collection of users with the same email domain. */
export type OrgOptimisticSavingsErrorableArgs = {
  calendarId: Scalars["String"];
  week: Scalars["LocalWeek"];
};

/** A collection of users with the same email domain. */
export type OrgOrgFlowStatesArgs = {
  flowKeys: Array<Scalars["String"]>;
};

/** A collection of users with the same email domain. */
export type OrgOrgPersonListPaginatedErrorableArgs = {
  activityFilter?: InputMaybe<ActivityFilter>;
  billingGroupId?: InputMaybe<Scalars["String"]>;
  excludeNonUsers?: InputMaybe<Scalars["Boolean"]>;
  fetchNext?: InputMaybe<Scalars["Boolean"]>;
  freePersonsOnly?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  pageToken?: InputMaybe<Scalars["String"]>;
  primaryBillingGroupOnly?: InputMaybe<Scalars["Boolean"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  sortDirection: SortDirection;
  sortType: SortType;
  teamId?: InputMaybe<Scalars["String"]>;
};

/** A collection of users with the same email domain. */
export type OrgPendingInvitesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgPersonsByCalendarIdsErrorableArgs = {
  calendarIds: Array<InputMaybe<Scalars["String"]>>;
  limit?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgPersonsByUserIdsErrorableArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  userIds: Array<InputMaybe<Scalars["String"]>>;
};

/** A collection of users with the same email domain. */
export type OrgProfileTimeZonesErrorableArgs = {
  calendarIds: Array<InputMaybe<Scalars["String"]>>;
};

/** A collection of users with the same email domain. */
export type OrgPublicChannelsForSlackForTeamArgs = {
  teamId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgReschedulingResponseErrorableArgs = {
  externalEventId: Scalars["String"];
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgRewindHistoryErrorableArgs = {
  calendarId: Scalars["String"];
  week: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgRoomsArgs = {
  roomIds: Array<Scalars["String"]>;
};

/** A collection of users with the same email domain. */
export type OrgSchedulingResponseErrorableArgs = {
  query?: InputMaybe<SchedulingQueryInput>;
};

/** A collection of users with the same email domain. */
export type OrgSettingsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgSlackAccountForTeamErrorableArgs = {
  teamId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgSmartHoldEventInfoArgs = {
  externalEventId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgSsoAdminPortalLinkArgs = {
  bgId: Scalars["String"];
  intent?: InputMaybe<SsoIntent>;
};

/** A collection of users with the same email domain. */
export type OrgSuggestDefragForHighPriorityMeetingArgs = {
  attendees: Array<Scalars["String"]>;
  duration: Scalars["Int"];
  externalEventId?: InputMaybe<Scalars["String"]>;
  slot: DayTimeSlotInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgSuggestedInvitesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgSummarizedWorkingPreferencesArgs = {
  calendarId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgSyncedOriginEventArgs = {
  externalEventId: Scalars["String"];
  startTime: EventTimeInput;
};

/** A collection of users with the same email domain. */
export type OrgTailoredDefragCardSummaryArgs = {
  newerThan?: InputMaybe<Scalars["BigInt"]>;
};

/** A collection of users with the same email domain. */
export type OrgTeamCalendarStatusErrorableArgs = {
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgTeamForTeamIdArgs = {
  teamId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgTeamHealthScoreForCalendarsErrorableArgs = {
  calendarIds: Array<InputMaybe<Scalars["String"]>>;
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgTeamHealthScoreForTeamErrorableArgs = {
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  teamId: Scalars["String"];
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgTeamHealthScoreForTeamWithSubTeamsErrorableArgs = {
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  teamId: Scalars["String"];
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgTeamHealthScoreJustForUserErrorableArgs = {
  rangeMax: DayTimeSlotInput;
  rangeMin: DayTimeSlotInput;
  timeZone: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgTeamSettingsArgs = {
  teamId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgTeamUserSettingsArgs = {
  teamId: Scalars["String"];
};

/** A collection of users with the same email domain. */
export type OrgUserGoalsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgUserMeetingHoursArgs = {
  resolveOverrides?: InputMaybe<Scalars["Boolean"]>;
};

/** A collection of users with the same email domain. */
export type OrgUserSurveyResponseErrorableArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgUserSurveyResponseWrapperErrorableArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgUserWorkingHoursArgs = {
  resolveOverrides?: InputMaybe<Scalars["Boolean"]>;
};

/** A collection of users with the same email domain. */
export type OrgWorkingGroupsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A collection of users with the same email domain. */
export type OrgWorkingHoursQueryResultArgs = {
  nonUserCalendarIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  resolveOverrides?: InputMaybe<Scalars["Boolean"]>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type OrgPersonListErrorable = GraphEntityError | OrgPersonList;

export type OrgPersonList = {
  __typename: "OrgPersonList";
  list: Array<OrgPerson>;
};

export type AsanaAccountErrorable = AsanaAccount | GraphEntityError;

/** Asana Account Details */
export type AsanaAccount = Node & {
  __typename: "AsanaAccount";
  /** boolean describing if the user has Asana oauth credentials stored. */
  hasAsanaCredentials: Scalars["Boolean"];
  /** The ID of an object */
  id: Scalars["ID"];
};

export type AutopilotEventsResponseErrorable = AutopilotEventsResponse | GraphEntityError;

/** A list of autopilot events that are enabled or suggested */
export type AutopilotEventsResponse = {
  __typename: "AutopilotEventsResponse";
  enabledAttending: Array<Maybe<Event>>;
  enabledOrganized: Array<Maybe<Event>>;
  suggestedAttending: Array<Maybe<Event>>;
  suggestedOrganized: Array<Maybe<Event>>;
};

/** An event on a calendar */
export type Event = {
  __typename: "Event";
  /** The annotations for this event */
  annotatedEvent?: Maybe<AnnotatedEvent>;
  /**
   * The annotations for the recurring version of this event
   * @deprecated Use annotatedEvent
   */
  annotatedRecurringEvent?: Maybe<AnnotatedEvent>;
  attendeePeople: PersonListErrorable;
  /** The attendees that are associated with this event */
  attendees: Array<Attendee>;
  /** For autopilot candidates, the status of the current autopilot */
  autopilotEventStatus?: Maybe<AutopilotEventStatusErrorable>;
  /** A list of calendar ids that the event is associated with */
  calendarIds: Array<Scalars["String"]>;
  /** When the event was created, in millis */
  createdMillis?: Maybe<Scalars["BigInt"]>;
  /** Attendee that created the event */
  creator?: Maybe<Attendee>;
  /** A description of the event */
  description?: Maybe<Scalars["String"]>;
  /** Indicates the description has been omitted */
  descriptionOmitted?: Maybe<Scalars["Boolean"]>;
  /** EventTime object representing the end time of the event */
  endTime: EventTime;
  /** Not sure what this is... */
  etag?: Maybe<Scalars["String"]>;
  /** A calendar event's autopilot history */
  eventAutopilotHistory?: Maybe<EventAutopilotHistoryErrorable>;
  /**
   * Contains all flex permutations of the event flexibility string
   * @deprecated Use EventFlexibility.description instead
   */
  eventFlexibilityErrorable: EventFlexibilityNewListErrorable;
  /** The unique event key for this event */
  eventKey: EventKey;
  eventParentBaseId?: Maybe<Scalars["String"]>;
  eventParentBaseTimestamp?: Maybe<Scalars["BigInt"]>;
  /** The id of the event parent that contains this event as a version */
  eventParentRelayId: Scalars["String"];
  /** The feature grid feature states for the organizer of this event */
  featureStatesForOrganizer?: Maybe<FeatureStatesErrorable>;
  /** Indicates that attendees are allowed to invite others */
  guestsCanInviteOthers?: Maybe<Scalars["Boolean"]>;
  /** Indicates that attendees can modify the event */
  guestsCanModify?: Maybe<Scalars["Boolean"]>;
  /** Indicates that attendees can see other attendees */
  guestsCanSeeOtherGuests?: Maybe<Scalars["Boolean"]>;
  /** A Google Hangout link for the event */
  hangoutLink?: Maybe<Scalars["String"]>;
  /** A link associated with the event */
  htmlLink?: Maybe<Scalars["String"]>;
  /** Indicates that this is an all-day event */
  isAllDay?: Maybe<Scalars["Boolean"]>;
  /** Is this a Clockwise generated event (eg. Smart Hold) */
  isClockwiseEvent: Scalars["Boolean"];
  /** The location of the event */
  location?: Maybe<Scalars["String"]>;
  /** Indicates that this event is locked */
  locked?: Maybe<Scalars["Boolean"]>;
  moveRangeInLocalTimeV3: MoveRangeInLocalTimeV3Errorable;
  /** The attendee who organized the event */
  organizer?: Maybe<Attendee>;
  /** Additionally resolve the OrgPerson for the organizer */
  organizerOrgPerson?: Maybe<OrgPersonErrorable>;
  /**
   * Additionally resolve the OrgPerson for the organizer
   * @deprecated Replacing with Organizer Org Person
   */
  organizerPerson?: Maybe<PersonErrorable>;
  /** Whether or not this event is paused */
  paused: Scalars["Boolean"];
  /** Indicates that this is a private copy...? */
  privateCopy?: Maybe<Scalars["Boolean"]>;
  /** The recurrence rules for the event */
  recurrenceRules?: Maybe<RecurrenceRules>;
  /** The recurring id for the event, if it recurs. */
  recurringEventId?: Maybe<Scalars["String"]>;
  scrubbedEvent: Scalars["Boolean"];
  /** EventTime object representing the start time of the event */
  startTime: EventTime;
  suggestedAutopilotSettingsResponseV3: SuggestedAutopilotSettingsResponseV3Errorable;
  /** Description of the event time & recurrence, ignoring flexibility. Null if unable to compute */
  timeDescription?: Maybe<Scalars["String"]>;
  /** The name of the event */
  title?: Maybe<Scalars["String"]>;
  /** Can this time be scheduled over? (None = 0; Opaque = 1; Transparent = 2) */
  transparency?: Maybe<TransparencyEnum>;
  /** When the event was updated, in millis */
  updatedMillis?: Maybe<Scalars["BigInt"]>;
};

/** An event on a calendar */
export type EventAutopilotEventStatusArgs = {
  calendarId?: InputMaybe<Scalars["String"]>;
};

/** An event annotated with user and org tags */
export type AnnotatedEvent = Node & {
  __typename: "AnnotatedEvent";
  externalEventId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The org tags for this event */
  orgTags?: Maybe<Array<OrgTag>>;
  /** The user tags for this event */
  userTags?: Maybe<Array<UserTag>>;
};

/** A per org tag on an event */
export type OrgTag = {
  __typename: "OrgTag";
  /** The TagState for this tag */
  state: TagState;
  /** The tag name */
  tag: Scalars["String"];
};

/** The state of a tag on an event */
export type TagState = {
  __typename: "TagState";
  /** Whether a tag is active or deleted */
  active: Scalars["Boolean"];
  /** Timestamp in millis of last change */
  lastModified: Scalars["Float"];
  /** Type of attendee urn */
  subjectType: SubjectUrnTypeEnum;
  /** Attendee's urn (note this relates to urnType) */
  subjectValue: Scalars["String"];
  /** If a tag has an associated value, it goes here */
  value?: Maybe<Scalars["String"]>;
};

export enum SubjectUrnTypeEnum {
  Email = "Email",
  Integration = "Integration",
  Org = "Org",
  Person = "Person",
  Phone = "Phone",
  Services = "Services",
  Team = "Team",
  User = "User",
}

/** A per user tag on an event */
export type UserTag = {
  __typename: "UserTag";
  /** The aggregate count for this tag */
  count: Scalars["Float"];
  /** The states of this user tag */
  states?: Maybe<Array<TagState>>;
  /** The tag name */
  tag: Scalars["String"];
};

export type PersonListErrorable = GraphEntityError | PersonList;

export type PersonList = {
  __typename: "PersonList";
  list: Array<Person>;
};

/** A person or room attached to a meeting */
export type Attendee = {
  __typename: "Attendee";
  /** What to call the attendee */
  displayName?: Maybe<Scalars["String"]>;
  /** Whether the attendee has been marked as optional for the meeting */
  optional?: Maybe<Scalars["Boolean"]>;
  /** Whether the attendee is the organizer of the meeting */
  organizer?: Maybe<Scalars["Boolean"]>;
  /** The ID of the calendar user's profile */
  profileId?: Maybe<Scalars["String"]>;
  /** Indicates that the attendee is a resource */
  resource?: Maybe<Scalars["Boolean"]>;
  /** Invite response status */
  responseStatus?: Maybe<ResponseStatusEnum>;
  /** Type of attendee urn */
  urnType?: Maybe<UrnTypeEnum>;
  /** Attendee's urn (note this relates to urnType) */
  urnValue: Scalars["String"];
};

export enum ResponseStatusEnum {
  Accepted = "Accepted",
  Declined = "Declined",
  NeedsAction = "NeedsAction",
  NotApplicable = "NotApplicable",
  Tentative = "Tentative",
}

export enum UrnTypeEnum {
  Email = "Email",
  Integration = "Integration",
  Org = "Org",
  Phone = "Phone",
  User = "User",
}

export type AutopilotEventStatusErrorable = AutopilotEventStatus | GraphEntityError;

/** the current status of an autopilot event candidate */
export type AutopilotEventStatus = {
  __typename: "AutopilotEventStatus";
  /** the reason why autopilot cannot move this event */
  status?: Maybe<AutopilotEventStatusEnum>;
};

export enum AutopilotEventStatusEnum {
  CanMove = "CanMove",
  EventExceedsDefragRange = "EventExceedsDefragRange",
  EventOutsideTimeRange = "EventOutsideTimeRange",
  External = "External",
  NoDuration = "NoDuration",
  OverQuota = "OverQuota",
  Paused = "Paused",
  Pinned = "Pinned",
  PrivateEvent = "PrivateEvent",
  SmartHold = "SmartHold",
}

export type EventAutopilotHistoryErrorable = EventAutopilotHistory | GraphEntityError;

/** An event's AP history */
export type EventAutopilotHistory = {
  __typename: "EventAutopilotHistory";
  /** AP history logs including next defrag run info */
  actions: Array<AutopilotHistoryActionLog>;
  /** AP history status: On/Off/Incomplete/Not Visible */
  status: StatusEnum;
};

/** A single action performed on an AP event */
export type AutopilotHistoryActionLog = {
  __typename: "AutopilotHistoryActionLog";
  actionInfo: Array<Scalars["String"]>;
  actionString: Scalars["String"];
  actionType: ActionTypeEnum;
  timestamp: Scalars["BigInt"];
};

export enum ActionTypeEnum {
  AutopilotTurnedOff = "AutopilotTurnedOff",
  AutopilotTurnedOn = "AutopilotTurnedOn",
  ClockwiseCouldNotResolveConflict = "ClockwiseCouldNotResolveConflict",
  ClockwiseMeetingMove = "ClockwiseMeetingMove",
  ClockwiseMovePaused = "ClockwiseMovePaused",
  ClockwiseMoveUnpaused = "ClockwiseMoveUnpaused",
  EventCreated = "EventCreated",
  EventRescheduled = "EventRescheduled",
  NextAutopilotRun = "NextAutopilotRun",
}

export enum StatusEnum {
  AutopilotHistoryIncomplete = "AutopilotHistoryIncomplete",
  AutopilotHistoryNotVisible = "AutopilotHistoryNotVisible",
  AutopilotHistoryOff = "AutopilotHistoryOff",
  AutopilotHistoryOn = "AutopilotHistoryOn",
}

export type EventFlexibilityNewListErrorable = EventFlexibilityNewList | GraphEntityError;

export type EventFlexibilityNewList = {
  __typename: "EventFlexibilityNewList";
  list: Array<EventFlexibilityNew>;
};

/** An event flex and corresponding flex string */
export type EventFlexibilityNew = {
  __typename: "EventFlexibilityNew";
  flex: Scalars["String"];
  flexString: Scalars["String"];
};

/** A query object for fetching events */
export type EventKey = Node & {
  __typename: "EventKey";
  /** The unique event key for an event */
  calendarIds?: Maybe<Array<Scalars["String"]>>;
  /** The non unique event id */
  externalEventId: Scalars["String"];
  /** A hash of all the calendarIds deduped and sorted */
  hashedCalendars?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  orgId?: Maybe<Scalars["String"]>;
};

export type FeatureStatesErrorable = FeatureStates | GraphEntityError;

/** DESCRIBE NEW FIELD HERE */
export type FeatureStates = {
  __typename: "FeatureStates";
  meetingReliefSettingVisibility: MeetingReliefSettingVisibility;
  mixedFreemiumOrgUIState: MixedFreemiumOrgUiState;
  /** @deprecated use the entity within mixedFreemiumOrgUIState */
  quotaAutopilotStatusCallout: QuotaAutopilotStatusCalloutEnumType;
  /** @deprecated use the entity within mixedFreemiumOrgUIState */
  quotaStatusBanner: QuotaStatusBannerEnumType;
};

export enum MeetingReliefSettingVisibility {
  DisabledByPaywall = "DisabledByPaywall",
  HideSetting = "HideSetting",
  ShowWithBadge = "ShowWithBadge",
  ShowWithoutBadge = "ShowWithoutBadge",
}

/** DESCRIBE NEW FIELD HERE */
export type MixedFreemiumOrgUiState = {
  __typename: "MixedFreemiumOrgUiState";
  autopilotPaused: Scalars["Boolean"];
  moveRangesEnabled: Scalars["Boolean"];
  paymentStatusBadge?: Maybe<PaymentStatusBadge>;
  quotaStatusBanner: QuotaStatusBannerEnum;
};

/** DESCRIBE NEW FIELD HERE */
export type PaymentStatusBadge = {
  __typename: "PaymentStatusBadge";
  text: PaymentStatusBadgeTextEnum;
  type: PaymentStatusBadgeTypeEnum;
};

export enum PaymentStatusBadgeTextEnum {
  Business = "Business",
  Enterprise = "Enterprise",
  Free = "Free",
  Pro = "Pro",
}

export enum PaymentStatusBadgeTypeEnum {
  Blue = "Blue",
  Gradient = "Gradient",
}

export enum QuotaStatusBannerEnum {
  ApproachingLimit = "ApproachingLimit",
  NoEnforcement = "NoEnforcement",
  ReachedLimit = "ReachedLimit",
}

export enum QuotaAutopilotStatusCalloutEnumType {
  ApproachingLimit = "ApproachingLimit",
  NoEnforcement = "NoEnforcement",
  ReachedLimit = "ReachedLimit",
}

export enum QuotaStatusBannerEnumType {
  ApproachingLimit = "ApproachingLimit",
  NoEnforcement = "NoEnforcement",
  ReachedLimit = "ReachedLimit",
}

export type MoveRangeInLocalTimeV3Errorable = GraphEntityError | MoveRangeInLocalTimeV3;

/** A move range specified by two day offset time slots */
export type MoveRangeInLocalTimeV3 = {
  __typename: "MoveRangeInLocalTimeV3";
  allowedEndTimeInclusive?: Maybe<DayOffsetTimeSlot>;
  allowedStartTimeInclusive?: Maybe<DayOffsetTimeSlot>;
};

/** DESCRIBE NEW FIELD HERE */
export type DayOffsetTimeSlot = {
  __typename: "DayOffsetTimeSlot";
  dayOffset: Scalars["Int"];
  timeSlot: TimeSlot;
};

export type OrgPersonErrorable = GraphEntityError | OrgPerson;

export type PersonErrorable = GraphEntityError | Person;

/** Full set of rules for how an event recurs */
export type RecurrenceRules = {
  __typename: "RecurrenceRules";
  /** Instances that have been removed from this set of recurrence rules */
  cancelledInstances?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** The start time of the recurrence rules */
  firstInstanceStartTime?: Maybe<EventTime>;
  /** The interval definition for the recurrence */
  interval?: Maybe<IntervalDefinition>;
  /** The timezone of the recurrence rules */
  timeZone: Scalars["String"];
};

/** The definition of the interval on which a recurrence recurs */
export type IntervalDefinition = {
  __typename: "IntervalDefinition";
  /** Which days the recurrence falls on — e.g., “MO,TU,FR” */
  byDay?: Maybe<Scalars["String"]>;
  /** Defines the poisition in the given frequence set that recurs; used for things like the first Monday of every month */
  bySetPos?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  /** How many times it recurs (null here AND for untilTime means it recurs forever) */
  count?: Maybe<Scalars["Int"]>;
  /** The frequency type of the interval */
  freqType: IntervalDefinitionFreqTypeEnum;
  /** The pacing of the interval — e.g., a bi-weekly interval is 2 */
  interval: Scalars["Int"];
  /** When the recurrence terminates (null here AND for count means it recurs forever) */
  untilTime?: Maybe<EventTime>;
};

export enum IntervalDefinitionFreqTypeEnum {
  Daily = "Daily",
  Monthly = "Monthly",
  Weekly = "Weekly",
  Yearly = "Yearly",
}

export type SuggestedAutopilotSettingsResponseV3Errorable =
  | GraphEntityError
  | SuggestedAutopilotSettingsResponseV3;

/** DESCRIBE NEW FIELD HERE */
export type SuggestedAutopilotSettingsResponseV3 = {
  __typename: "SuggestedAutopilotSettingsResponseV3";
  calendarIdToMeetingHours: Array<SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours>;
  intersectionOfAttendeesMeetingHours?: Maybe<DayOffsetTimeSlotRange>;
  suggestedAutopilotSettings: SuggestedAutopilotSettingsV3;
};

export type SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours = {
  __typename: "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours";
  calendarId: Scalars["String"];
  dayOffsetTimeSlotRanges: Array<DayOffsetTimeSlotRange>;
};

/** A range between two day offset time slots */
export type DayOffsetTimeSlotRange = {
  __typename: "DayOffsetTimeSlotRange";
  maxSlot: DayOffsetTimeSlot;
  minSlot: DayOffsetTimeSlot;
};

/** DESCRIBE NEW FIELD HERE */
export type SuggestedAutopilotSettingsV3 = {
  __typename: "SuggestedAutopilotSettingsV3";
  allowedEndTime?: Maybe<DayOffsetTimeSlot>;
  allowedStartTime?: Maybe<DayOffsetTimeSlot>;
  isRoomFlexible: Scalars["Boolean"];
  movementType: SuggestedAutopilotSettingsV3MovementType;
};

export enum SuggestedAutopilotSettingsV3MovementType {
  Day = "Day",
  Week = "Week",
}

export enum TransparencyEnum {
  None = "None",
  Opaque = "Opaque",
  Transparent = "Transparent",
}

export type AutopilotOnboardingSuggestionsResponseErrorable =
  | AutopilotOnboardingSuggestionsResponse
  | GraphEntityError;

/** Represents a set of suggestion events to put on autopilot */
export type AutopilotOnboardingSuggestionsResponse = {
  __typename: "AutopilotOnboardingSuggestionsResponse";
  flexible: Array<Maybe<Event>>;
  notFlexible: Array<Maybe<Event>>;
  veryFlexible: Array<Maybe<Event>>;
};

export type BillingGroupErrorable = BillingGroup | GraphEntityError;

/** Represents a billing group */
export type BillingGroup = {
  __typename: "BillingGroup";
  adminOrgPersons: OrgPersonListErrorable;
  createdAtMillis: Scalars["BigInt"];
  dsyncConfigured?: Maybe<DsyncConfiguredErrorable>;
  id: Scalars["String"];
  invitePolicy: InvitePolicyEnum;
  isAutoSyncEnabled?: Maybe<Scalars["Boolean"]>;
  manualMembers: BillingGroupManualMemberListErrorable;
  name: Scalars["String"];
  personListPaginatedErrorable?: Maybe<OrgPersonListPaginatedErrorable>;
  /** A link, which expires in 5 minutes, that can be used to configure sso for a billing group. */
  ssoAdminPortalLink?: Maybe<SsoAdminPortalLinkErrorable>;
  stripeCustomerPortalSession?: Maybe<StripeCustomerPortalSessionErrorable>;
  subscription: SubscriptionDetailsErrorable;
  syncSources: Array<Urn>;
  type?: Maybe<BillingGroupTypeEnum>;
};

/** Represents a billing group */
export type BillingGroupSsoAdminPortalLinkArgs = {
  intent?: InputMaybe<SsoIntentInput>;
};

export type DsyncConfiguredErrorable = DsyncConfigured | GraphEntityError;

/** Given a billing group, is SSO Dsync configured */
export type DsyncConfigured = {
  __typename: "DsyncConfigured";
  isDsyncConfigured: Scalars["Boolean"];
};

export enum InvitePolicyEnum {
  AdminOnly = "AdminOnly",
  AnyMember = "AnyMember",
}

export type BillingGroupManualMemberListErrorable = BillingGroupManualMemberList | GraphEntityError;

export type BillingGroupManualMemberList = {
  __typename: "BillingGroupManualMemberList";
  list: Array<BillingGroupManualMember>;
};

/** Represents a manual member of a billing group */
export type BillingGroupManualMember = {
  __typename: "BillingGroupManualMember";
  calendarId: Scalars["String"];
  externalUserId: Scalars["String"];
  /** The associated person */
  orgPerson?: Maybe<OrgPersonErrorable>;
  personId?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
};

export type OrgPersonListPaginatedErrorable = GraphEntityError | OrgPersonListPaginated;

/** List of org persons along with a nexPersonId and previousPersonId for pagination. */
export type OrgPersonListPaginated = {
  __typename: "OrgPersonListPaginated";
  count?: Maybe<Scalars["Int"]>;
  inputQuery?: Maybe<Scalars["String"]>;
  nextPersonId?: Maybe<Scalars["String"]>;
  persons?: Maybe<Array<OrgPerson>>;
  previousPersonId?: Maybe<Scalars["String"]>;
  searchPersons?: Maybe<Array<SearchPerson>>;
};

/** A wrapper around org person for the admin panel members tab */
export type SearchPerson = {
  __typename: "SearchPerson";
  person: OrgPerson;
  status: SearchPersonStatusResponse;
};

export enum SearchPersonStatusResponse {
  Deactivated = "Deactivated",
  Invited = "Invited",
  NonUser = "NonUser",
  User = "User",
}

export enum SsoIntentInput {
  Dsync = "Dsync",
  Sso = "Sso",
}

export type SsoAdminPortalLinkErrorable = GraphEntityError | SsoAdminPortalLink;

/** Generated link to WorkOS admin portal */
export type SsoAdminPortalLink = {
  __typename: "SsoAdminPortalLink";
  link: Scalars["String"];
};

export type StripeCustomerPortalSessionErrorable = GraphEntityError | StripeCustomerPortalSession;

/** Generated stripe customer portal session for a given subscription */
export type StripeCustomerPortalSession = {
  __typename: "StripeCustomerPortalSession";
  account?: Maybe<AccountStripe>;
  sessionUrl?: Maybe<Scalars["String"]>;
};

/** DESCRIBE NEW FIELD HERE */
export type AccountStripe = {
  __typename: "AccountStripe";
  accountId: Scalars["String"];
  stripeCustomerId: Scalars["String"];
};

export type SubscriptionDetailsErrorable = GraphEntityError | SubscriptionDetails;

/** DESCRIBE NEW FIELD HERE */
export type SubscriptionDetails = {
  __typename: "SubscriptionDetails";
  subscription: PaymentSubscription;
};

export enum BillingGroupTypeEnum {
  Manual = "Manual",
  Sso = "SSO",
}

export type BillingGroupListErrorable = BillingGroupList | GraphEntityError;

export type BillingGroupList = {
  __typename: "BillingGroupList";
  list: Array<BillingGroup>;
};

export type SmartHoldCalculationResultErrorable = GraphEntityError | SmartHoldCalculationResult;

/** Calculates smart hold slots without reserving them on the calendar */
export type SmartHoldCalculationResult = {
  __typename: "SmartHoldCalculationResult";
  events: Array<Event>;
  smartHolds: Array<Event>;
};

export type CalendarStatusErrorable = CalendarStatus | GraphEntityError;

/** Current Calendar Status */
export type CalendarStatus = Node & {
  __typename: "CalendarStatus";
  calendarId: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  moonPhase?: Maybe<MoonPhase>;
  status?: Maybe<CalendarStatusResponse>;
};

export enum MoonPhase {
  FirstQuarterMoon = "FirstQuarterMoon",
  FullMoon = "FullMoon",
  LastQuarterMoon = "LastQuarterMoon",
  NewMoon = "NewMoon",
  WaningCrescentMoon = "WaningCrescentMoon",
  WaningGibbousMoon = "WaningGibbousMoon",
  WaxingCrescentMoon = "WaxingCrescentMoon",
  WaxingGibbousMoon = "WaxingGibbousMoon",
}

export enum CalendarStatusResponse {
  AfterHours = "AfterHours",
  BeforeWorkingHours = "BeforeWorkingHours",
  DayOff = "DayOff",
  FocusTime = "FocusTime",
  Holiday = "Holiday",
  Lunch = "Lunch",
  Meeting = "Meeting",
  Other = "Other",
  OutOfOffice = "OutOfOffice",
  Weekend = "Weekend",
  WorkingHours = "WorkingHours",
}

/** Calendar stats for a teammate */
export type CalendarTimeStats = {
  __typename: "CalendarTimeStats";
  busyMinutes?: Maybe<Scalars["Int"]>;
  calendarId?: Maybe<Scalars["String"]>;
  focusMinutes?: Maybe<Scalars["Int"]>;
  fragmentedMinutes?: Maybe<Scalars["Int"]>;
  scoresByDate: Array<CalendarFocusTimeScore>;
  scoresByDay?: Maybe<Array<Maybe<CalendarFocusTimeScore>>>;
  totalMinutes?: Maybe<Scalars["Int"]>;
  unclassifiedMinutes?: Maybe<Scalars["Int"]>;
};

/** Health Score for a given calendarId */
export type CalendarFocusTimeScore = {
  __typename: "CalendarFocusTimeScore";
  busyMinutes?: Maybe<Scalars["Int"]>;
  calendarId?: Maybe<Scalars["String"]>;
  categoryAdHoc?: Maybe<Scalars["Int"]>;
  categoryExternal?: Maybe<Scalars["Int"]>;
  categoryFocusTime?: Maybe<Scalars["Int"]>;
  categoryIndividualHold?: Maybe<Scalars["Int"]>;
  categoryOneOnOne?: Maybe<Scalars["Int"]>;
  categoryOther?: Maybe<Scalars["Int"]>;
  categoryOutOfOffice?: Maybe<Scalars["Int"]>;
  categoryPaceSetting?: Maybe<Scalars["Int"]>;
  categoryRecruiting?: Maybe<Scalars["Int"]>;
  crawledStatus: CrawledStatus;
  focusMinutes?: Maybe<Scalars["Int"]>;
  fragmentedMinutes?: Maybe<Scalars["Int"]>;
  secondaryKey?: Maybe<Scalars["String"]>;
  totalMinutes?: Maybe<Scalars["Int"]>;
};

export enum CrawledStatus {
  NoAccess = "NoAccess",
  None = "None",
  Pending = "Pending",
  Stale = "Stale",
  Synced = "Synced",
  VeryStale = "VeryStale",
}

export type CalendarTimeStatsListErrorable = CalendarTimeStatsList | GraphEntityError;

export type CalendarTimeStatsList = {
  __typename: "CalendarTimeStatsList";
  list: Array<CalendarTimeStats>;
};

export type CanScheduleResponseListErrorable = CanScheduleResponseList | GraphEntityError;

export type CanScheduleResponseList = {
  __typename: "CanScheduleResponseList";
  list: Array<CanScheduleResponse>;
};

/** An object representing whether a user can reschedule or enable autopilot */
export type CanScheduleResponse = {
  __typename: "CanScheduleResponse";
  attendeeNotInDomain: Scalars["Boolean"];
  canAutopilot: Scalars["Boolean"];
  canReschedule: Scalars["Boolean"];
  externalEventId: Scalars["String"];
  isAllDayEvent: Scalars["Boolean"];
  organizerNotClockwiseUser: Scalars["Boolean"];
};

/** A list of teammates that you work with the most */
export type CollaboratorStats = {
  __typename: "CollaboratorStats";
  calendarId?: Maybe<Scalars["String"]>;
  topCollaborators?: Maybe<Array<Maybe<CollaboratorScore>>>;
};

/** A teammates shared minutes */
export type CollaboratorScore = {
  __typename: "CollaboratorScore";
  calendarId?: Maybe<Scalars["String"]>;
  sharedMinutes?: Maybe<Scalars["Int"]>;
};

export type CollaboratorStatsErrorable = CollaboratorStats | GraphEntityError;

export type CurrentScheduledSlotImpactErrorable = CurrentScheduledSlotImpact | GraphEntityError;

/** Current Scheduled Slot Impact */
export type CurrentScheduledSlotImpact = {
  __typename: "CurrentScheduledSlotImpact";
  /** The current slot associated to the event */
  currentSlot?: Maybe<SchedulingSlot>;
  /** The calendar Ids that have not been crawled yet */
  uncrawledCalendars: Array<Maybe<Scalars["String"]>>;
};

/** Scheduling Slot */
export type SchedulingSlot = {
  __typename: "SchedulingSlot";
  attendanceImpacts: Array<SchedulingAttendanceImpact>;
  gapSlot: GapSlot;
  roomImpacts: Array<SchedulingRoomImpact>;
  summary: SchedulingAttendanceSummary;
  timeRange?: Maybe<TimeRange>;
};

/** Scheduling Attendance Impact */
export type SchedulingAttendanceImpact = {
  __typename: "SchedulingAttendanceImpact";
  calendarId: Scalars["String"];
  conflictingMeetings: Array<Scalars["String"]>;
  focusTimeMinutesCost: Scalars["Int"];
  hasConflict: Scalars["Boolean"];
  inconveniences: Array<Inconveniences>;
  unavailabilities: Array<Unavailabilities>;
};

export enum Inconveniences {
  External = "External",
  MissedLunch = "MissedLunch",
  NoMeetingRelief = "NoMeetingRelief",
  OnNoMeetingDay = "OnNoMeetingDay",
  Other = "Other",
  OutsideMeetingHours = "OutsideMeetingHours",
  OutsideWorkingHours = "OutsideWorkingHours",
  Uncrawled = "Uncrawled",
}

export enum Unavailabilities {
  FarOutsideWorkingHours = "FarOutsideWorkingHours",
}

/** Gap Slot */
export type GapSlot = {
  __typename: "GapSlot";
  dayTimeSlot: DayTimeSlot;
  numSlots: Scalars["Int"];
};

/** A 30 minute interval on a given day */
export type DayTimeSlot = {
  __typename: "DayTimeSlot";
  /** The date represented as a string */
  date: Scalars["String"];
  /** An enum representing a 30 minute time slot */
  timeSlot: TimeSlot;
};

/** Scheduling Room Impact */
export type SchedulingRoomImpact = {
  __typename: "SchedulingRoomImpact";
  available: Scalars["Boolean"];
  roomId: Scalars["String"];
  tooLarge: Scalars["Boolean"];
  tooSmall: Scalars["Boolean"];
};

/** Scheduling Attendance Summary */
export type SchedulingAttendanceSummary = {
  __typename: "SchedulingAttendanceSummary";
  availableRooms: Array<Scalars["String"]>;
  conflictingAttendees: Array<Scalars["String"]>;
  focusTimeMinutesCost: Scalars["Int"];
  freeAttendees: Array<Scalars["String"]>;
  inconvenientForAttendees: Array<Scalars["String"]>;
  tags?: Maybe<Array<Maybe<SchedulingAttendanceSummaryTag>>>;
  unavailableAttendees: Array<Scalars["String"]>;
};

export enum SchedulingAttendanceSummaryTag {
  Best = "Best",
  Conflict = "Conflict",
  Current = "Current",
  Good = "Good",
  Inconvenient = "Inconvenient",
  InFocusTime = "InFocusTime",
  MostFocus = "MostFocus",
  OverLunch = "OverLunch",
  Soonest = "Soonest",
}

/** A time range */
export type TimeRange = Node & {
  __typename: "TimeRange";
  /** The end time in the range */
  endTime?: Maybe<EventTime>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The start time in the range */
  startTime?: Maybe<EventTime>;
};

/** For a given org, which crawl states calendar Ids fall into */
export type CrawledCalendarInfo = Node & {
  __typename: "CrawledCalendarInfo";
  /** The ID of an object */
  id: Scalars["ID"];
  /** Calendar Ids that have crawl status of 'None' */
  none?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Calendar Ids that have crawl status of 'Pending' */
  pending?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Calendar Ids that have crawl status of 'Stale' */
  stale?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Calendar Ids that have crawl status of 'Synced' */
  synced?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export enum OrgCrawlTest {
  GoogleApiAccessDisabled = "GoogleApiAccessDisabled",
  GoogleContactSharingDisabled = "GoogleContactSharingDisabled",
  NoCrawl = "NoCrawl",
  NoExternalOrganization = "NoExternalOrganization",
  ShouldCrawl = "ShouldCrawl",
  Skipped = "Skipped",
  StartedCrawl = "StartedCrawl",
}

export type EventColoringSettingsErrorable = EventColoringSettings | GraphEntityError;

/** A User's settings for how their events should be colored */
export type EventColoringSettings = Node & {
  __typename: "EventColoringSettings";
  /** A user's collection of event-category coloring preferences */
  eventCategoryColorings?: Maybe<Array<EventCategoryColoring>>;
  /** The ID of an object */
  id: Scalars["ID"];
};

/** Color settings for a given event category */
export type EventCategoryColoring = {
  __typename: "EventCategoryColoring";
  active: Scalars["Boolean"];
  eventCategory: Scalars["String"];
  googleColorKey?: Maybe<Scalars["String"]>;
  isUserSet: Scalars["Boolean"];
};

export type EventErrorable = Event | GraphEntityError;

export type EventParentBaseWrapperErrorable = EventParentBaseWrapper | GraphEntityError;

/** Event parents and event parent bases for those event parents */
export type EventParentBaseWrapper = {
  __typename: "EventParentBaseWrapper";
  eventParentBases: Array<EventParentBase>;
  eventParents: Array<EventParent>;
};

/** A record indicating which version of an event is current */
export type EventParentBase = Node & {
  __typename: "EventParentBase";
  /** The ID of an object */
  id: Scalars["ID"];
  /** Ignore all event parents with a eventParentBaseTimestamp less than this */
  timestamp: Scalars["BigInt"];
};

/** An object that holds all event versions for a given externalEventId */
export type EventParent = Node & {
  __typename: "EventParent";
  /** All calendarIds found on any version of this event */
  calendarIds: Array<Scalars["String"]>;
  eventParentBaseId?: Maybe<Scalars["String"]>;
  eventParentBaseTimestamp?: Maybe<Scalars["BigInt"]>;
  /**
   * The services parentEventId shared by event parents referring to the same recurrence
   * @deprecated EventParentWrapper shouldn't be used
   */
  eventParentWrapperId: Scalars["String"];
  /** All active versions of an event for an externalEventId */
  events: Array<Event>;
  /** The externalEventId shared by all versions, used in the id as well */
  externalEventId: Scalars["String"];
  /** All calendarIds used to fetch this EventParent.  An empty array represents all calendarIds in a working group */
  fetchedWithCalendarIds?: Maybe<Array<Scalars["String"]>>;
  /** Event flexibility, if this event is flexible */
  flexibility?: Maybe<EventFlexibilityErrorable>;
  /** Constraints around setting flexibility, for the given event */
  flexibilityConstraints: FlexibilityConstraintsErrorable;
  /** The ID of an object */
  id: Scalars["ID"];
  /** For personal calendar synced events, the actual event from the personal calendar */
  syncedOriginEventErrorable?: Maybe<EventErrorable>;
};

/** An object that holds all event versions for a given externalEventId */
export type EventParentFlexibilityArgs = {
  calendarId: Scalars["CalendarId"];
};

/** An object that holds all event versions for a given externalEventId */
export type EventParentFlexibilityConstraintsArgs = {
  calendarId: Scalars["CalendarId"];
};

/** An object that holds all event versions for a given externalEventId */
export type EventParentSyncedOriginEventErrorableArgs = {
  calendarId?: InputMaybe<Scalars["String"]>;
};

export type EventFlexibilityErrorable = EventFlexibility | GraphEntityError;

/** Flexibility for a given event */
export type EventFlexibility = {
  __typename: "EventFlexibility";
  /** String describing the events flexibility. Null if unable to fetch */
  description?: Maybe<Scalars["String"]>;
  /** Whether the event can change rooms, null if the event has no room */
  isRoomFlexible?: Maybe<Scalars["Boolean"]>;
  /** How an event can move within a day, null if not configured */
  timeOfDayFlexibility?: Maybe<TimeOfDayFlexibility>;
  /** How an event can move between days */
  timeRangeFlexibility: TimeRangeFlexibility;
};

export type TimeOfDayFlexibility = {
  __typename: "TimeOfDayFlexibility";
  /** End of allowed time range for moving an event, null if not configured */
  end?: Maybe<Scalars["LocalTime"]>;
  /** Beginning of allowed time range for moving an event, null if not configured */
  start?: Maybe<Scalars["LocalTime"]>;
};

export type TimeRangeFlexibility = DayOfWeekFlexibility | RangeFlexibility;

export type DayOfWeekFlexibility = {
  __typename: "DayOfWeekFlexibility";
  allowedDays: Array<DayOfWeek>;
};

export enum DayOfWeek {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export type RangeFlexibility = {
  __typename: "RangeFlexibility";
  range: FlexibilityRange;
};

export enum FlexibilityRange {
  /** The event can only move within its currently scheduled day */
  Day = "Day",
  /** The event can move anywhere within its currently scheduled week */
  Week = "Week",
}

export type FlexibilityConstraintsErrorable = FlexibilityConstraints | GraphEntityError;

/** Constraints for modifying event flexibilty */
export type FlexibilityConstraints = {
  __typename: "FlexibilityConstraints";
  /** Whether the user is allowed to modify the flexibility settings for this event. Null if unable to compute */
  allowedToModify?: Maybe<Scalars["Boolean"]>;
  /**
   *               Days of the week that are available for all attendees of an
   * event; the intersection of working days for attendees.
   *               Null if unable to compute.
   */
  availableMeetingDays?: Maybe<Array<DayOfWeek>>;
  /** The intersection of meeting hours, on the day the event is currently scheduled. Null if there are no available hours */
  availableMeetingHours?: Maybe<AvailableMeetingHours>;
  /** Whether day of week flexibility is allowed by the user's plan */
  dayOfWeekFlexibilityAllowedByPlan?: Maybe<Scalars["Boolean"]>;
  /** Whether this event is eligible for day of week flexibility. Null if unable to compute */
  dayOfWeekFlexibilityEligible?: Maybe<Scalars["Boolean"]>;
  /** Whether this event is external, and is ineligible for flexibility. Null if unable to compute */
  externalEvent?: Maybe<Scalars["Boolean"]>;
  /** Whether time of day flexibility is allowed by the user's plan. Null if unable to compute */
  timeOfDayAllowedByPlan?: Maybe<Scalars["Boolean"]>;
};

/** Start and end of hours that are available to meet, in the querying user's time zone */
export type AvailableMeetingHours = {
  __typename: "AvailableMeetingHours";
  end: Scalars["LocalTime"];
  start: Scalars["LocalTime"];
};

export type EventParentBaseWrapperByWeekListErrorable =
  | EventParentBaseWrapperByWeekList
  | GraphEntityError;

export type EventParentBaseWrapperByWeekList = {
  __typename: "EventParentBaseWrapperByWeekList";
  list: Array<EventParentBaseWrapperByWeek>;
};

/** Event parent bases and parents grouped by day */
export type EventParentBaseWrapperByWeek = {
  __typename: "EventParentBaseWrapperByWeek";
  eventParentBases: Array<EventParentBase>;
  eventParentsByDay: Array<Array<EventParent>>;
};

export type EventParentBaseWrapperByWeekObjectListErrorable =
  | EventParentBaseWrapperByWeekObjectList
  | GraphEntityError;

export type EventParentBaseWrapperByWeekObjectList = {
  __typename: "EventParentBaseWrapperByWeekObjectList";
  list: Array<EventParentBaseWrapperByWeekObject>;
};

/** Event parent bases and parents grouped by day */
export type EventParentBaseWrapperByWeekObject = {
  __typename: "EventParentBaseWrapperByWeekObject";
  eventParentBases: Array<EventParentBase>;
  eventParentsByDay: Array<EventParentsForDay>;
};

export type EventParentsForDay = {
  __typename: "EventParentsForDay";
  eventParents?: Maybe<Array<EventParent>>;
};

/** A connection to a list of items. */
export type EventParentConnection = {
  __typename: "EventParentConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventParentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventParentEdge = {
  __typename: "EventParentEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<EventParent>;
};

export type EventParentWrapperConnectionErrorable = EventParentWrapperConnection | GraphEntityError;

/** A connection to a list of items. */
export type EventParentWrapperConnection = {
  __typename: "EventParentWrapperConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventParentWrapperEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventParentWrapperEdge = {
  __typename: "EventParentWrapperEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<EventParentWrapper>;
};

/** A top level entity that encompasses a group of evereturn eventParents */
export type EventParentWrapper = Node & {
  __typename: "EventParentWrapper";
  deleted: Scalars["Boolean"];
  eventParents: Array<EventParent>;
  /** The ID of an object */
  id: Scalars["ID"];
};

export type ExternalGroupListErrorable = ExternalGroupList | GraphEntityError;

export type ExternalGroupList = {
  __typename: "ExternalGroupList";
  list: Array<ExternalGroup>;
};

/** A group of people defined in an external system */
export type ExternalGroup = Node & {
  __typename: "ExternalGroup";
  email: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  memberEmails: Array<Scalars["String"]>;
  members: PersonListErrorable;
};

export type FeatureGridErrorable = FeatureGrid | GraphEntityError;

/** DESCRIBE NEW FIELD HERE */
export type FeatureGrid = {
  __typename: "FeatureGrid";
  featureStates: FeatureStates;
  stateMetadata: PaymentStateMetadata;
};

/** DESCRIBE NEW FIELD HERE */
export type PaymentStateMetadata = {
  __typename: "PaymentStateMetadata";
  primaryBillingGroupMetadata?: Maybe<PrimaryBillingGroupMetadata>;
  userMetadata?: Maybe<UserMetadata>;
};

/** Primary billing group metadata field */
export type PrimaryBillingGroupMetadata = {
  __typename: "PrimaryBillingGroupMetadata";
  billingGroup: BillingGroup;
  subscription: PaymentSubscription;
};

/** User metadata */
export type UserMetadata = {
  __typename: "UserMetadata";
  person: OrgPerson;
  trialMetadata?: Maybe<TrialMetadata>;
};

/** Trial metadata */
export type TrialMetadata = {
  __typename: "TrialMetadata";
  timeZone: Scalars["String"];
  trialEndDate: Scalars["String"];
};

export type FeedSuggestionResultsErrorable = FeedSuggestionResults | GraphEntityError;

/** A list of feed suggestions for this user/org */
export type FeedSuggestionResults = {
  __typename: "FeedSuggestionResults";
  suggestions?: Maybe<Array<Maybe<FeedSuggestion>>>;
};

/** A suggestion in the feed */
export type FeedSuggestion = Node & {
  __typename: "FeedSuggestion";
  expiresMillis?: Maybe<Scalars["BigInt"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  occurredMillis?: Maybe<Scalars["BigInt"]>;
  primaryAction?: Maybe<SuggestionActionResult>;
  suggestionId?: Maybe<Scalars["String"]>;
  suggestionPayload?: Maybe<SuggestionResultPayload>;
  suggestionType?: Maybe<SuggestionType>;
  text?: Maybe<FeedSuggestionText>;
};

/** Suggestion Action Result */
export type SuggestionActionResult = {
  __typename: "SuggestionActionResult";
  display?: Maybe<Scalars["String"]>;
  isPrimary?: Maybe<Scalars["Boolean"]>;
  payload?: Maybe<SuggestionActionPayload>;
  type?: Maybe<SuggestionActionResultType>;
};

export type SuggestionActionPayload =
  | SuggestionActionAutopilotPayload
  | SuggestionActionConfigureSettingsPayload
  | SuggestionActionDeclinePayload
  | SuggestionActionFyiPayload
  | SuggestionActionInvitePayload
  | SuggestionActionRemoveAttendeePayload
  | SuggestionActionRequestToMovePayload
  | SuggestionActionReschedulePayload
  | SuggestionActionViewMeetingPayload
  | SuggestionActionViewProfilePayload
  | SuggestionActionViewTeamDashboardPayload;

/** Suggestion Action Autopilot Payload */
export type SuggestionActionAutopilotPayload = {
  __typename: "SuggestionActionAutopilotPayload";
  calendarId?: Maybe<Scalars["String"]>;
  externalEventId?: Maybe<Scalars["String"]>;
  hasRoom?: Maybe<Scalars["Boolean"]>;
};

/** Payload for suggestions that require the user to configure a setting */
export type SuggestionActionConfigureSettingsPayload = {
  __typename: "SuggestionActionConfigureSettingsPayload";
  configureSettingsType?: Maybe<ConfigureSettingsType>;
};

export enum ConfigureSettingsType {
  MeetingColors = "MeetingColors",
  PersonalCalendarSync = "PersonalCalendarSync",
  SettingUpTeam = "SettingUpTeam",
  SettingUpWorkingHours = "SettingUpWorkingHours",
  ShadowCalendar = "ShadowCalendar",
  SlackStatusSync = "SlackStatusSync",
  TravelTime = "TravelTime",
}

/** Suggestion Action Decline Payload */
export type SuggestionActionDeclinePayload = {
  __typename: "SuggestionActionDeclinePayload";
  nop?: Maybe<Scalars["String"]>;
};

/** Suggestion Action FYI Payload */
export type SuggestionActionFyiPayload = {
  __typename: "SuggestionActionFyiPayload";
  nop?: Maybe<Scalars["String"]>;
};

/** Suggestion Action Invite Payload */
export type SuggestionActionInvitePayload = {
  __typename: "SuggestionActionInvitePayload";
  calendarId?: Maybe<Scalars["String"]>;
};

/** Suggestion Action Remove Attendee Payload */
export type SuggestionActionRemoveAttendeePayload = {
  __typename: "SuggestionActionRemoveAttendeePayload";
  nop?: Maybe<Scalars["String"]>;
};

/** Suggestion Action Request To Move Payload */
export type SuggestionActionRequestToMovePayload = {
  __typename: "SuggestionActionRequestToMovePayload";
  betterTime?: Maybe<DayTimeSlot>;
  nearestAlternateTime?: Maybe<DayTimeSlot>;
};

/** Suggestion Action Reschedule Payload */
export type SuggestionActionReschedulePayload = {
  __typename: "SuggestionActionReschedulePayload";
  betterTime?: Maybe<DayTimeSlot>;
  calendarId?: Maybe<Scalars["String"]>;
  event?: Maybe<Event>;
  eventStartWeek?: Maybe<Scalars["String"]>;
  externalEventId?: Maybe<Scalars["String"]>;
  nearestAlternateTime?: Maybe<DayTimeSlot>;
};

/** Suggestion Action View Meeting Payload */
export type SuggestionActionViewMeetingPayload = {
  __typename: "SuggestionActionViewMeetingPayload";
  calendarId?: Maybe<Scalars["String"]>;
  externalEventId?: Maybe<Scalars["String"]>;
};

/** Suggestion Action View Profile Payload */
export type SuggestionActionViewProfilePayload = {
  __typename: "SuggestionActionViewProfilePayload";
  calendarId?: Maybe<Scalars["String"]>;
  viewWeek?: Maybe<Scalars["String"]>;
};

/** Payload (currently empty) for the action to view the team dashboard */
export type SuggestionActionViewTeamDashboardPayload = {
  __typename: "SuggestionActionViewTeamDashboardPayload";
  nop?: Maybe<Scalars["String"]>;
};

export enum SuggestionActionResultType {
  Autopilot = "Autopilot",
  ConfigureSettings = "ConfigureSettings",
  Decline = "Decline",
  Fyi = "Fyi",
  Invite = "Invite",
  RemoveAttendee = "RemoveAttendee",
  RequestToMove = "RequestToMove",
  Reschedule = "Reschedule",
  ViewMeeting = "ViewMeeting",
  ViewProfile = "ViewProfile",
  ViewTeamDashboard = "ViewTeamDashboard",
}

export type SuggestionResultPayload =
  | SuggestionResultAutopilotAttendeePayload
  | SuggestionResultChromeExtensionTipPayload
  | SuggestionResultConflictingMeetingPayload
  | SuggestionResultExpensiveMeetingPayload
  | SuggestionResultExpensiveOrganizerPayload
  | SuggestionResultLowFocusTimePayload
  | SuggestionResultMeetingNotOnAutopilotPayload
  | SuggestionResultMissingAttendancePayload
  | SuggestionResultMissingUserConfigurationPayload
  | SuggestionResultRecurringOneOnOneOrganizerPayload
  | SuggestionResultRunningOutOfFocusTimePayload
  | SuggestionResultShellPayload
  | SuggestionResultTeammateOutOfOfficePayload
  | SuggestionResultWeekInReviewPayload
  | SuggestionResultWeeklyAutopilotSummaryPayload;

/** Payload for an attendee on an autopiloted meeting */
export type SuggestionResultAutopilotAttendeePayload = {
  __typename: "SuggestionResultAutopilotAttendeePayload";
  attendee: Scalars["String"];
};

/** Suggestion Result Chrome Extension Tip Payload */
export type SuggestionResultChromeExtensionTipPayload = {
  __typename: "SuggestionResultChromeExtensionTipPayload";
  tipType?: Maybe<TipType>;
};

export enum TipType {
  CheckOutProfile = "CheckOutProfile",
  CheckOutRescheduler = "CheckOutRescheduler",
  CheckOutTeamDashboard = "CheckOutTeamDashboard",
  FeedWelcome = "FeedWelcome",
}

/** Suggestion Result Conflicting Meeting Payload */
export type SuggestionResultConflictingMeetingPayload = {
  __typename: "SuggestionResultConflictingMeetingPayload";
  conflictingEvent?: Maybe<Event>;
  targetEvent?: Maybe<Event>;
};

/** Suggestion Result Expensive Meeting Payload */
export type SuggestionResultExpensiveMeetingPayload = {
  __typename: "SuggestionResultExpensiveMeetingPayload";
  focusMinutesCost?: Maybe<Scalars["Int"]>;
  targetEvent?: Maybe<Event>;
};

/** Suggestion Result Expensive Organizer Payload */
export type SuggestionResultExpensiveOrganizerPayload = {
  __typename: "SuggestionResultExpensiveOrganizerPayload";
  approximateMonthlyFocusHoursCost?: Maybe<Scalars["Int"]>;
  calendarId?: Maybe<Scalars["String"]>;
};

/** Suggestion Result Low Focus Time Payload */
export type SuggestionResultLowFocusTimePayload = {
  __typename: "SuggestionResultLowFocusTimePayload";
  calendarId?: Maybe<Scalars["String"]>;
  totalFocusTimeMinutes?: Maybe<Scalars["Int"]>;
  totalMinutes?: Maybe<Scalars["Int"]>;
  week?: Maybe<Scalars["String"]>;
};

/** Suggestion Result Meetinging Not On Autopilot Payload */
export type SuggestionResultMeetingNotOnAutopilotPayload = {
  __typename: "SuggestionResultMeetingNotOnAutopilotPayload";
  targetEvent?: Maybe<Event>;
};

/** Suggestion Result Missing Attendance Payload */
export type SuggestionResultMissingAttendancePayload = {
  __typename: "SuggestionResultMissingAttendancePayload";
  targetEvent?: Maybe<Event>;
};

/** Suggestion Result Missing User Configuration Payload */
export type SuggestionResultMissingUserConfigurationPayload = {
  __typename: "SuggestionResultMissingUserConfigurationPayload";
  configurationType?: Maybe<ConfigurationType>;
};

export enum ConfigurationType {
  MeetingColors = "MeetingColors",
  PersonalCalendarSync = "PersonalCalendarSync",
  SettingUpTeam = "SettingUpTeam",
  SettingUpWorkingHours = "SettingUpWorkingHours",
  ShadowCalendar = "ShadowCalendar",
  SlackStatusSync = "SlackStatusSync",
  TravelTime = "TravelTime",
}

/** Payload for an organizer of a user's recurring 1:1 */
export type SuggestionResultRecurringOneOnOneOrganizerPayload = {
  __typename: "SuggestionResultRecurringOneOnOneOrganizerPayload";
  organizer: Scalars["String"];
};

/** Suggestion Result Running Out Of Focus Time Payload */
export type SuggestionResultRunningOutOfFocusTimePayload = {
  __typename: "SuggestionResultRunningOutOfFocusTimePayload";
  calendarId?: Maybe<Scalars["String"]>;
  originalFocusTimeMinutes?: Maybe<Scalars["Int"]>;
  remainingFocusTimeMinutes?: Maybe<Scalars["Int"]>;
  week?: Maybe<Scalars["String"]>;
};

/** Suggestion Result Shell Payload */
export type SuggestionResultShellPayload = {
  __typename: "SuggestionResultShellPayload";
  nop?: Maybe<Scalars["String"]>;
};

/** Suggestion Result Teammate Out Of Office Payload */
export type SuggestionResultTeammateOutOfOfficePayload = {
  __typename: "SuggestionResultTeammateOutOfOfficePayload";
  calendarId?: Maybe<Scalars["String"]>;
  maxDate?: Maybe<Scalars["String"]>;
  minDate?: Maybe<Scalars["String"]>;
  targetEvent?: Maybe<Event>;
};

/** Suggestion Result Week In Review Payload */
export type SuggestionResultWeekInReviewPayload = {
  __typename: "SuggestionResultWeekInReviewPayload";
  calendarId: Scalars["String"];
  rewindHistory: RewindHistory;
  rewindWeek: Scalars["String"];
};

/** Rewind History */
export type RewindHistory = Node & {
  __typename: "RewindHistory";
  /** The ID of an object */
  id: Scalars["ID"];
  snapshotDurationMillis: Scalars["BigInt"];
  snapshots: Array<Maybe<CompactCalendarSlotSnapshot>>;
};

/** Compact Calendar Slot Snapshot for Week In Review */
export type CompactCalendarSlotSnapshot = {
  __typename: "CompactCalendarSlotSnapshot";
  days: Array<Maybe<DaySnapshot>>;
  snapshotMillis: Scalars["BigInt"];
};

/** A collection of Snapshot Bits for a day */
export type DaySnapshot = {
  __typename: "DaySnapshot";
  focusTime: SnapshotBits;
  fragmented: SnapshotBits;
  lunch: SnapshotBits;
  meetings: SnapshotBits;
  workingHours: SnapshotBits;
};

/** Week In Review Snapshot Bits */
export type SnapshotBits = {
  __typename: "SnapshotBits";
  amBits: Scalars["Int"];
  pmBits: Scalars["Int"];
};

export type SuggestionResultWeeklyAutopilotSummaryPayload = {
  __typename: "SuggestionResultWeeklyAutopilotSummaryPayload";
  dateRangeMax: Scalars["String"];
  dateRangeMin: Scalars["String"];
  historicalDefragBenefitScore: HistoricalDefragBenefitScore;
};

export type HistoricalDefragBenefitScore = {
  __typename: "HistoricalDefragBenefitScore";
  affectedCalendars: Array<Scalars["String"]>;
  conflictsResolved: Scalars["Int"];
  meetingsMoved: Scalars["Int"];
  totalFocusTimeSavings: Scalars["Int"];
};

export enum SuggestionType {
  AutopilotAttendee = "AutopilotAttendee",
  ChromeExtensionTip = "ChromeExtensionTip",
  ConflictingMeeting = "ConflictingMeeting",
  ExpensiveMeeting = "ExpensiveMeeting",
  ExpensiveOrganizer = "ExpensiveOrganizer",
  LowFocusTime = "LowFocusTime",
  MeetingNotOnAutopilot = "MeetingNotOnAutopilot",
  MissingAttendance = "MissingAttendance",
  MissingUserConfiguration = "MissingUserConfiguration",
  RecurringOneOnOneOrganizer = "RecurringOneOnOneOrganizer",
  RunningOutOfFocusTime = "RunningOutOfFocusTime",
  Shell = "Shell",
  TeammateOutOfOffice = "TeammateOutOfOffice",
  WeekInReview = "WeekInReview",
  WeeklyAutopilotSummary = "WeeklyAutopilotSummary",
}

/** Text for a feed suggestion */
export type FeedSuggestionText = {
  __typename: "FeedSuggestionText";
  subHeading?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type DateRangeInput = {
  maxDate: Scalars["String"];
  minDate: Scalars["String"];
};

export type HeatmapResultErrorable = GraphEntityError | HeatmapResult;

/** The result of a heatmap fetch */
export type HeatmapResult = {
  __typename: "HeatmapResult";
  busyHours: Array<TimeRange>;
  crawledCalendarIds: Array<Scalars["String"]>;
  holdHours: Array<TimeRange>;
  meetingHours: Array<TimeRange>;
  uncrawledCalendarIds: Array<Scalars["String"]>;
};

export type FocusTimeStatsErrorable = FocusTimeStats | GraphEntityError;

/** Average focus time stats (for use in Focus Time Sync) */
export type FocusTimeStats = {
  __typename: "FocusTimeStats";
  minutesPerWeek?: Maybe<Scalars["Int"]>;
};

export type EventParentErrorable = EventParent | GraphEntityError;

/** Meeting Hours for a given user id */
export type MeetingHoursQueryResult = {
  __typename: "MeetingHoursQueryResult";
  calendarMeetingHours?: Maybe<CalendarMeetingHoursConnection>;
  orgMeetingHours?: Maybe<OrgMeetingHours>;
  userMeetingHours?: Maybe<UserMeetingHoursConnection>;
};

/** Meeting Hours for a given user id */
export type MeetingHoursQueryResultCalendarMeetingHoursArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** Meeting Hours for a given user id */
export type MeetingHoursQueryResultUserMeetingHoursArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A connection to a list of items. */
export type CalendarMeetingHoursConnection = {
  __typename: "CalendarMeetingHoursConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CalendarMeetingHoursEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CalendarMeetingHoursEdge = {
  __typename: "CalendarMeetingHoursEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<CalendarMeetingHours>;
};

/** Meeting Hours for a given calendar id */
export type CalendarMeetingHours = Node & {
  __typename: "CalendarMeetingHours";
  calendarId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  workingHours?: Maybe<WorkingHours>;
};

/** Working Hours */
export type WorkingHours = Node & {
  __typename: "WorkingHours";
  dayOverrides?: Maybe<Array<Maybe<DayOverride>>>;
  daySettings?: Maybe<Array<Maybe<DaySetting>>>;
  /** The ID of an object */
  id: Scalars["ID"];
  timeZone?: Maybe<Scalars["String"]>;
  /** Can be working hours or meeting hours (if you have PreferredFocusTime type, something's wrong... */
  type?: Maybe<WorkingHoursTypeEnum>;
};

/** An override for a day */
export type DayOverride = {
  __typename: "DayOverride";
  date?: Maybe<Scalars["String"]>;
  setting?: Maybe<WorkingSetting>;
};

/** Working time constraints for a time period */
export type WorkingSetting = {
  __typename: "WorkingSetting";
  excludedSlots?: Maybe<Array<Maybe<ExcludedSlots>>>;
  maxSlot?: Maybe<MaxSlot>;
  minSlot?: Maybe<MinSlot>;
};

export enum ExcludedSlots {
  T_00_00 = "T_00_00",
  T_00_30 = "T_00_30",
  T_01_00 = "T_01_00",
  T_01_30 = "T_01_30",
  T_02_00 = "T_02_00",
  T_02_30 = "T_02_30",
  T_03_00 = "T_03_00",
  T_03_30 = "T_03_30",
  T_04_00 = "T_04_00",
  T_04_30 = "T_04_30",
  T_05_00 = "T_05_00",
  T_05_30 = "T_05_30",
  T_06_00 = "T_06_00",
  T_06_30 = "T_06_30",
  T_07_00 = "T_07_00",
  T_07_30 = "T_07_30",
  T_08_00 = "T_08_00",
  T_08_30 = "T_08_30",
  T_09_00 = "T_09_00",
  T_09_30 = "T_09_30",
  T_10_00 = "T_10_00",
  T_10_30 = "T_10_30",
  T_11_00 = "T_11_00",
  T_11_30 = "T_11_30",
  T_12_00 = "T_12_00",
  T_12_30 = "T_12_30",
  T_13_00 = "T_13_00",
  T_13_30 = "T_13_30",
  T_14_00 = "T_14_00",
  T_14_30 = "T_14_30",
  T_15_00 = "T_15_00",
  T_15_30 = "T_15_30",
  T_16_00 = "T_16_00",
  T_16_30 = "T_16_30",
  T_17_00 = "T_17_00",
  T_17_30 = "T_17_30",
  T_18_00 = "T_18_00",
  T_18_30 = "T_18_30",
  T_19_00 = "T_19_00",
  T_19_30 = "T_19_30",
  T_20_00 = "T_20_00",
  T_20_30 = "T_20_30",
  T_21_00 = "T_21_00",
  T_21_30 = "T_21_30",
  T_22_00 = "T_22_00",
  T_22_30 = "T_22_30",
  T_23_00 = "T_23_00",
  T_23_30 = "T_23_30",
}

export enum MaxSlot {
  T_00_00 = "T_00_00",
  T_00_30 = "T_00_30",
  T_01_00 = "T_01_00",
  T_01_30 = "T_01_30",
  T_02_00 = "T_02_00",
  T_02_30 = "T_02_30",
  T_03_00 = "T_03_00",
  T_03_30 = "T_03_30",
  T_04_00 = "T_04_00",
  T_04_30 = "T_04_30",
  T_05_00 = "T_05_00",
  T_05_30 = "T_05_30",
  T_06_00 = "T_06_00",
  T_06_30 = "T_06_30",
  T_07_00 = "T_07_00",
  T_07_30 = "T_07_30",
  T_08_00 = "T_08_00",
  T_08_30 = "T_08_30",
  T_09_00 = "T_09_00",
  T_09_30 = "T_09_30",
  T_10_00 = "T_10_00",
  T_10_30 = "T_10_30",
  T_11_00 = "T_11_00",
  T_11_30 = "T_11_30",
  T_12_00 = "T_12_00",
  T_12_30 = "T_12_30",
  T_13_00 = "T_13_00",
  T_13_30 = "T_13_30",
  T_14_00 = "T_14_00",
  T_14_30 = "T_14_30",
  T_15_00 = "T_15_00",
  T_15_30 = "T_15_30",
  T_16_00 = "T_16_00",
  T_16_30 = "T_16_30",
  T_17_00 = "T_17_00",
  T_17_30 = "T_17_30",
  T_18_00 = "T_18_00",
  T_18_30 = "T_18_30",
  T_19_00 = "T_19_00",
  T_19_30 = "T_19_30",
  T_20_00 = "T_20_00",
  T_20_30 = "T_20_30",
  T_21_00 = "T_21_00",
  T_21_30 = "T_21_30",
  T_22_00 = "T_22_00",
  T_22_30 = "T_22_30",
  T_23_00 = "T_23_00",
  T_23_30 = "T_23_30",
}

export enum MinSlot {
  T_00_00 = "T_00_00",
  T_00_30 = "T_00_30",
  T_01_00 = "T_01_00",
  T_01_30 = "T_01_30",
  T_02_00 = "T_02_00",
  T_02_30 = "T_02_30",
  T_03_00 = "T_03_00",
  T_03_30 = "T_03_30",
  T_04_00 = "T_04_00",
  T_04_30 = "T_04_30",
  T_05_00 = "T_05_00",
  T_05_30 = "T_05_30",
  T_06_00 = "T_06_00",
  T_06_30 = "T_06_30",
  T_07_00 = "T_07_00",
  T_07_30 = "T_07_30",
  T_08_00 = "T_08_00",
  T_08_30 = "T_08_30",
  T_09_00 = "T_09_00",
  T_09_30 = "T_09_30",
  T_10_00 = "T_10_00",
  T_10_30 = "T_10_30",
  T_11_00 = "T_11_00",
  T_11_30 = "T_11_30",
  T_12_00 = "T_12_00",
  T_12_30 = "T_12_30",
  T_13_00 = "T_13_00",
  T_13_30 = "T_13_30",
  T_14_00 = "T_14_00",
  T_14_30 = "T_14_30",
  T_15_00 = "T_15_00",
  T_15_30 = "T_15_30",
  T_16_00 = "T_16_00",
  T_16_30 = "T_16_30",
  T_17_00 = "T_17_00",
  T_17_30 = "T_17_30",
  T_18_00 = "T_18_00",
  T_18_30 = "T_18_30",
  T_19_00 = "T_19_00",
  T_19_30 = "T_19_30",
  T_20_00 = "T_20_00",
  T_20_30 = "T_20_30",
  T_21_00 = "T_21_00",
  T_21_30 = "T_21_30",
  T_22_00 = "T_22_00",
  T_22_30 = "T_22_30",
  T_23_00 = "T_23_00",
  T_23_30 = "T_23_30",
}

/** A working setting for a day */
export type DaySetting = {
  __typename: "DaySetting";
  day?: Maybe<Day>;
  setting?: Maybe<WorkingSetting>;
};

export enum Day {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export enum WorkingHoursTypeEnum {
  Base = "Base",
  Meeting = "Meeting",
  PreferredFocusTime = "PreferredFocusTime",
}

/** Meeting hours for the org */
export type OrgMeetingHours = Node & {
  __typename: "OrgMeetingHours";
  hasBeenSet?: Maybe<Scalars["Boolean"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  orgId?: Maybe<Scalars["String"]>;
  workingHours?: Maybe<WorkingHours>;
};

/** A connection to a list of items. */
export type UserMeetingHoursConnection = {
  __typename: "UserMeetingHoursConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserMeetingHoursEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserMeetingHoursEdge = {
  __typename: "UserMeetingHoursEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<UserMeetingHours>;
};

/** Meeting Hours for a given user id */
export type UserMeetingHours = Node & {
  __typename: "UserMeetingHours";
  hasBeenSet?: Maybe<Scalars["Boolean"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  userId?: Maybe<Scalars["String"]>;
  workingHours?: Maybe<WorkingHours>;
};

export type DefragTimeErrorable = DefragTime | GraphEntityError;

/** Represents the time in which a defrag will run */
export type DefragTime = {
  __typename: "DefragTime";
  millis?: Maybe<Scalars["BigInt"]>;
};

/** Onboarding Checklist */
export type OnboardingChecklist = {
  __typename: "OnboardingChecklist";
  flexMeetingEnabled?: Maybe<FlexMeetingEnabledErrorable>;
  focusTimeEnabled?: Maybe<FocusTimeEnabledErrorable>;
  hasInvitedTeammate?: Maybe<HasInvitedTeammateErrorable>;
  lunchEnabled?: Maybe<LunchEnabledErrorable>;
  slackEnabled?: Maybe<SlackEnabledErrorable>;
};

export type FlexMeetingEnabledErrorable = FlexMeetingEnabled | GraphEntityError;

export type FlexMeetingEnabled = {
  __typename: "FlexMeetingEnabled";
  flexMeetingEnabled?: Maybe<Scalars["Boolean"]>;
};

export type FocusTimeEnabledErrorable = FocusTimeEnabled | GraphEntityError;

export type FocusTimeEnabled = {
  __typename: "FocusTimeEnabled";
  focusTimeEnabled?: Maybe<Scalars["Boolean"]>;
};

export type HasInvitedTeammateErrorable = GraphEntityError | HasInvitedTeammate;

export type HasInvitedTeammate = {
  __typename: "HasInvitedTeammate";
  hasInvitedTeammate?: Maybe<Scalars["Boolean"]>;
};

export type LunchEnabledErrorable = GraphEntityError | LunchEnabled;

export type LunchEnabled = {
  __typename: "LunchEnabled";
  lunchEnabled?: Maybe<Scalars["Boolean"]>;
};

export type SlackEnabledErrorable = GraphEntityError | SlackEnabled;

export type SlackEnabled = {
  __typename: "SlackEnabled";
  slackEnabled?: Maybe<Scalars["Boolean"]>;
};

export type EventListErrorable = EventList | GraphEntityError;

export type EventList = {
  __typename: "EventList";
  list: Array<Event>;
};

export type OptimisticSavingsErrorable = GraphEntityError | OptimisticSavings;

/** Optimistic savings for a user, used to determine how much time can be saved in a week */
export type OptimisticSavings = {
  __typename: "OptimisticSavings";
  couldCalculate: Scalars["Boolean"];
  savingMinutes?: Maybe<Scalars["Int"]>;
};

export type FlowStateListErrorable = FlowStateList | GraphEntityError;

export type FlowStateList = {
  __typename: "FlowStateList";
  list: Array<FlowState>;
};

export type OrgOverviewErrorable = GraphEntityError | OrgOverview;

/** Overview of organization-wide Clockwise usage */
export type OrgOverview = {
  __typename: "OrgOverview";
  conflictsResolvedCount: Array<IntegerDataPoint>;
  /** False if the org doesn't have enough data to display yet */
  doNotShowOverview: Scalars["Boolean"];
  focusTimeHoursCreatedCount: Array<IntegerDataPoint>;
  numUsersByFunction: Array<IntegerDataPoint>;
  numUsersByRole: Array<IntegerDataPoint>;
  scheduleAssistCount: Array<IntegerDataPoint>;
  scheduleAssistLimit: Scalars["Int"];
  userCount: Array<IntegerDataPoint>;
};

/** Label and value pair */
export type IntegerDataPoint = {
  __typename: "IntegerDataPoint";
  label: Scalars["String"];
  value: Scalars["Int"];
};

export enum ActivityFilter {
  CurrentUser = "CurrentUser",
  CurrentUserOrInvited = "CurrentUserOrInvited",
  Invited = "Invited",
}

export enum SortDirection {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum SortType {
  FullName = "FullName",
  Status = "Status",
}

/** A connection to a list of items. */
export type OrgInviteConnection = {
  __typename: "OrgInviteConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrgInviteEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrgInviteEdge = {
  __typename: "OrgInviteEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<OrgInvite>;
};

/** An invitation to join an org */
export type OrgInvite = Node & {
  __typename: "OrgInvite";
  createdTime?: Maybe<Scalars["Float"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  lastInvitingUserId?: Maybe<Scalars["String"]>;
  lastSentTime?: Maybe<Scalars["Float"]>;
  orgId?: Maybe<Scalars["String"]>;
  targetCalendarId?: Maybe<Scalars["String"]>;
  /** @deprecated Does not exist */
  targetProfile?: Maybe<UserProfile>;
  used?: Maybe<Scalars["Boolean"]>;
};

export type TeamErrorable = GraphEntityError | Team;

/** Your team and its members */
export type Team = Node & {
  __typename: "Team";
  createdBy: Urn;
  /** The ID of an object */
  id: Scalars["ID"];
  invitedMembers: Array<TeamMember>;
  settings: TeamSettingsErrorable;
  teamCalendarId?: Maybe<Scalars["String"]>;
  teamId: Scalars["String"];
  teamMembers: Array<TeamMember>;
  teamName: Scalars["String"];
  teamRoleAndPersonIds: Array<TeamRoleAndPersonId>;
  userSettings: TeamUserSettingsErrorable;
};

/** DESCRIBE NEW FIELD HERE */
export type TeamMember = {
  __typename: "TeamMember";
  addedBy?: Maybe<Scalars["String"]>;
  person: OrgPerson;
  role: TeamMemberRole;
};

export enum TeamMemberRole {
  Admin = "Admin",
  Member = "Member",
}

export type TeamSettingsErrorable = GraphEntityError | TeamSettings;

/** overall settings about a team */
export type TeamSettings = Node & {
  __typename: "TeamSettings";
  /** The ID of an object */
  id: Scalars["ID"];
  lastUpdated?: Maybe<Scalars["BigInt"]>;
  manageTeamCalendar: Scalars["Boolean"];
  minimumMinutesForSyncing: Scalars["Int"];
  noMeetingDayEmailOnScheduleOver: Scalars["Boolean"];
  noMeetingDayOfWeek: NoMeetingDayOfWeek;
  slackSettings: TeamSlackSettings;
  syncWFHEvents: Scalars["Boolean"];
  useNoMeetingDay: Scalars["Boolean"];
};

export enum NoMeetingDayOfWeek {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

/** DESCRIBE NEW FIELD HERE */
export type TeamSlackSettings = {
  __typename: "TeamSlackSettings";
  channelId?: Maybe<Scalars["String"]>;
  channelName?: Maybe<Scalars["String"]>;
  notificationEnabled: Scalars["Boolean"];
  timeSlot?: Maybe<TimeSlotEnum>;
};

export enum TimeSlotEnum {
  T_00_00 = "T_00_00",
  T_00_30 = "T_00_30",
  T_01_00 = "T_01_00",
  T_01_30 = "T_01_30",
  T_02_00 = "T_02_00",
  T_02_30 = "T_02_30",
  T_03_00 = "T_03_00",
  T_03_30 = "T_03_30",
  T_04_00 = "T_04_00",
  T_04_30 = "T_04_30",
  T_05_00 = "T_05_00",
  T_05_30 = "T_05_30",
  T_06_00 = "T_06_00",
  T_06_30 = "T_06_30",
  T_07_00 = "T_07_00",
  T_07_30 = "T_07_30",
  T_08_00 = "T_08_00",
  T_08_30 = "T_08_30",
  T_09_00 = "T_09_00",
  T_09_30 = "T_09_30",
  T_10_00 = "T_10_00",
  T_10_30 = "T_10_30",
  T_11_00 = "T_11_00",
  T_11_30 = "T_11_30",
  T_12_00 = "T_12_00",
  T_12_30 = "T_12_30",
  T_13_00 = "T_13_00",
  T_13_30 = "T_13_30",
  T_14_00 = "T_14_00",
  T_14_30 = "T_14_30",
  T_15_00 = "T_15_00",
  T_15_30 = "T_15_30",
  T_16_00 = "T_16_00",
  T_16_30 = "T_16_30",
  T_17_00 = "T_17_00",
  T_17_30 = "T_17_30",
  T_18_00 = "T_18_00",
  T_18_30 = "T_18_30",
  T_19_00 = "T_19_00",
  T_19_30 = "T_19_30",
  T_20_00 = "T_20_00",
  T_20_30 = "T_20_30",
  T_21_00 = "T_21_00",
  T_21_30 = "T_21_30",
  T_22_00 = "T_22_00",
  T_22_30 = "T_22_30",
  T_23_00 = "T_23_00",
  T_23_30 = "T_23_30",
}

/** DESCRIBE NEW FIELD HERE */
export type TeamRoleAndPersonId = {
  __typename: "TeamRoleAndPersonId";
  personId: Scalars["String"];
  role: TeamMemberRole;
};

export type TeamUserSettingsErrorable = GraphEntityError | TeamUserSettings;

/** individual user settings for a team */
export type TeamUserSettings = Node & {
  __typename: "TeamUserSettings";
  /** The ID of an object */
  id: Scalars["ID"];
  lastUpdated: Scalars["BigInt"];
  useNoMeetingDay: Scalars["Boolean"];
  useTeamCalendar: Scalars["Boolean"];
};

export type ProfileTimeZoneListErrorable = GraphEntityError | ProfileTimeZoneList;

export type ProfileTimeZoneList = {
  __typename: "ProfileTimeZoneList";
  list: Array<ProfileTimeZone>;
};

/** A time zone for a profile */
export type ProfileTimeZone = {
  __typename: "ProfileTimeZone";
  calendarId?: Maybe<Scalars["String"]>;
  timeZone: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
};

export type SlackChannelListErrorable = GraphEntityError | SlackChannelList;

export type SlackChannelList = {
  __typename: "SlackChannelList";
  list: Array<SlackChannel>;
};

/** Slack channel */
export type SlackChannel = {
  __typename: "SlackChannel";
  channelId: Scalars["String"];
  name: Scalars["String"];
};

export type SchedulingResponseErrorable = GraphEntityError | SchedulingResponse;

/** Scheduling Response */
export type SchedulingResponse = {
  __typename: "SchedulingResponse";
  qualifiers?: Maybe<Array<Maybe<SchedulingResponseQualifier>>>;
  queryRecommendation?: Maybe<QueryRecommendation>;
  slots: Array<SchedulingSlot>;
  uncrawledCalendars: Array<Maybe<Scalars["String"]>>;
};

export enum SchedulingResponseQualifier {
  NoConvenientTimesWithRooms = "NoConvenientTimesWithRooms",
}

/** Recommended date and/or duration of first available suggestion */
export type QueryRecommendation = {
  __typename: "QueryRecommendation";
  availableDate?: Maybe<Scalars["String"]>;
  minutesDuration?: Maybe<Scalars["String"]>;
};

export type RewindHistoryErrorable = GraphEntityError | RewindHistory;

export type RoomListErrorable = GraphEntityError | RoomList;

export type RoomList = {
  __typename: "RoomList";
  list: Array<Room>;
};

export type SchedulingQueryInput = {
  includeConflictSuggestions?: InputMaybe<Scalars["Boolean"]>;
  includeRoom: Scalars["Boolean"];
  invitees: Array<InputMaybe<InviteeContextInput>>;
  limit: Scalars["Int"];
  maxSlot: DayTimeSlotInput;
  minSlot: DayTimeSlotInput;
  minutesDuration: Scalars["Int"];
  roomsOverride: Array<InputMaybe<Scalars["String"]>>;
  seenSlots: Array<InputMaybe<DayTimeSlotInput>>;
  timeZone: Scalars["String"];
  traits?: InputMaybe<Array<InputMaybe<EventTrait>>>;
};

export type InviteeContextInput = {
  calendarId: Scalars["String"];
  required: Scalars["Boolean"];
};

export enum EventTrait {
  Autopilot = "Autopilot",
  IndividualHold = "IndividualHold",
  LinkEvent = "LinkEvent",
  LunchHold = "LunchHold",
  OneOnOne = "OneOnOne",
  TaskHold = "TaskHold",
}

/** A connection to a list of items. */
export type SettingConnection = {
  __typename: "SettingConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SettingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SettingEdge = {
  __typename: "SettingEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<Setting>;
};

/** A setting */
export type Setting = Node & {
  __typename: "Setting";
  /** The ID of an object */
  id: Scalars["ID"];
  key?: Maybe<SettingKey>;
  type?: Maybe<SettingType>;
  value?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** A setting key */
export type SettingKey = Node & {
  __typename: "SettingKey";
  /** The ID of an object */
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  scope?: Maybe<Urn>;
  target?: Maybe<Urn>;
};

/** A setting type */
export type SettingType = Node & {
  __typename: "SettingType";
  containerType?: Maybe<ContainerType>;
  /** The ID of an object */
  id: Scalars["ID"];
  required?: Maybe<Scalars["Boolean"]>;
  valueType?: Maybe<ValueType>;
};

export enum ContainerType {
  Multi = "Multi",
  Single = "Single",
}

export enum ValueType {
  Boolean = "Boolean",
  Long = "Long",
  Numeric = "Numeric",
  String = "String",
}

export type ShadowCalendarSettingsErrorable = GraphEntityError | ShadowCalendarSettings;

/** A container of settings for the users shadow calendar */
export type ShadowCalendarSettings = Node & {
  __typename: "ShadowCalendarSettings";
  enabled: Scalars["Boolean"];
  focusTimeExternalTransparency?: Maybe<FocusTimeExternalTransparency>;
  focusTimeIdealMinutesPerWeek: Scalars["Int"];
  focusTimeRemindersEnabled: Scalars["Boolean"];
  focusTimeSyncAll: Scalars["Boolean"];
  focusTimeSyncEnabled: Scalars["Boolean"];
  /** The ID of an object */
  id: Scalars["ID"];
  lunchRemindersEnabled: Scalars["Boolean"];
  lunchSyncEnabled: Scalars["Boolean"];
  shadowCalendarId?: Maybe<Scalars["String"]>;
  travelTimeRemindersEnabled: Scalars["Boolean"];
  travelTimeSyncEnabled: Scalars["Boolean"];
};

export enum FocusTimeExternalTransparency {
  None = "None",
  Opaque = "Opaque",
  Transparent = "Transparent",
}

export type SlackAccountErrorable = GraphEntityError | SlackAccount;

/** Slack Account */
export type SlackAccount = Node & {
  __typename: "SlackAccount";
  /** The ID of an object */
  id: Scalars["ID"];
  needsUpdate: Scalars["Boolean"];
  slackTeamId?: Maybe<Scalars["String"]>;
  slackUserId?: Maybe<Scalars["String"]>;
  teamDisplayName?: Maybe<Scalars["String"]>;
};

export type SlackAccountListErrorable = GraphEntityError | SlackAccountList;

export type SlackAccountList = {
  __typename: "SlackAccountList";
  list: Array<SlackAccount>;
};

export type SlackSettingsListErrorable = GraphEntityError | SlackSettingsList;

export type SlackSettingsList = {
  __typename: "SlackSettingsList";
  list: Array<SlackSettings>;
};

/** Slack calendar sync settings */
export type SlackSettings = Node & {
  __typename: "SlackSettings";
  calendarStatus?: Maybe<SlackCalendarStatusSync>;
  /** @deprecated use calendarStatus */
  calendarStatusEnabled: Scalars["Boolean"];
  dailyDigestSettings?: Maybe<SlackDailyDigestSettings>;
  dndSettings?: Maybe<SlackDndSettings>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** @deprecated use calendarStatus */
  includeMeetingCategory: Scalars["Boolean"];
  /** @deprecated use calendarStatus */
  includeMeetingTitle: Scalars["Boolean"];
  notificationSettings?: Maybe<SlackNotificationSettings>;
  slackTeamId: Scalars["String"];
  slackUserId: Scalars["String"];
};

export type SlackCalendarStatusSync = {
  __typename: "SlackCalendarStatusSync";
  calendarStatusEnabled: Scalars["Boolean"];
  includeMeetingCategory: Scalars["Boolean"];
  includeMeetingTitle: Scalars["Boolean"];
};

export type SlackDailyDigestSettings = {
  __typename: "SlackDailyDigestSettings";
  enabled: Scalars["Boolean"];
  timeSlot: DigestTimeSlot;
};

export enum DigestTimeSlot {
  T_00_00 = "T_00_00",
  T_00_30 = "T_00_30",
  T_01_00 = "T_01_00",
  T_01_30 = "T_01_30",
  T_02_00 = "T_02_00",
  T_02_30 = "T_02_30",
  T_03_00 = "T_03_00",
  T_03_30 = "T_03_30",
  T_04_00 = "T_04_00",
  T_04_30 = "T_04_30",
  T_05_00 = "T_05_00",
  T_05_30 = "T_05_30",
  T_06_00 = "T_06_00",
  T_06_30 = "T_06_30",
  T_07_00 = "T_07_00",
  T_07_30 = "T_07_30",
  T_08_00 = "T_08_00",
  T_08_30 = "T_08_30",
  T_09_00 = "T_09_00",
  T_09_30 = "T_09_30",
  T_10_00 = "T_10_00",
  T_10_30 = "T_10_30",
  T_11_00 = "T_11_00",
  T_11_30 = "T_11_30",
  T_12_00 = "T_12_00",
  T_12_30 = "T_12_30",
  T_13_00 = "T_13_00",
  T_13_30 = "T_13_30",
  T_14_00 = "T_14_00",
  T_14_30 = "T_14_30",
  T_15_00 = "T_15_00",
  T_15_30 = "T_15_30",
  T_16_00 = "T_16_00",
  T_16_30 = "T_16_30",
  T_17_00 = "T_17_00",
  T_17_30 = "T_17_30",
  T_18_00 = "T_18_00",
  T_18_30 = "T_18_30",
  T_19_00 = "T_19_00",
  T_19_30 = "T_19_30",
  T_20_00 = "T_20_00",
  T_20_30 = "T_20_30",
  T_21_00 = "T_21_00",
  T_21_30 = "T_21_30",
  T_22_00 = "T_22_00",
  T_22_30 = "T_22_30",
  T_23_00 = "T_23_00",
  T_23_30 = "T_23_30",
}

export type SlackDndSettings = {
  __typename: "SlackDndSettings";
  focusTime: Scalars["Boolean"];
  meeting: Scalars["Boolean"];
};

export type SlackNotificationSettings = {
  __typename: "SlackNotificationSettings";
  defragSummary: Scalars["Boolean"];
};

export type SmartHoldEventInfoErrorable = GraphEntityError | SmartHoldEventInfo;

/** Metadata about a Smart Hold event */
export type SmartHoldEventInfo = Node & {
  __typename: "SmartHoldEventInfo";
  /** The ID of an object */
  id: Scalars["ID"];
  isMeetingPrep: Scalars["Boolean"];
  isPostTravelTime: Scalars["Boolean"];
  isPreTravelTime: Scalars["Boolean"];
  isTeamCalendarSyncEvent: Scalars["Boolean"];
  originEvent: Event;
};

export enum SsoIntent {
  Dsync = "Dsync",
  Sso = "Sso",
}

export type DefragConflictResolutionErrorable = DefragConflictResolution | GraphEntityError;

/** Defrag Conflict Resolution */
export type DefragConflictResolution = {
  __typename: "DefragConflictResolution";
  defragId: Scalars["String"];
  eventMoveSuggestions: Array<EventMoveSuggestion>;
};

/** The actual suggestion for moving an event within a defrag */
export type EventMoveSuggestion = Node & {
  __typename: "EventMoveSuggestion";
  /** The proposed minutes added to (or subtracted from) the base event */
  addedMinutes?: Maybe<Scalars["Int"]>;
  /** The unique key for the event for this suggestion */
  eventKey?: Maybe<EventKey>;
  /** The ID of an object */
  id: Scalars["ID"];
  meetingDurationInMinutes?: Maybe<Scalars["Int"]>;
  /** The original day time slot of the event */
  originalSlot?: Maybe<DayTimeSlot>;
  /** The original time of the event */
  originalTime?: Maybe<EventTime>;
  /** The proposed day time slot to move the event to */
  proposedSlot?: Maybe<DayTimeSlot>;
  /** The proposed time to move the event to */
  proposedTime?: Maybe<EventTime>;
  /** What type of EventMoveSuggestion */
  type?: Maybe<TypeEnum>;
};

export enum TypeEnum {
  Add = "Add",
  Move = "Move",
  Remove = "Remove",
  UndoMove = "UndoMove",
}

/** A connection to a list of items. */
export type SuggestedOrgInviteConnection = {
  __typename: "SuggestedOrgInviteConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SuggestedOrgInviteEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SuggestedOrgInviteEdge = {
  __typename: "SuggestedOrgInviteEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<SuggestedOrgInvite>;
};

/** A suggestion to invite someone to join an org */
export type SuggestedOrgInvite = Node & {
  __typename: "SuggestedOrgInvite";
  /** The ID of an object */
  id: Scalars["ID"];
  inviteReason?: Maybe<SuggestedOrgInviteReason>;
  numberOfOrganizedMeetings?: Maybe<Scalars["Int"]>;
  numberOfSharedMeetings?: Maybe<Scalars["Int"]>;
  orgId?: Maybe<Scalars["String"]>;
  resolution?: Maybe<SuggestedOrgInviteResolution>;
  suggestedTime?: Maybe<Scalars["Float"]>;
  targetCalendarId?: Maybe<Scalars["String"]>;
  targetProfile?: Maybe<UserProfile>;
  totalScore?: Maybe<Scalars["Float"]>;
};

export enum SuggestedOrgInviteReason {
  AttendSameMeetings = "AttendSameMeetings",
  MeetsWithYourTeammates = "MeetsWithYourTeammates",
  OnYourTeam = "OnYourTeam",
  OrganizedYourMeetings = "OrganizedYourMeetings",
}

export enum SuggestedOrgInviteResolution {
  Accepted = "Accepted",
  Dismissed = "Dismissed",
}

export type SuggestedRoomPreferencesErrorable = GraphEntityError | SuggestedRoomPreferences;

/** The suggested room preferences for the user */
export type SuggestedRoomPreferences = Node & {
  __typename: "SuggestedRoomPreferences";
  /** The ID of an object */
  id: Scalars["ID"];
  suggestedRooms: Array<SuggestedRoomPreference>;
};

/** A selected or suggested preferred room */
export type SuggestedRoomPreference = {
  __typename: "SuggestedRoomPreference";
  /** Has the room been selected as a preferred room by the user */
  isPreferred: Scalars["Boolean"];
  /** Is the room suggested as a preferred room for the user */
  isSuggested: Scalars["Boolean"];
  room: Room;
};

export type SuggestedTeamListErrorable = GraphEntityError | SuggestedTeamList;

export type SuggestedTeamList = {
  __typename: "SuggestedTeamList";
  list: Array<SuggestedTeam>;
};

/** A suggested team and its reasons */
export type SuggestedTeam = {
  __typename: "SuggestedTeam";
  reasons: Array<SuggestedTeamReason>;
  score: Scalars["Float"];
  team: Team;
};

/** DESCRIBE NEW FIELD HERE */
export type SuggestedTeamReason = {
  __typename: "SuggestedTeamReason";
  type: SuggestedTeamReasonType;
  value: Scalars["Float"];
};

export enum SuggestedTeamReasonType {
  NumMeetingsWithOverlap = "NumMeetingsWithOverlap",
  NumOneOnOnesWithOverlap = "NumOneOnOnesWithOverlap",
}

/** A summary of working preferences for a teammate */
export type SummarizedWorkingPreferences = {
  __typename: "SummarizedWorkingPreferences";
  busiestDay?: Maybe<Day>;
  calendarId?: Maybe<Scalars["String"]>;
  mostBookedRoom?: Maybe<Scalars["String"]>;
  mostFocusTime?: Maybe<Day>;
};

export type EventTimeInput = {
  dateOrDateTime: Scalars["String"];
  millis: Scalars["Float"];
  offsetMinutes?: InputMaybe<Scalars["Float"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
  type: EventTimeType;
};

export type TailoredDefragCardSummaryErrorable = GraphEntityError | TailoredDefragCardSummary;

/** A tailored set of defrag moves summarized for the user */
export type TailoredDefragCardSummary = {
  __typename: "TailoredDefragCardSummary";
  calendarValueStrings?: Maybe<Array<Maybe<TailoredDefragCalendarValueStrings>>>;
  defragTime: Scalars["BigInt"];
  impactedOtherCalendarIds: Array<Scalars["String"]>;
  knobs: DefragValueKnobs;
  persons: PersonListErrorable;
  referencedEvents: Array<Event>;
  rooms: RoomListErrorable;
  valueStrings: Array<Scalars["String"]>;
  yourEventMoves: Array<DefragExplainedMove>;
};

export type TailoredDefragCalendarValueStrings = {
  __typename: "TailoredDefragCalendarValueStrings";
  calendarId: Scalars["String"];
  valueStrings: Array<Scalars["String"]>;
};

/** Defrag Value Knobs */
export type DefragValueKnobs = {
  __typename: "DefragValueKnobs";
  autopilotMeetingKnobs: Array<AutopilotMeetingKnob>;
  calendarId: Scalars["String"];
  inviteOrganizerKnobs: Array<InviteOrganizerKnob>;
  lessenAutopilotConstraintKnobs: Array<LessenAutopilotConstraintKnob>;
};

/** Affected Goal For Event */
export type AutopilotMeetingKnob = {
  __typename: "AutopilotMeetingKnob";
  affectedGoals: Array<Maybe<AffectedGoals>>;
  externalEventId: Scalars["String"];
  knobScore: Scalars["Float"];
  knobUrn: Urn;
};

export enum AffectedGoals {
  AttendMeeting = "AttendMeeting",
  ConvenientMeetingTime = "ConvenientMeetingTime",
  EmailTriage = "EmailTriage",
  FocusTask = "FocusTask",
  FocusTime = "FocusTime",
  Lunch = "Lunch",
  MeetingRelief = "MeetingRelief",
  NoMeetingDay = "NoMeetingDay",
  PersonalObligation = "PersonalObligation",
  PreferredWork = "PreferredWork",
  PrepTime = "PrepTime",
  Task = "Task",
  TravelTime = "TravelTime",
  WithinMeetingHours = "WithinMeetingHours",
  WithinWorkingHours = "WithinWorkingHours",
}

/** Inviter Organizer Knob */
export type InviteOrganizerKnob = {
  __typename: "InviteOrganizerKnob";
  affectedEventIds: Array<Scalars["String"]>;
  affectedGoals: Array<Maybe<AffectedGoals>>;
  affectedGoalsForEvents: Array<AffectedGoalForEvent>;
  knobScore: Scalars["Float"];
  knobUrn: Urn;
  suggestedInvitee: Scalars["String"];
  suggestedInviteePerson: PersonErrorable;
};

/** The event and reasons why it is affected */
export type AffectedGoalForEvent = {
  __typename: "AffectedGoalForEvent";
  affectedGoals: Array<Maybe<AffectedGoals>>;
  externalEventId: Scalars["String"];
};

/** Lessen Autopilot Constraint Knob */
export type LessenAutopilotConstraintKnob = {
  __typename: "LessenAutopilotConstraintKnob";
  affectedGoals: Array<Maybe<AffectedGoals>>;
  externalEventId: Scalars["String"];
  knobScore: Scalars["Float"];
  knobUrn: Urn;
};

/** The explanation for a singular move within a defrag */
export type DefragExplainedMove = {
  __typename: "DefragExplainedMove";
  addedRooms: Array<Scalars["String"]>;
  event: Event;
  moveReasons: Array<Scalars["String"]>;
  newStartTime: EventTime;
  originalStartTime: EventTime;
  removedRooms: Array<Scalars["String"]>;
};

export type CalendarStatusListErrorable = CalendarStatusList | GraphEntityError;

export type CalendarStatusList = {
  __typename: "CalendarStatusList";
  list: Array<CalendarStatus>;
};

export type TeamHealthScoreErrorable = GraphEntityError | TeamHealthScore;

/** Team Health Score */
export type TeamHealthScore = {
  __typename: "TeamHealthScore";
  calendarFocusTimeScores?: Maybe<Array<Maybe<CalendarFocusTimeScore>>>;
  myFocusTimeScore?: Maybe<CalendarFocusTimeScore>;
  orgId: Scalars["String"];
  orgPersons: OrgPersonListErrorable;
  persons: PersonListErrorable;
  profileTimeZones?: Maybe<Array<Maybe<ProfileTimeZone>>>;
};

export type TeamHealthScoreWithSubTeamsErrorable = GraphEntityError | TeamHealthScoreWithSubTeams;

/** Team Health Score With Sub Teams */
export type TeamHealthScoreWithSubTeams = {
  __typename: "TeamHealthScoreWithSubTeams";
  teamCalendars: Array<TeamCalendarMap>;
  teamHealthScore: TeamHealthScore;
};

export type TeamCalendarMap = {
  __typename: "teamCalendarMap";
  calendarIds?: Maybe<Array<Scalars["String"]>>;
  teamId: Scalars["String"];
  teamName?: Maybe<Scalars["String"]>;
};

export type TeamListErrorable = GraphEntityError | TeamList;

export type TeamList = {
  __typename: "TeamList";
  list: Array<Team>;
};

/** The users team as defined by the user */
export type UserDefinedTeam = Node & {
  __typename: "UserDefinedTeam";
  calendarIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** The ID of an object */
  id: Scalars["ID"];
};

/** A connection to a list of items. */
export type GoalConnection = {
  __typename: "GoalConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GoalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GoalEdge = {
  __typename: "GoalEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<Goal>;
};

/** A calendar's goal */
export type Goal = {
  __typename: "Goal";
  /** The id of the goal, used internally by the services */
  goalId: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** Whether this goal is deleted or not */
  isDeleted: Scalars["Boolean"];
  /** The name associated with this goal */
  name: Scalars["String"];
  /** Options associated with this goal */
  options?: Maybe<GoalOptions>;
  /** Additional ids that this goal is associated with */
  otherUrns: Array<Urn>;
  /** The id of this goal's target, generally a calendar id scoped to an org */
  targetUrn: Urn;
  /** The id associated with an object used to represent this goal, e.g. an event id if the goal is represented by an event */
  valueUrn: Urn;
};

/** Options describing a goal */
export type GoalOptions = {
  __typename: "GoalOptions";
  specificOptions?: Maybe<GoalSpecificOptions>;
  /** If this goal is saved on the user's google calendar */
  syncToGoogle: Scalars["Boolean"];
};

export type GoalSpecificOptions =
  | GoalMeetingReliefOptions
  | GoalPreferredWorkOptions
  | GoalWithinDayOptions
  | GoalWithinWeekOptions;

/** Options for the preferred work option */
export type GoalMeetingReliefOptions = {
  __typename: "GoalMeetingReliefOptions";
  /** The number of consecutive minutes of meetings that are allowed before a gap is requested */
  fatigueThresholdMinutes: Scalars["Int"];
  /** The number of minutes placed between consecutive meetings when fatigue threshold met */
  meetingReliefBreakMinutes: Scalars["Int"];
};

/** Options for the preferred work option */
export type GoalPreferredWorkOptions = {
  __typename: "GoalPreferredWorkOptions";
  /** Whether to keep the end of a user's day open, or to schedule meetings until the end */
  keepEndOfDayOpen?: Maybe<Scalars["Boolean"]>;
  /** Whether to keep the start of a user's day open, or to schedule meetings at the start */
  keepStartOfDayOpen?: Maybe<Scalars["Boolean"]>;
  /** When the user prefers to work */
  preferredWorkType: PreferredWorkType;
};

export enum PreferredWorkType {
  Afternoon = "Afternoon",
  Any = "Any",
  Morning = "Morning",
}

/** Options for goals that move within a day */
export type GoalWithinDayOptions = {
  __typename: "GoalWithinDayOptions";
  /** The ideal and usually maximum duration of the goal */
  idealDuration?: Maybe<Scalars["Int"]>;
  /** The maximum time slot in a day that the goal can be in */
  maxTimeSlot?: Maybe<TimeSlot>;
  /** The minimum duration of the goal */
  minimumDuration?: Maybe<Scalars["Int"]>;
  /** The minimum time slot in a day that the goal can be in */
  minTimeSlot?: Maybe<TimeSlot>;
};

/** Options for creating a goal that operates in the entire week context. e.g. focus time */
export type GoalWithinWeekOptions = {
  __typename: "GoalWithinWeekOptions";
  /** The maximum duration in minutes of each individual block, where a block is typically an event on the calendar */
  maxMinutesPerBlock: Scalars["Int"];
};

export type UserSurveyResponseListErrorable = GraphEntityError | UserSurveyResponseList;

export type UserSurveyResponseList = {
  __typename: "UserSurveyResponseList";
  list: Array<UserSurveyResponse>;
};

/** Onboarding survey reponses from user */
export type UserSurveyResponse = {
  __typename: "UserSurveyResponse";
  freeformResponse?: Maybe<Scalars["String"]>;
  questionText?: Maybe<Scalars["String"]>;
  questionType?: Maybe<QuestionType>;
  responseText?: Maybe<Scalars["String"]>;
  responseType?: Maybe<ResponseType>;
};

export enum QuestionType {
  HelpWithFindingUninterruptedTimeToFocus = "HelpWithFindingUninterruptedTimeToFocus",
  HelpWithSchedulingExternalMeetingsEffortlessly = "HelpWithSchedulingExternalMeetingsEffortlessly",
  HelpWithSettingHealthyWorkLifeBoundaries = "HelpWithSettingHealthyWorkLifeBoundaries",
  HelpWithSimplifyingSchedulingWithCoworkers = "HelpWithSimplifyingSchedulingWithCoworkers",
  HelpWithSomethingElse = "HelpWithSomethingElse",
  HowDidYouHearAboutClockwise = "HowDidYouHearAboutClockwise",
  HowManyPeopleOnTeam = "HowManyPeopleOnTeam",
  WhatIsYourCurrentPosition = "WhatIsYourCurrentPosition",
  WhatTypeOfWorkDoYouDo = "WhatTypeOfWorkDoYouDo",
}

export enum ResponseType {
  AccountingOrFinance = "AccountingOrFinance",
  Administrative = "Administrative",
  Between10And15 = "Between10And15",
  Between15And20 = "Between15And20",
  Between5And9 = "Between5And9",
  BusinessOwner = "BusinessOwner",
  Checked = "Checked",
  CustomerSupport = "CustomerSupport",
  DesignOrUxResearch = "DesignOrUxResearch",
  DirectorOrDepartmentLeader = "DirectorOrDepartmentLeader",
  ExecutiveOrBusinessLeader = "ExecutiveOrBusinessLeader",
  FoundOnline = "FoundOnline",
  FriendOrFamily = "FriendOrFamily",
  IDoNotKnow = "IDoNotKnow",
  IDoNotWorkOnAnyTeams = "IDoNotWorkOnAnyTeams",
  IndividualContributor = "IndividualContributor",
  InternetSearch = "InternetSearch",
  It = "It",
  Legal = "Legal",
  LessThan5 = "LessThan5",
  Manager = "Manager",
  Marketing = "Marketing",
  MoreThan20 = "MoreThan20",
  MyMeetingsOnAutopilot = "MyMeetingsOnAutopilot",
  OnlineAdvertisement = "OnlineAdvertisement",
  Operations = "Operations",
  Other = "Other",
  PeopleOpsOrHr = "PeopleOpsOrHr",
  ProductManagement = "ProductManagement",
  ProgramOrProjectManagement = "ProgramOrProjectManagement",
  Recruiting = "Recruiting",
  SalesOrBusinessDevelopment = "SalesOrBusinessDevelopment",
  SocialMedia = "SocialMedia",
  SoftwareEngineering = "SoftwareEngineering",
  TeammateAutopilot = "TeammateAutopilot",
  TeammateCalendar = "TeammateCalendar",
  TeammateFocusTime = "TeammateFocusTime",
  TeammateInvited = "TeammateInvited",
  TeammatePersonalCalendar = "TeammatePersonalCalendar",
  TeammatePrepTime = "TeammatePrepTime",
  TeammateSlackStatus = "TeammateSlackStatus",
  TeammateTravelTime = "TeammateTravelTime",
  Unchecked = "Unchecked",
  VpOrDivisionLeader = "VpOrDivisionLeader",
}

export type UserSurveyResponseWrapperErrorable = GraphEntityError | UserSurveyResponseWrapper;

/** A wrapper for UserSurveyResponses to give them an ID. */
export type UserSurveyResponseWrapper = Node & {
  __typename: "UserSurveyResponseWrapper";
  /** The ID of an object */
  id: Scalars["ID"];
  userSurveyResponses: Array<UserSurveyResponse>;
};

/** Working Hours for a given user id */
export type UserWorkingHours = Node & {
  __typename: "UserWorkingHours";
  hasBeenSet?: Maybe<Scalars["Boolean"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  userId?: Maybe<Scalars["String"]>;
  workingHours?: Maybe<WorkingHours>;
};

export type AddressErrorable = Address | GraphEntityError;

export type Address = {
  __typename: "Address";
  rawAddress: Scalars["String"];
};

/** A connection to a list of items. */
export type WorkingGroupConnection = {
  __typename: "WorkingGroupConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkingGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type WorkingGroupEdge = {
  __typename: "WorkingGroupEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<WorkingGroup>;
};

/** a collection of calendarIds in a shared group */
export type WorkingGroup = Node & {
  __typename: "WorkingGroup";
  /** The people that make up the working group */
  calendarIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Calendars associated with this org */
  calendars?: Maybe<CalendarConnection>;
  /** Calendars associated with this org */
  calendarWeeks?: Maybe<CalendarWeekConnection>;
  /** The collection of event move suggestions to carry out a defrag */
  defragSuggestions?: Maybe<Array<Maybe<DefragSuggestions>>>;
  /** An org's collection of events from all queried calendars and dates */
  eventParents: EventParentConnection;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The name of the working group */
  name?: Maybe<Scalars["String"]>;
  /** The org id this working group belongs to */
  orgId?: Maybe<Scalars["String"]>;
  /** The list of rooms associated with this working group */
  rooms?: Maybe<Array<Maybe<Room>>>;
};

/** a collection of calendarIds in a shared group */
export type WorkingGroupCalendarsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  calendarIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orgId?: InputMaybe<Scalars["String"]>;
};

/** a collection of calendarIds in a shared group */
export type WorkingGroupCalendarWeeksArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  calendarIds: Array<InputMaybe<Scalars["String"]>>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  startDate: Scalars["Date"];
  timeZone: Scalars["String"];
};

/** a collection of calendarIds in a shared group */
export type WorkingGroupDefragSuggestionsArgs = {
  annotationRestriction?: InputMaybe<AnnotationRestriction>;
  organizerRestriction: OrganizerRestriction;
  saveResults?: InputMaybe<Scalars["Boolean"]>;
  startDate: Scalars["String"];
  timeZone: Scalars["String"];
  weeks?: InputMaybe<Scalars["Int"]>;
};

/** a collection of calendarIds in a shared group */
export type WorkingGroupEventParentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  calendarIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  dates?: InputMaybe<Array<InputMaybe<Scalars["Date"]>>>;
  eventParentRelayId?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
};

/** A connection to a list of items. */
export type CalendarConnection = {
  __typename: "CalendarConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CalendarEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CalendarEdge = {
  __typename: "CalendarEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<Calendar>;
};

/** A calendar belonging to someone or thing in the organization */
export type Calendar = Node & {
  __typename: "Calendar";
  /** The id of the calendar — usually an email address */
  calendarId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The id of the organization this calendar belongs to */
  orgId?: Maybe<Scalars["String"]>;
};

/** A connection to a list of items. */
export type CalendarWeekConnection = {
  __typename: "CalendarWeekConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CalendarWeekEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CalendarWeekEdge = {
  __typename: "CalendarWeekEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<CalendarWeek>;
};

/** A week of events for a given calendar id */
export type CalendarWeek = Node & {
  __typename: "CalendarWeek";
  calendarId?: Maybe<Scalars["String"]>;
  calendarMeetingHours?: Maybe<CalendarMeetingHours>;
  eventParents?: Maybe<EventParentConnection>;
  /** The ID of an object */
  id: Scalars["ID"];
  orgId?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  timeZone?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  userMeetingHours?: Maybe<UserMeetingHours>;
};

/** A week of events for a given calendar id */
export type CalendarWeekEventParentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export enum AnnotationRestriction {
  None = "None",
  RequiredAnnotation = "RequiredAnnotation",
}

export enum OrganizerRestriction {
  None = "None",
  OrganizersInOrg = "OrganizersInOrg",
  UserOnly = "UserOnly",
}

/** A set of suggestions for moving events */
export type DefragSuggestions = Node & {
  __typename: "DefragSuggestions";
  /** New events created as part of this suggestion */
  addedEventParents?: Maybe<EventParentConnection>;
  /** New events created as part of this pre suggestion */
  addedPreEventParents?: Maybe<EventParentConnection>;
  /** The event query that was used to generate suggestions */
  eventsQuery?: Maybe<EventsQuery>;
  goalScoreDelta?: Maybe<TeamGoalScores>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The pre suggestions for this defrag */
  preSuggestions?: Maybe<Array<Maybe<DefragSuggestion>>>;
  /** The suggestions for this defrag */
  suggestions?: Maybe<Array<Maybe<DefragSuggestion>>>;
};

/** A set of suggestions for moving events */
export type DefragSuggestionsAddedEventParentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A set of suggestions for moving events */
export type DefragSuggestionsAddedPreEventParentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A set of suggestions for moving events */
export type DefragSuggestionsPreSuggestionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A query object for fetching events */
export type EventsQuery = Node & {
  __typename: "EventsQuery";
  /** The list of calendarIds used for the query */
  calendarIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** The end time */
  endTime?: Maybe<EventTime>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The start time */
  startTime?: Maybe<EventTime>;
};

/** Scoring of goals for the team for a defrag */
export type TeamGoalScores = {
  __typename: "TeamGoalScores";
  aggregatedGoalScores?: Maybe<Array<Maybe<GoalScore>>>;
  calendarGoalScores?: Maybe<Array<Maybe<CalendarGoalScores>>>;
};

/** Scoring fitness of a goal for a particular defrag */
export type GoalScore = {
  __typename: "GoalScore";
  after?: Maybe<Scalars["Float"]>;
  before?: Maybe<Scalars["Float"]>;
  goalId?: Maybe<Scalars["String"]>;
  units?: Maybe<UnitsEnum>;
};

export enum UnitsEnum {
  DaysWith = "DaysWith",
  Has = "Has",
  HoursOf = "HoursOf",
}

/** A collection of Goal Scores for a calendarId */
export type CalendarGoalScores = {
  __typename: "CalendarGoalScores";
  calendarId?: Maybe<Scalars["String"]>;
  goalScores?: Maybe<Array<Maybe<GoalScore>>>;
};

/** A suggestion for moving an individual event */
export type DefragSuggestion = {
  __typename: "DefragSuggestion";
  /** The details of suggested event move */
  eventMoveSuggestion?: Maybe<EventMoveSuggestion>;
};

/** Working Hours for a given user id */
export type WorkingHoursQueryResult = {
  __typename: "WorkingHoursQueryResult";
  userWorkingHours?: Maybe<UserWorkingHoursConnection>;
};

/** Working Hours for a given user id */
export type WorkingHoursQueryResultUserWorkingHoursArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** A connection to a list of items. */
export type UserWorkingHoursConnection = {
  __typename: "UserWorkingHoursConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserWorkingHoursEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserWorkingHoursEdge = {
  __typename: "UserWorkingHoursEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The item at the end of the edge */
  node?: Maybe<UserWorkingHours>;
};

export type ZoomAccountErrorable = GraphEntityError | ZoomAccount;

/** Zoom Account */
export type ZoomAccount = Node & {
  __typename: "ZoomAccount";
  accountId: Scalars["String"];
  connected: Scalars["String"];
  /** Domain of the zoom account that’s been connected */
  displayName: Scalars["String"];
  /** boolean whether the user has a valid zoom account for the connected zoom integration */
  hasValidZoomAccount: Scalars["Boolean"];
  /** The ID of an object */
  id: Scalars["ID"];
  ownerPersons: PersonListErrorable;
  /** userId of the person who connected the zoom account */
  ownerUserId: Scalars["String"];
};

/** Details of a users scheduling link */
export type SchedulingLink = {
  __typename: "SchedulingLink";
  /** A user's configurable id, like a username, for their scheduling links. Unique among all Clockwise users. */
  linkName: Scalars["String"];
  linkUrl: Scalars["String"];
  meetingSettings: MeetingSettings;
};

export enum UserStatusEnum {
  Active = "Active",
  Preview = "Preview",
  Restricted = "Restricted",
}

export type WaitlistedUser = {
  __typename: "WaitlistedUser";
  claimed: Scalars["Boolean"];
  email: Scalars["String"];
  function?: Maybe<Scalars["String"]>;
  waitlistTime: Scalars["BigInt"];
};

export type TeamQueryResultErrorable = GraphEntityError | TeamQueryResult;

/** The result of a team query */
export type TeamQueryResult = {
  __typename: "TeamQueryResult";
  query: Scalars["String"];
  searchId?: Maybe<Scalars["Int"]>;
  teamMembers: Array<TeamMember>;
  teams: Array<Team>;
};

/** A verification for a verification code including the external account that will be connected */
export type VerificationCodeResponse = {
  __typename: "VerificationCodeResponse";
  slackTeam?: Maybe<Scalars["String"]>;
  slackUsername?: Maybe<Scalars["String"]>;
  valid?: Maybe<Scalars["Boolean"]>;
  verificationAttempted?: Maybe<Scalars["Boolean"]>;
  verificationCode?: Maybe<Scalars["String"]>;
  verificationType?: Maybe<VerificationType>;
};

export enum VerificationType {
  Slack = "Slack",
}

export type Mutation = {
  __typename: "Mutation";
  acceptDefaultOrgTags?: Maybe<AcceptDefaultOrgTagsMutationPayload>;
  addAdminForBillingGroup?: Maybe<AddAdminForBillingGroupMutationPayload>;
  addAndRemoveOrgTags?: Maybe<AddAndRemoveOrgTagsMutationPayload>;
  addManualMembersForBillingGroup?: Maybe<AddManualMembersForBillingGroupMutationPayload>;
  addOrgTags?: Maybe<AddOrgTagsMutationPayload>;
  addSlackAccount?: Maybe<AddSlackAccountMutationPayload>;
  addSlackAccountForTeam?: Maybe<AddSlackAccountForTeamMutationPayload>;
  addSlackAccountV2?: Maybe<AddSlackAccountV2MutationPayload>;
  addZoomAccount?: Maybe<AddZoomAccountMutationPayload>;
  batchAddAndRemoveOrgTags?: Maybe<BatchAddAndRemoveOrgTagsMutationPayload>;
  batchModifyAutopilotForEvents?: Maybe<BatchModifyAutopilotForEventsMutationPayload>;
  /** Modifies events flexibilities, returns the event parents that have been updated */
  batchUpdateFlexibility?: Maybe<Array<EventParent>>;
  cancelBooking?: Maybe<CancelBookingMutationPayload>;
  createBooking?: Maybe<CreateBookingMutationPayload>;
  createDataSource?: Maybe<CreateDataSourceMutationPayload>;
  /** Create a meeting setting, which represents a scheduling link. */
  createMeetingSettings?: Maybe<CreateMeetingSettingsPayload>;
  createOrgSubscriptionStripe?: Maybe<CreateOrgSubscriptionStripePayload>;
  createTeam?: Maybe<CreateTeamMutationPayload>;
  createTeamAndTeamSubscriptionStripe?: Maybe<CreateTeamAndTeamSubscriptionStripePayload>;
  createTeamCalendar?: Maybe<CreateTeamCalendarMutationPayload>;
  createTeamSubscriptionStripe?: Maybe<CreateTeamSubscriptionStripePayload>;
  deactivateUser?: Maybe<DeactivateUserMutationPayload>;
  /** mutation to delete Asana credentials. */
  deleteAsanaCredentials?: Maybe<DeleteAsanaCredentialsPayload>;
  deleteDataSource?: Maybe<DeleteDataSourcePayload>;
  deleteEvent?: Maybe<DeleteEventMutationPayload>;
  /** Delete a scheduling link's meeting settings. */
  deleteMeetingSettings?: Maybe<DeleteMeetingSettingsPayload>;
  deleteTeam?: Maybe<DeleteTeamMutationPayload>;
  deleteUserLevelZoomAccount?: Maybe<DeleteUserLevelZoomAccountMutationPayload>;
  deleteZoomAccount?: Maybe<DeleteZoomAccountMutationPayload>;
  disableDataSourceSync?: Maybe<DisableDataSourceSyncPayload>;
  enableDataSourceSync?: Maybe<EnableDataSourceSyncPayload>;
  enableOrDisableTeamSyncForEvent?: Maybe<EnableOrDisableTeamSyncForEventPayload>;
  executeCliCommand?: Maybe<ExecuteCliCommandMutationPayload>;
  /** Create a user's initial linkName. */
  findOrCreateLinkName?: Maybe<FindOrCreateLinkNamePayload>;
  installSlackApp?: Maybe<InstallSlackAppMutationPayload>;
  invitePersonsToTeam?: Maybe<InvitePersonsToTeamPayload>;
  inviteToBillingGroup?: Maybe<InviteToBillingGroupMutationPayload>;
  joinWaitlist?: Maybe<JoinWaitlistMutationPayload>;
  loginInsightsUser?: Maybe<LoginInsightsUserPayload>;
  loginInsightsUserOffline?: Maybe<LoginInsightsUserOfflinePayload>;
  loginMicrosoftUser?: Maybe<LoginMicrosoftUserMutationPayload>;
  loginUser?: Maybe<LoginUserMutationPayload>;
  logoutInsightsUser?: Maybe<LogoutInsightsUserPayload>;
  logoutUser?: Maybe<LogoutUserMutationPayload>;
  markDefragValueKnobsAsAccepted?: Maybe<MarkDefragValueKnobsAsAcceptedMutationPayload>;
  markDefragValueKnobsAsDismissed?: Maybe<MarkDefragValueKnobsAsDismissedMutationPayload>;
  markDefragValueKnobsAsPresented?: Maybe<MarkDefragValueKnobsAsPresentedMutationPayload>;
  markSeenFeedSuggestion?: Maybe<MarkSeenFeedSuggestionMutationPayload>;
  maybeOnboardOrg?: Maybe<MaybeOnboardOrgMutationPayload>;
  overrideSyncStatusForUserEvent?: Maybe<OverrideSyncStatusForUserEventMutationPayload>;
  patchBillingGroup?: Maybe<PatchBillingGroupMutationPayload>;
  patchSlackSettings?: Maybe<PatchSlackSettingsMutationPayload>;
  preAddOrgTags?: Maybe<PreAddOrgTagsMutationPayload>;
  /** Pre sets event flexibility, before the event has been created, based on a set of event properties */
  preSetEventFlexibility?: Maybe<PreSetFlexibilityResponse>;
  recordChromeInstall?: Maybe<RecordChromeInstallMutationPayload>;
  recordChromeUninstall?: Maybe<RecordChromeUninstallMutationPayload>;
  recordDefragResponse?: Maybe<RecordDefragResponseMutationPayload>;
  recordImpression?: Maybe<RecordImpressionMutationPayload>;
  registerEmailUpdates?: Maybe<RegisterEmailUpdatesPayload>;
  removeAdminForBillingGroup?: Maybe<RemoveAdminForBillingGroupMutationPayload>;
  removeGoal?: Maybe<RemoveGoalMutationPayload>;
  removeLunchHold?: Maybe<RemoveLunchHoldMutationPayload>;
  removeManualMembersForBillingGroup?: Maybe<RemoveManualMembersForBillingGroupMutationPayload>;
  removeOrgTags?: Maybe<RemoveOrgTagsMutationPayload>;
  rescheduleBooking?: Maybe<RescheduleBookingMutationPayload>;
  rescheduleEventParent?: Maybe<RescheduleEventParentMutationPayload>;
  /** mutation to set auth code recieved from Asana via redirect uri upon successful authentication. */
  saveAsanaCredentials?: Maybe<SaveAsanaCredentialsPayload>;
  saveTeamSettings?: Maybe<SaveTeamSettingsMutationPayload>;
  saveTeamUserSettings?: Maybe<SaveTeamUserSettingsMutationPayload>;
  saveUninstallResponse?: Maybe<SaveUninstallResponseMutationPayload>;
  scheduleNewEvent?: Maybe<ScheduleNewEventMutationPayload>;
  scheduleNewEventV2?: Maybe<ScheduleNewEventV2MutationPayload>;
  scheduleNewSmartHold?: Maybe<ScheduleNewSmartHoldMutationPayload>;
  sendBillingGroupRequestEmail?: Maybe<SendBillingGroupRequestEmailMutationPayload>;
  sendCalAuditInviteEmail?: Maybe<SendCalAuditInviteEmailPayload>;
  setPreferredRooms?: Maybe<SetPreferredRoomsMutationPayload>;
  setPrimaryTeam?: Maybe<SetPrimaryTeamMutationPayload>;
  setWorkAddressForUser?: Maybe<SetWorkAddressForUserMutationPayload>;
  submitHubspotForm?: Maybe<SubmitHubspotFormMutationPayload>;
  sudoDeactivateUser?: Maybe<SudoDeactivateUserMutationPayload>;
  sudoDeleteEverything?: Maybe<SudoDeleteEverythingMutationPayload>;
  sudoModifyUser?: Maybe<SudoModifyUserMutationPayload>;
  sudoResetFlowState?: Maybe<SudoResetFlowStateMutationPayload>;
  sudoSwitchUser?: Maybe<SudoSwitchUserMutationPayload>;
  sudoTriggerClientUpdate?: Maybe<SudoTriggerClientUpdateMutationPayload>;
  sudoUpdateWaitlist?: Maybe<SudoUpdateWaitlistMutationPayload>;
  sudoUpdateWhitelistedDomains?: Maybe<SudoUpdateWhitelistedDomainsMutationPayload>;
  sudoUpdateWhitelistedEmails?: Maybe<SudoUpdateWhitelistedEmailsMutationPayload>;
  toggleAutoSyncForBillingGroup?: Maybe<ToggleAutoSyncForBillingGroupMutationPayload>;
  triggerDefragRun?: Maybe<TriggerDefragRunMutationPayload>;
  unpauseEvent?: Maybe<UnpauseEventMutationPayload>;
  unsubscribeEmail?: Maybe<UnsubscribeEmailPayload>;
  unsyncFocusTimeBlock?: Maybe<UnsyncFocusTimeBlockMutationPayload>;
  unsyncFocusTimeEvent?: Maybe<UnsyncFocusTimeEventMutationPayload>;
  updateDeviceToken?: Maybe<UpdateDeviceTokenPayload>;
  updateEventColoringSettings?: Maybe<EventColoringSettingsMutationsPayload>;
  updateEventResponseStatus?: Maybe<UpdateEventResponseStatusMutationPayload>;
  updateFlagsForUser?: Maybe<UpdateFlagsForUserMutationPayload>;
  updateFlowStateUser?: Maybe<UpdateUserFlowMutationPayload>;
  updateFlowStateUserOrg?: Maybe<UpdateUserOrgFlowMutationPayload>;
  /** Update whether a Clockwise Link is marked active or inactive */
  updateLinkActive?: Maybe<UpdateLinkActivePayload>;
  /** Update a meeting setting, which represents a scheduling link. */
  updateMeetingSettings?: Maybe<UpdateMeetingSettingsPayload>;
  updateOrgInvite?: Maybe<UpdateOrgInvitePayload>;
  updateSetting?: Maybe<UpdateSettingMutationPayload>;
  updateSettings?: Maybe<UpdateSettingsMutationPayload>;
  updateShadowCalendarSettings?: Maybe<UpdateShadowCalendarSettingsMutationPayload>;
  updateSlackAccount?: Maybe<UpdateSlackAccountMutationPayload>;
  updateSlackAccountForTeam?: Maybe<UpdateSlackAccountForTeamMutationPayload>;
  updateSmartHoldSyncSettings?: Maybe<UpdateSmartHoldSyncSettingsMutationPayload>;
  updateSuggestedOrgInvite?: Maybe<UpdateSuggestedOrgInvitePayload>;
  updateTeam?: Maybe<UpdateTeamMutationPayload>;
  updateToggleEventColoringSettings?: Maybe<ToggleEventColoringSettingsMutationsPayload>;
  updateUserDefinedTeam?: Maybe<UpdateUserDefinedTeamMutationPayload>;
  /** Update the user's shortname that is used for generating Clockwise Link URLs. */
  updateUserShortname?: Maybe<UpdateUserShortnamePayload>;
  updateWorkingHours?: Maybe<UpdateWorkingHoursMutationPayload>;
  upsertEmailTriage?: Maybe<UpsertEmailTriageMutationPayload>;
  upsertFocusTime?: Maybe<UpsertFocusTimeMutationPayload>;
  upsertLunch?: Maybe<UpsertLunchMutationPayload>;
  upsertMeetingRelief?: Maybe<UpsertMeetingReliefMutationPayload>;
  upsertNonUserDefragEmailResponse?: Maybe<UpsertNonUserDefragEmailResponsePayload>;
  upsertPreferredWork?: Maybe<UpsertPreferredWorkMutationPayload>;
  upsertTravelTime?: Maybe<UpsertTravelTimeMutationPayload>;
  userSurveyResponseMutations?: Maybe<SaveUserSurveyResponsesMutationPayload>;
  userSurveyResponseWrapperMutations?: Maybe<SaveUserSurveyResponseWrapperMutationPayload>;
  validateSlackChannelBySendingMessage?: Maybe<ValidateSlackChannelBySendingMessageMutationPayload>;
  weeklySummaryResponse?: Maybe<WeeklySummaryResponseMutationPayload>;
};

export type MutationAcceptDefaultOrgTagsArgs = {
  input: AcceptDefaultOrgTagsMutationInput;
};

export type MutationAddAdminForBillingGroupArgs = {
  input: AddAdminForBillingGroupMutationInput;
};

export type MutationAddAndRemoveOrgTagsArgs = {
  input: AddAndRemoveOrgTagsMutationInput;
};

export type MutationAddManualMembersForBillingGroupArgs = {
  input: AddManualMembersForBillingGroupMutationInput;
};

export type MutationAddOrgTagsArgs = {
  input: AddOrgTagsMutationInput;
};

export type MutationAddSlackAccountArgs = {
  input: AddSlackAccountMutationInput;
};

export type MutationAddSlackAccountForTeamArgs = {
  input: AddSlackAccountForTeamMutationInput;
};

export type MutationAddSlackAccountV2Args = {
  input: AddSlackAccountV2MutationInput;
};

export type MutationAddZoomAccountArgs = {
  input: AddZoomAccountMutationInput;
};

export type MutationBatchAddAndRemoveOrgTagsArgs = {
  input: BatchAddAndRemoveOrgTagsMutationInput;
};

export type MutationBatchModifyAutopilotForEventsArgs = {
  input: BatchModifyAutopilotForEventsMutationInput;
};

export type MutationBatchUpdateFlexibilityArgs = {
  input: BatchModifyFlexibilityInput;
};

export type MutationCancelBookingArgs = {
  input: CancelBookingMutationInput;
};

export type MutationCreateBookingArgs = {
  input: CreateBookingMutationInput;
};

export type MutationCreateDataSourceArgs = {
  input: CreateDataSourceMutationInput;
};

export type MutationCreateMeetingSettingsArgs = {
  input: CreateMeetingSettingsInput;
};

export type MutationCreateOrgSubscriptionStripeArgs = {
  input: CreateOrgSubscriptionStripeInput;
};

export type MutationCreateTeamArgs = {
  input: CreateTeamMutationInput;
};

export type MutationCreateTeamAndTeamSubscriptionStripeArgs = {
  input: CreateTeamAndTeamSubscriptionStripeInput;
};

export type MutationCreateTeamCalendarArgs = {
  input: CreateTeamCalendarMutationInput;
};

export type MutationCreateTeamSubscriptionStripeArgs = {
  input: CreateTeamSubscriptionStripeInput;
};

export type MutationDeactivateUserArgs = {
  input: DeactivateUserMutationInput;
};

export type MutationDeleteAsanaCredentialsArgs = {
  input: DeleteAsanaCredentialsInput;
};

export type MutationDeleteDataSourceArgs = {
  input: DeleteDataSourceInput;
};

export type MutationDeleteEventArgs = {
  input: DeleteEventMutationInput;
};

export type MutationDeleteMeetingSettingsArgs = {
  input: DeleteMeetingSettingsInput;
};

export type MutationDeleteTeamArgs = {
  input: DeleteTeamMutationInput;
};

export type MutationDeleteUserLevelZoomAccountArgs = {
  input: DeleteUserLevelZoomAccountMutationInput;
};

export type MutationDeleteZoomAccountArgs = {
  input: DeleteZoomAccountMutationInput;
};

export type MutationDisableDataSourceSyncArgs = {
  input: DisableDataSourceSyncInput;
};

export type MutationEnableDataSourceSyncArgs = {
  input: EnableDataSourceSyncInput;
};

export type MutationEnableOrDisableTeamSyncForEventArgs = {
  input: EnableOrDisableTeamSyncForEventInput;
};

export type MutationExecuteCliCommandArgs = {
  input: ExecuteCliCommandMutationInput;
};

export type MutationFindOrCreateLinkNameArgs = {
  input: FindOrCreateLinkNameInput;
};

export type MutationInstallSlackAppArgs = {
  input: InstallSlackAppMutationInput;
};

export type MutationInvitePersonsToTeamArgs = {
  input: InvitePersonsToTeamInput;
};

export type MutationInviteToBillingGroupArgs = {
  input: InviteToBillingGroupMutationInput;
};

export type MutationJoinWaitlistArgs = {
  input: JoinWaitlistMutationInput;
};

export type MutationLoginInsightsUserArgs = {
  input: LoginInsightsUserInput;
};

export type MutationLoginInsightsUserOfflineArgs = {
  input: LoginInsightsUserOfflineInput;
};

export type MutationLoginMicrosoftUserArgs = {
  input: LoginMicrosoftUserMutationInput;
};

export type MutationLoginUserArgs = {
  input: LoginUserMutationInput;
};

export type MutationLogoutInsightsUserArgs = {
  input: LogoutInsightsUserInput;
};

export type MutationLogoutUserArgs = {
  input: LogoutUserMutationInput;
};

export type MutationMarkDefragValueKnobsAsAcceptedArgs = {
  input: MarkDefragValueKnobsAsAcceptedMutationInput;
};

export type MutationMarkDefragValueKnobsAsDismissedArgs = {
  input: MarkDefragValueKnobsAsDismissedMutationInput;
};

export type MutationMarkDefragValueKnobsAsPresentedArgs = {
  input: MarkDefragValueKnobsAsPresentedMutationInput;
};

export type MutationMarkSeenFeedSuggestionArgs = {
  input: MarkSeenFeedSuggestionMutationInput;
};

export type MutationMaybeOnboardOrgArgs = {
  input: MaybeOnboardOrgMutationInput;
};

export type MutationOverrideSyncStatusForUserEventArgs = {
  input: OverrideSyncStatusForUserEventMutationInput;
};

export type MutationPatchBillingGroupArgs = {
  input: PatchBillingGroupMutationInput;
};

export type MutationPatchSlackSettingsArgs = {
  input: PatchSlackSettingsMutationInput;
};

export type MutationPreAddOrgTagsArgs = {
  input: PreAddOrgTagsMutationInput;
};

export type MutationPreSetEventFlexibilityArgs = {
  input: PreSetFlexibilityInput;
};

export type MutationRecordChromeInstallArgs = {
  input: RecordChromeInstallMutationInput;
};

export type MutationRecordChromeUninstallArgs = {
  input: RecordChromeUninstallMutationInput;
};

export type MutationRecordDefragResponseArgs = {
  input: RecordDefragResponseMutationInput;
};

export type MutationRecordImpressionArgs = {
  input: RecordImpressionMutationInput;
};

export type MutationRegisterEmailUpdatesArgs = {
  input: RegisterEmailUpdatesInput;
};

export type MutationRemoveAdminForBillingGroupArgs = {
  input: RemoveAdminForBillingGroupMutationInput;
};

export type MutationRemoveGoalArgs = {
  input: RemoveGoalMutationInput;
};

export type MutationRemoveLunchHoldArgs = {
  input: RemoveLunchHoldMutationInput;
};

export type MutationRemoveManualMembersForBillingGroupArgs = {
  input: RemoveManualMembersForBillingGroupMutationInput;
};

export type MutationRemoveOrgTagsArgs = {
  input: RemoveOrgTagsMutationInput;
};

export type MutationRescheduleBookingArgs = {
  input: RescheduleBookingMutationInput;
};

export type MutationRescheduleEventParentArgs = {
  input: RescheduleEventParentMutationInput;
};

export type MutationSaveAsanaCredentialsArgs = {
  input: SaveAsanaCredentialsInput;
};

export type MutationSaveTeamSettingsArgs = {
  input: SaveTeamSettingsMutationInput;
};

export type MutationSaveTeamUserSettingsArgs = {
  input: SaveTeamUserSettingsMutationInput;
};

export type MutationSaveUninstallResponseArgs = {
  input: SaveUninstallResponseMutationInput;
};

export type MutationScheduleNewEventArgs = {
  input: ScheduleNewEventMutationInput;
};

export type MutationScheduleNewEventV2Args = {
  input: ScheduleNewEventV2MutationInput;
};

export type MutationScheduleNewSmartHoldArgs = {
  input: ScheduleNewSmartHoldMutationInput;
};

export type MutationSendBillingGroupRequestEmailArgs = {
  input: SendBillingGroupRequestEmailMutationInput;
};

export type MutationSendCalAuditInviteEmailArgs = {
  input: SendCalAuditInviteEmailInput;
};

export type MutationSetPreferredRoomsArgs = {
  input: SetPreferredRoomsMutationInput;
};

export type MutationSetPrimaryTeamArgs = {
  input: SetPrimaryTeamMutationInput;
};

export type MutationSetWorkAddressForUserArgs = {
  input: SetWorkAddressForUserMutationInput;
};

export type MutationSubmitHubspotFormArgs = {
  input: SubmitHubspotFormMutationInput;
};

export type MutationSudoDeactivateUserArgs = {
  input: SudoDeactivateUserMutationInput;
};

export type MutationSudoDeleteEverythingArgs = {
  input: SudoDeleteEverythingMutationInput;
};

export type MutationSudoModifyUserArgs = {
  input: SudoModifyUserMutationInput;
};

export type MutationSudoResetFlowStateArgs = {
  input: SudoResetFlowStateMutationInput;
};

export type MutationSudoSwitchUserArgs = {
  input: SudoSwitchUserMutationInput;
};

export type MutationSudoTriggerClientUpdateArgs = {
  input: SudoTriggerClientUpdateMutationInput;
};

export type MutationSudoUpdateWaitlistArgs = {
  input: SudoUpdateWaitlistMutationInput;
};

export type MutationSudoUpdateWhitelistedDomainsArgs = {
  input: SudoUpdateWhitelistedDomainsMutationInput;
};

export type MutationSudoUpdateWhitelistedEmailsArgs = {
  input: SudoUpdateWhitelistedEmailsMutationInput;
};

export type MutationToggleAutoSyncForBillingGroupArgs = {
  input: ToggleAutoSyncForBillingGroupMutationInput;
};

export type MutationTriggerDefragRunArgs = {
  input: TriggerDefragRunMutationInput;
};

export type MutationUnpauseEventArgs = {
  input: UnpauseEventMutationInput;
};

export type MutationUnsubscribeEmailArgs = {
  input: UnsubscribeEmailInput;
};

export type MutationUnsyncFocusTimeBlockArgs = {
  input: UnsyncFocusTimeBlockMutationInput;
};

export type MutationUnsyncFocusTimeEventArgs = {
  input: UnsyncFocusTimeEventMutationInput;
};

export type MutationUpdateDeviceTokenArgs = {
  input: UpdateDeviceTokenInput;
};

export type MutationUpdateEventColoringSettingsArgs = {
  input: EventColoringSettingsMutationsInput;
};

export type MutationUpdateEventResponseStatusArgs = {
  input: UpdateEventResponseStatusMutationInput;
};

export type MutationUpdateFlagsForUserArgs = {
  input: UpdateFlagsForUserMutationInput;
};

export type MutationUpdateFlowStateUserArgs = {
  input: UpdateUserFlowMutationInput;
};

export type MutationUpdateFlowStateUserOrgArgs = {
  input: UpdateUserOrgFlowMutationInput;
};

export type MutationUpdateLinkActiveArgs = {
  input: UpdateLinkActiveInput;
};

export type MutationUpdateMeetingSettingsArgs = {
  input: UpdateMeetingSettingsInput;
};

export type MutationUpdateOrgInviteArgs = {
  input: UpdateOrgInviteInput;
};

export type MutationUpdateSettingArgs = {
  input: UpdateSettingMutationInput;
};

export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsMutationInput;
};

export type MutationUpdateShadowCalendarSettingsArgs = {
  input: UpdateShadowCalendarSettingsMutationInput;
};

export type MutationUpdateSlackAccountArgs = {
  input: UpdateSlackAccountMutationInput;
};

export type MutationUpdateSlackAccountForTeamArgs = {
  input: UpdateSlackAccountForTeamMutationInput;
};

export type MutationUpdateSmartHoldSyncSettingsArgs = {
  input: UpdateSmartHoldSyncSettingsMutationInput;
};

export type MutationUpdateSuggestedOrgInviteArgs = {
  input: UpdateSuggestedOrgInviteInput;
};

export type MutationUpdateTeamArgs = {
  input: UpdateTeamMutationInput;
};

export type MutationUpdateToggleEventColoringSettingsArgs = {
  input: ToggleEventColoringSettingsMutationsInput;
};

export type MutationUpdateUserDefinedTeamArgs = {
  input: UpdateUserDefinedTeamMutationInput;
};

export type MutationUpdateUserShortnameArgs = {
  input: UpdateUserShortnameInput;
};

export type MutationUpdateWorkingHoursArgs = {
  input: UpdateWorkingHoursMutationInput;
};

export type MutationUpsertEmailTriageArgs = {
  input: UpsertEmailTriageMutationInput;
};

export type MutationUpsertFocusTimeArgs = {
  input: UpsertFocusTimeMutationInput;
};

export type MutationUpsertLunchArgs = {
  input: UpsertLunchMutationInput;
};

export type MutationUpsertMeetingReliefArgs = {
  input: UpsertMeetingReliefMutationInput;
};

export type MutationUpsertNonUserDefragEmailResponseArgs = {
  input: UpsertNonUserDefragEmailResponseInput;
};

export type MutationUpsertPreferredWorkArgs = {
  input: UpsertPreferredWorkMutationInput;
};

export type MutationUpsertTravelTimeArgs = {
  input: UpsertTravelTimeMutationInput;
};

export type MutationUserSurveyResponseMutationsArgs = {
  input: SaveUserSurveyResponsesMutationInput;
};

export type MutationUserSurveyResponseWrapperMutationsArgs = {
  input: SaveUserSurveyResponseWrapperMutationInput;
};

export type MutationValidateSlackChannelBySendingMessageArgs = {
  input: ValidateSlackChannelBySendingMessageMutationInput;
};

export type MutationWeeklySummaryResponseArgs = {
  input: WeeklySummaryResponseMutationInput;
};

export type AcceptDefaultOrgTagsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  suggestedAnnotationRelayId: Scalars["String"];
};

export type AcceptDefaultOrgTagsMutationPayload = {
  __typename: "AcceptDefaultOrgTagsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent?: Maybe<EventParent>;
};

export type AddAdminForBillingGroupMutationInput = {
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  userId: Scalars["String"];
};

export type AddAdminForBillingGroupMutationPayload = {
  __typename: "AddAdminForBillingGroupMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type AddAndRemoveOrgTagsMutationInput = {
  calendarId?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  eventParentRelayId: Scalars["String"];
  moveRangeV3?: InputMaybe<MoveRangeInLocalTimeV3Input>;
  orgRelayId: Scalars["String"];
  tagNamesToRemove: Array<Scalars["String"]>;
  tagsToAdd?: InputMaybe<Array<TagInput>>;
};

export type MoveRangeInLocalTimeV3Input = {
  allowedEndTimeInclusive?: InputMaybe<DayOffsetTimeSlotInput>;
  allowedStartTimeInclusive?: InputMaybe<DayOffsetTimeSlotInput>;
};

export type DayOffsetTimeSlotInput = {
  dayOffset: Scalars["Int"];
  timeSlot: TimeSlot;
};

export type TagInput = {
  name: Scalars["String"];
  value?: InputMaybe<Scalars["String"]>;
};

export type AddAndRemoveOrgTagsMutationPayload = {
  __typename: "AddAndRemoveOrgTagsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent?: Maybe<EventParent>;
};

export type AddManualMembersForBillingGroupMutationInput = {
  addExclusions?: InputMaybe<Scalars["Boolean"]>;
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  personIds: Array<Scalars["String"]>;
};

export type AddManualMembersForBillingGroupMutationPayload = {
  __typename: "AddManualMembersForBillingGroupMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type AddOrgTagsMutationInput = {
  calendarId?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  debuggingReason?: InputMaybe<Scalars["String"]>;
  eventParentRelayId: Scalars["String"];
  moveRangeV3?: InputMaybe<MoveRangeInLocalTimeV3Input>;
  orgRelayId: Scalars["String"];
  tags?: InputMaybe<Array<TagInput>>;
};

export type AddOrgTagsMutationPayload = {
  __typename: "AddOrgTagsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent?: Maybe<EventParent>;
};

export type AddSlackAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  redirect: Scalars["String"];
  verificationCode: Scalars["String"];
};

export type AddSlackAccountMutationPayload = {
  __typename: "AddSlackAccountMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type AddSlackAccountForTeamMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  redirect: Scalars["String"];
  teamId: Scalars["String"];
  verificationCode: Scalars["String"];
};

export type AddSlackAccountForTeamMutationPayload = {
  __typename: "AddSlackAccountForTeamMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type AddSlackAccountV2MutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  redirect: Scalars["String"];
  verificationCode: Scalars["String"];
};

export type AddSlackAccountV2MutationPayload = {
  __typename: "AddSlackAccountV2MutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type AddZoomAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  isUserLevelZoomAccount?: InputMaybe<Scalars["Boolean"]>;
  orgRelayId: Scalars["String"];
  redirect: Scalars["String"];
  verificationCode: Scalars["String"];
};

export type AddZoomAccountMutationPayload = {
  __typename: "AddZoomAccountMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type BatchAddAndRemoveOrgTagsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  tagPairings?: InputMaybe<Array<BatchAddAndRemoveOrgTagsTagPairings>>;
};

export type BatchAddAndRemoveOrgTagsTagPairings = {
  calendarId?: InputMaybe<Scalars["String"]>;
  eventParentRelayId: Scalars["String"];
  moveRangeV3?: InputMaybe<MoveRangeInLocalTimeV3Input>;
  orgRelayId: Scalars["String"];
  tagNamesToRemove: Array<Scalars["String"]>;
  tagsToAdd?: InputMaybe<Array<TagInput>>;
};

export type BatchAddAndRemoveOrgTagsMutationPayload = {
  __typename: "BatchAddAndRemoveOrgTagsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParents?: Maybe<Array<EventParent>>;
};

export type BatchModifyAutopilotForEventsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  events?: InputMaybe<Array<AutopilotEventToModify>>;
  orgRelayId: Scalars["String"];
};

/** Events to modify */
export type AutopilotEventToModify = {
  externalEventId: Scalars["String"];
  movementType: ModifyAutopilotForEventMovementTypeEnum;
};

export enum ModifyAutopilotForEventMovementTypeEnum {
  Day = "Day",
  None = "None",
  Week = "Week",
}

export type BatchModifyAutopilotForEventsMutationPayload = {
  __typename: "BatchModifyAutopilotForEventsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type BatchModifyFlexibilityInput = {
  /** Event ids that should be updated to day flexibility */
  dayFlexibleEvents?: Array<Scalars["String"]>;
  /** Events that should be updated to day of week flexibility, and the allowed days for the flexibility */
  dayOfWeekFlexibleEvents?: Array<DayOfWeekFlexibleEvent>;
  /** Event ids that should not be flexible */
  notFlexibleEvents?: Array<Scalars["String"]>;
  /** The relay org id */
  orgRelayId?: InputMaybe<Scalars["ID"]>;
  /** Event ids that should be updated to week flexibility */
  weekFlexibleEvents?: Array<Scalars["String"]>;
};

export type DayOfWeekFlexibleEvent = {
  /** The days that this event is allowed to move among */
  allowedDays: Array<DayOfWeek>;
  /** The backend event id */
  eventId: Scalars["String"];
};

export type CancelBookingMutationInput = {
  /** Id of booking. */
  bookingId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Optional reason for cancellation. */
  reason?: InputMaybe<Scalars["String"]>;
};

export type CancelBookingMutationPayload = {
  __typename: "CancelBookingMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateBookingMutationInput = {
  body: CreateBookingBody;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** fetchSchedulingLinkDetails formatted request to refetch the date of booking to ensure slot is still available. */
  dateRefetchBody?: InputMaybe<ZonedDayTimeSlotRangeInput>;
  /** A user's configurable id, like a username, for their scheduling links. Unique among all Clockwise users. */
  linkName: Scalars["String"];
  slug: Scalars["String"];
};

export type CreateBookingBody = {
  attendeeEmailAddress: Scalars["String"];
  attendeeName: Scalars["String"];
  eventStartMillis: Scalars["BigInt"];
  notes?: InputMaybe<Scalars["String"]>;
  timeZone: Scalars["String"];
};

export type CreateBookingMutationPayload = {
  __typename: "CreateBookingMutationPayload";
  bookedDateOrDateTime: Scalars["String"];
  bookedTimeZone: Scalars["String"];
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateDataSourceMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  googleOfflineCode: Scalars["String"];
  isPersonal?: InputMaybe<Scalars["Boolean"]>;
  /** The front-end ID of the organization the work calendar is part of */
  orgRelayId: Scalars["String"];
};

export type CreateDataSourceMutationPayload = {
  __typename: "CreateDataSourceMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  /** The new data source that was just created */
  dataSource?: Maybe<DataSource>;
  dataSourceAuthError?: Maybe<DataSourceAuthError>;
  user?: Maybe<User>;
};

export enum DataSourceAuthError {
  GenericError = "GenericError",
  SameDomainError = "SameDomainError",
}

export type CreateMeetingSettingsInput = {
  body?: InputMaybe<MeetingSettingsInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type MeetingSettingsInput = {
  allowFifteenMinuteMarkBooking: Scalars["Boolean"];
  availabilityType: AvailabilityType;
  bookableHours: BookableHoursEnum;
  bookingTimeBufferHours: Scalars["Int"];
  bookOnNoMeetingDay: Scalars["Boolean"];
  description?: InputMaybe<Scalars["String"]>;
  highlightBestTimes: Scalars["Boolean"];
  id?: InputMaybe<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  locationSettings: LocationSettingsInput;
  name: Scalars["String"];
  slug: Scalars["String"];
  timingSettings: TimingSettingsInput;
};

export type LocationSettingsInput = {
  locationDetails?: InputMaybe<Scalars["String"]>;
  locationType: LinkLocationType;
};

export type TimingSettingsInput = {
  durationMinutes: Scalars["Int"];
  periodType: PeriodType;
  timeRange: LinkTimeRangeInput;
};

export type LinkTimeRangeInput = {
  rangeEndTime?: InputMaybe<Scalars["String"]>;
  rangeEndTimeMillis?: InputMaybe<Scalars["Int"]>;
  rangeStartTime?: InputMaybe<Scalars["String"]>;
  rangeStartTimeMillis?: InputMaybe<Scalars["Int"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
  windowSizeDays?: InputMaybe<Scalars["Int"]>;
};

export type CreateMeetingSettingsPayload = {
  __typename: "CreateMeetingSettingsPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  meetingSettingsErrorable?: Maybe<MeetingSettingsErrorable>;
};

export type CreateOrgSubscriptionStripeInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  initialUsers: Array<Scalars["String"]>;
  numSeats?: InputMaybe<Scalars["Int"]>;
  orgRelayId: Scalars["ID"];
  recurrence: CreateOrgSubscriptionStripeRecurrenceEnum;
  stripePaymentMethodId: Scalars["String"];
};

export enum CreateOrgSubscriptionStripeRecurrenceEnum {
  Monthly = "Monthly",
  Yearly = "Yearly",
}

export type CreateOrgSubscriptionStripePayload = {
  __typename: "CreateOrgSubscriptionStripePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  stripeError?: Maybe<StripeError>;
};

/** Stripe error */
export type StripeError = {
  __typename: "StripeError";
  code?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
};

export type CreateTeamMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  setAsPrimary?: InputMaybe<Scalars["Boolean"]>;
  teamMembers: Array<TeamRoleAndPersonIdInput>;
  teamName: Scalars["String"];
  teamType: TeamType;
};

export type TeamRoleAndPersonIdInput = {
  personId: Scalars["String"];
  role: TeamMemberRole;
};

export enum TeamType {
  Managerial = "Managerial",
  Other = "Other",
}

export type CreateTeamMutationPayload = {
  __typename: "createTeamMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  team: Team;
};

export type CreateTeamAndTeamSubscriptionStripeInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["ID"];
  personId: Scalars["ID"];
  seatCount: Scalars["Int"];
  stripePaymentMethodId: Scalars["String"];
  subscriptionInterval: SubscriptionInterval;
  userEmail: Scalars["String"];
};

export enum SubscriptionInterval {
  Monthly = "Monthly",
  Yearly = "Yearly",
}

export type CreateTeamAndTeamSubscriptionStripePayload = {
  __typename: "CreateTeamAndTeamSubscriptionStripePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  stripeError?: Maybe<StripeError>;
  team: Team;
};

export type CreateTeamCalendarMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  teamId: Scalars["String"];
};

export type CreateTeamCalendarMutationPayload = {
  __typename: "createTeamCalendarMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateTeamSubscriptionStripeInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["ID"];
  seatCount: Scalars["Int"];
  stripePaymentMethodId: Scalars["String"];
  subscriptionInterval: SubscriptionInterval;
  teamId: Scalars["String"];
};

export type CreateTeamSubscriptionStripePayload = {
  __typename: "CreateTeamSubscriptionStripePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  stripeError?: Maybe<StripeError>;
  team: Team;
};

export type DeactivateUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type DeactivateUserMutationPayload = {
  __typename: "DeactivateUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  viewer?: Maybe<Viewer>;
};

export type DeleteAsanaCredentialsInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** org id */
  orgRelayId: Scalars["ID"];
};

export type DeleteAsanaCredentialsPayload = {
  __typename: "DeleteAsanaCredentialsPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteDataSourceInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The relay ID of the organization the calendar is part of */
  orgRelayId: Scalars["String"];
  /** The ID of the calendar that is being deleted */
  sourceCalId: Scalars["String"];
};

export type DeleteDataSourcePayload = {
  __typename: "DeleteDataSourcePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteEventMutationInput = {
  calendarId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  emailAddress: Scalars["ID"];
  externalEventId: Scalars["String"];
  /** optional, when true will delete an entire recurrence */
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
};

export type DeleteEventMutationPayload = {
  __typename: "DeleteEventMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteMeetingSettingsInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  meetingSettingsId: Scalars["String"];
};

export type DeleteMeetingSettingsPayload = {
  __typename: "DeleteMeetingSettingsPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteTeamMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  teamId: Scalars["String"];
};

export type DeleteTeamMutationPayload = {
  __typename: "deleteTeamMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  deletedTeamId: Scalars["String"];
};

export type DeleteUserLevelZoomAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
};

export type DeleteUserLevelZoomAccountMutationPayload = {
  __typename: "DeleteUserLevelZoomAccountMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteZoomAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  zoomAccountId: Scalars["String"];
};

export type DeleteZoomAccountMutationPayload = {
  __typename: "DeleteZoomAccountMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  deletedZoomAccountId: Scalars["String"];
};

export type DisableDataSourceSyncInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The relay ID of the organization the calendar is part of */
  orgRelayId: Scalars["String"];
  /** The ID of the calendar that is being disabled */
  sourceCalId: Scalars["String"];
};

export type DisableDataSourceSyncPayload = {
  __typename: "DisableDataSourceSyncPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  dataSource?: Maybe<DataSource>;
};

export type EnableDataSourceSyncInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The front-end ID of the organization the work calendar is part of */
  orgRelayId: Scalars["String"];
  /** The ID of the calendar that is being synced to the work calendar */
  sourceCalId: Scalars["String"];
};

export type EnableDataSourceSyncPayload = {
  __typename: "EnableDataSourceSyncPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  dataSource?: Maybe<DataSource>;
};

export type EnableOrDisableTeamSyncForEventInput = {
  calendarId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  disable: Scalars["Boolean"];
  externalEventId: Scalars["String"];
  orgRelayId: Scalars["ID"];
};

export type EnableOrDisableTeamSyncForEventPayload = {
  __typename: "EnableOrDisableTeamSyncForEventPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  disabled: Scalars["Boolean"];
};

export type ExecuteCliCommandMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  command: Scalars["String"];
  options?: InputMaybe<Array<CliOptionInput>>;
};

export type CliOptionInput = {
  name: Scalars["String"];
  values: Array<Scalars["String"]>;
};

export type ExecuteCliCommandMutationPayload = {
  __typename: "ExecuteCliCommandMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  result: Scalars["String"];
};

export type FindOrCreateLinkNameInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type FindOrCreateLinkNamePayload = {
  __typename: "FindOrCreateLinkNamePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  linkName?: Maybe<Scalars["String"]>;
  schedulingLinks?: Maybe<Array<SchedulingLink>>;
};

export type InstallSlackAppMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  installSlackAppCode: Scalars["String"];
  redirect: Scalars["String"];
  useOAuthV2?: Scalars["Boolean"];
};

export type InstallSlackAppMutationPayload = {
  __typename: "InstallSlackAppMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  installSlackAppResult?: Maybe<Scalars["Boolean"]>;
  viewer?: Maybe<Viewer>;
};

export type InvitePersonsToTeamInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  personIds: Array<Scalars["String"]>;
  teamId: Scalars["String"];
};

export type InvitePersonsToTeamPayload = {
  __typename: "InvitePersonsToTeamPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type InviteToBillingGroupMutationInput = {
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  personIds: Array<Scalars["String"]>;
};

export type InviteToBillingGroupMutationPayload = {
  __typename: "InviteToBillingGroupMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type JoinWaitlistMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  role?: InputMaybe<Scalars["String"]>;
};

export type JoinWaitlistMutationPayload = {
  __typename: "JoinWaitlistMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  response: WaitlistSignupResponse;
};

export enum WaitlistSignupResponse {
  Allowed = "Allowed",
  Claimed = "Claimed",
  Queued = "Queued",
}

export type LoginInsightsUserInput = {
  accessToken: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  oauthType: OAuthType;
};

export enum OAuthType {
  Google = "Google",
  Office365 = "Office365",
}

export type LoginInsightsUserPayload = {
  __typename: "LoginInsightsUserPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type LoginInsightsUserOfflineInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  codeOrToken: Scalars["String"];
  oauthType: OAuthType;
};

export type LoginInsightsUserOfflinePayload = {
  __typename: "LoginInsightsUserOfflinePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  externalImageUrl?: Maybe<Scalars["String"]>;
  familyName?: Maybe<Scalars["String"]>;
  givenName?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type LoginMicrosoftUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  microsoftAuthCode: Scalars["String"];
  redirectUri: Scalars["String"];
};

export type LoginMicrosoftUserMutationPayload = {
  __typename: "LoginMicrosoftUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  loginStatus: LoginStatus;
  operation?: Maybe<RefreshTokenResultOperationEnum>;
  orgOperation?: Maybe<OrganizationOperationResultEnum>;
  verifyCodeMessage?: Maybe<Scalars["String"]>;
  verifyCodeResult?: Maybe<Scalars["Boolean"]>;
  viewer?: Maybe<Viewer>;
};

export enum LoginStatus {
  BlockedByAdmin = "BlockedByAdmin",
  Deactivating = "Deactivating",
  GoogleApiAccessDisabled = "GoogleApiAccessDisabled",
  GoogleContactSharingDisabled = "GoogleContactSharingDisabled",
  NoCrawl = "NoCrawl",
  PersonalEmail = "PersonalEmail",
  SecondaryDomainUsed = "SecondaryDomainUsed",
  Success = "Success",
  WaitlistedEmail = "WaitlistedEmail",
}

export enum RefreshTokenResultOperationEnum {
  Create = "Create",
  Fetch = "Fetch",
}

export enum OrganizationOperationResultEnum {
  Add = "Add",
  Create = "Create",
  Delete = "Delete",
  Fetch = "Fetch",
}

export type LoginUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  deviceIdAndRegistrationToken?: InputMaybe<DeviceIdAndRegistrationToken>;
  googleOfflineCode: Scalars["String"];
  verificationType?: InputMaybe<VerificationType>;
};

export type DeviceIdAndRegistrationToken = {
  /** A unique id that identifies the calling device */
  deviceId: Scalars["String"];
  /** The registration token of the device that allows sending push notifications */
  registrationToken: Scalars["String"];
};

export type LoginUserMutationPayload = {
  __typename: "LoginUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  loginStatus: LoginStatus;
  operation?: Maybe<RefreshTokenResultOperationEnum>;
  orgOperation?: Maybe<OrganizationOperationResultEnum>;
  verifyCodeMessage?: Maybe<Scalars["String"]>;
  verifyCodeResult?: Maybe<Scalars["Boolean"]>;
  viewer?: Maybe<Viewer>;
};

export type LogoutInsightsUserInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type LogoutInsightsUserPayload = {
  __typename: "LogoutInsightsUserPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type LogoutUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type LogoutUserMutationPayload = {
  __typename: "LogoutUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  viewer?: Maybe<Viewer>;
};

export type MarkDefragValueKnobsAsAcceptedMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  knobUrns: Array<InputMaybe<UrnInput>>;
  orgRelayId: Scalars["String"];
};

export type UrnInput = {
  id: Scalars["ID"];
  scope?: InputMaybe<UrnInput>;
  type?: InputMaybe<UrnType>;
  value?: InputMaybe<Scalars["String"]>;
};

export type MarkDefragValueKnobsAsAcceptedMutationPayload = {
  __typename: "MarkDefragValueKnobsAsAcceptedMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type MarkDefragValueKnobsAsDismissedMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  knobUrns: Array<InputMaybe<UrnInput>>;
  orgRelayId: Scalars["String"];
};

export type MarkDefragValueKnobsAsDismissedMutationPayload = {
  __typename: "MarkDefragValueKnobsAsDismissedMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type MarkDefragValueKnobsAsPresentedMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  knobUrns: Array<InputMaybe<UrnInput>>;
  orgRelayId: Scalars["String"];
};

export type MarkDefragValueKnobsAsPresentedMutationPayload = {
  __typename: "MarkDefragValueKnobsAsPresentedMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type MarkSeenFeedSuggestionMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The front-end ID for the feed suggestion to mark as seen */
  feedSuggestionRelayId: Scalars["String"];
  /** Optional enum value of primary action taken resulting in this suggestion being marked seen */
  primaryActionTaken?: InputMaybe<SuggestionActionResultType>;
};

export type MarkSeenFeedSuggestionMutationPayload = {
  __typename: "MarkSeenFeedSuggestionMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type MaybeOnboardOrgMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
};

export type MaybeOnboardOrgMutationPayload = {
  __typename: "MaybeOnboardOrgMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  crawlTest: OrgCrawlTest;
};

export type OverrideSyncStatusForUserEventMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  externalEventId: Scalars["String"];
};

export type OverrideSyncStatusForUserEventMutationPayload = {
  __typename: "OverrideSyncStatusForUserEventMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type PatchBillingGroupMutationInput = {
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  invitePolicy: InvitePolicyEnum;
  name?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
};

export type PatchBillingGroupMutationPayload = {
  __typename: "PatchBillingGroupMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type PatchSlackSettingsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["ID"];
  slackSettings: SlackSettingsInput;
};

export type SlackSettingsInput = {
  calendarStatus?: InputMaybe<SlackCalendarStatusSyncInput>;
  calendarStatusEnabled: Scalars["Boolean"];
  dailyDigestSettings?: InputMaybe<SlackDailyDigestSettingsInput>;
  dndSettings?: InputMaybe<SlackDndSettingsInput>;
  id: Scalars["ID"];
  includeMeetingCategory: Scalars["Boolean"];
  includeMeetingTitle: Scalars["Boolean"];
  notificationSettings?: InputMaybe<SlackNotificationSettingsInput>;
  slackTeamId: Scalars["String"];
  slackUserId: Scalars["String"];
};

export type SlackCalendarStatusSyncInput = {
  calendarStatusEnabled: Scalars["Boolean"];
  includeMeetingCategory: Scalars["Boolean"];
  includeMeetingTitle: Scalars["Boolean"];
};

export type SlackDailyDigestSettingsInput = {
  enabled: Scalars["Boolean"];
  timeSlot: DigestTimeSlot;
};

export type SlackDndSettingsInput = {
  focusTime: Scalars["Boolean"];
  meeting: Scalars["Boolean"];
};

export type SlackNotificationSettingsInput = {
  defragSummary: Scalars["Boolean"];
};

export type PatchSlackSettingsMutationPayload = {
  __typename: "PatchSlackSettingsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  slackSettings: SlackSettings;
};

export type PreAddOrgTagsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  moveRangeV3?: InputMaybe<MoveRangeInLocalTimeV3Input>;
  orgRelayId: Scalars["ID"];
  preAnnotation: PreAnnotationInput;
};

export type PreAnnotationInput = {
  attendees: Array<Scalars["String"]>;
  calendarId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  endTime: InferredEventTimeInput;
  startTime: InferredEventTimeInput;
  tags: Array<TagInput>;
  title?: InputMaybe<Scalars["String"]>;
};

export type InferredEventTimeInput = {
  date: Scalars["String"];
  time: Scalars["String"];
  timeZone?: InputMaybe<Scalars["String"]>;
};

export type PreAddOrgTagsMutationPayload = {
  __typename: "PreAddOrgTagsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type PreSetFlexibilityInput = {
  calendarId: Scalars["CalendarId"];
  orgRelayId: Scalars["ID"];
  /** Event flexibility configuration */
  preEventFlexibility: PreEventFlexibility;
  /** A set of event properties that allows us to identify an event without its id */
  preEventKey: PreEventKey;
};

export type PreEventFlexibility = {
  roomFlexibility: PreRoomFlexibility;
  scheduledBy?: EventScheduledBy;
  timeOfDayFlexibility: MoveRangeInLocalTimeV3Input;
  timeRangeFlexibility: PreTimeRangeFlexibility;
};

export enum PreRoomFlexibility {
  KeepCurrentRoom = "KeepCurrentRoom",
  SimilarRoomsAllowed = "SimilarRoomsAllowed",
}

export enum EventScheduledBy {
  /** The event was scheduled using Clockwise, and Clockwise should record the event as scheduled by the app */
  Clockwise = "Clockwise",
  Other = "Other",
}

/**
 *                         OneOf RangeFlexibility or DayOfWeekFlexibility.
 *
 *                         Because we don't have oneOf support yet, this is modelled
 * as nullable fields, where exactly one field must be non-null
 *                         This is unfortunately validated at runtime, but it's the best we have for now.
 */
export type PreTimeRangeFlexibility = {
  dayOfWeekFlexibility?: InputMaybe<PreDayOfWeekFlexibility>;
  rangeFlexibility?: InputMaybe<PreRangeFlexibility>;
};

export type PreDayOfWeekFlexibility = {
  allowedDays: Array<DayOfWeek>;
};

export enum PreRangeFlexibility {
  Day = "Day",
  Week = "Week",
}

export type PreEventKey = {
  attendees: Array<Scalars["CalendarId"]>;
  endTime: InferredEventTimeInput;
  startTime: InferredEventTimeInput;
  /** The event title, null if the event doesn't have a title */
  title?: InputMaybe<Scalars["String"]>;
};

export type PreSetFlexibilityResponse = {
  __typename: "PreSetFlexibilityResponse";
  successful: Scalars["Boolean"];
};

export type RecordChromeInstallMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type RecordChromeInstallMutationPayload = {
  __typename: "RecordChromeInstallMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RecordChromeUninstallMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type RecordChromeUninstallMutationPayload = {
  __typename: "RecordChromeUninstallMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RecordDefragResponseMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  feedback?: InputMaybe<DefragFeedback>;
  orgId: Scalars["String"];
  otherReason?: InputMaybe<Scalars["String"]>;
  preDefinedReasons?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  responseKeys: Array<InputMaybe<Scalars["JSON"]>>;
};

export enum DefragFeedback {
  LooksGood = "LooksGood",
  Maybe = "Maybe",
  Meh = "Meh",
}

export type RecordDefragResponseMutationPayload = {
  __typename: "RecordDefragResponseMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  response?: Maybe<Scalars["Boolean"]>;
};

export type RecordImpressionMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  treatmentType: Scalars["String"];
};

export type RecordImpressionMutationPayload = {
  __typename: "RecordImpressionMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RegisterEmailUpdatesInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
};

export type RegisterEmailUpdatesPayload = {
  __typename: "RegisterEmailUpdatesPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveAdminForBillingGroupMutationInput = {
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  forceDelete?: InputMaybe<Scalars["Boolean"]>;
  orgRelayId: Scalars["String"];
  userId: Scalars["String"];
};

export type RemoveAdminForBillingGroupMutationPayload = {
  __typename: "RemoveAdminForBillingGroupMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveGoalMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  goal: GoalInput;
  orgId: Scalars["String"];
};

export type GoalInput = {
  goalId: Scalars["String"];
  id: Scalars["ID"];
  isDeleted: Scalars["Boolean"];
  name: Scalars["String"];
  options?: InputMaybe<GoalOptionsInput>;
  otherUrns: Array<UrnInput>;
  targetUrn: UrnInput;
  valueUrn: UrnInput;
};

export type GoalOptionsInput = {
  syncToGoogle: Scalars["Boolean"];
};

export type RemoveGoalMutationPayload = {
  __typename: "RemoveGoalMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  goal?: Maybe<Goal>;
};

export type RemoveLunchHoldMutationInput = {
  calendarId?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  isPaused?: InputMaybe<Scalars["Boolean"]>;
  lunchEventId: Scalars["String"];
  orgRelayId: Scalars["String"];
};

export type RemoveLunchHoldMutationPayload = {
  __typename: "RemoveLunchHoldMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveManualMembersForBillingGroupMutationInput = {
  addExclusions?: InputMaybe<Scalars["Boolean"]>;
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  personIds: Array<Scalars["String"]>;
};

export type RemoveManualMembersForBillingGroupMutationPayload = {
  __typename: "RemoveManualMembersForBillingGroupMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveOrgTagsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  eventParentRelayId: Scalars["String"];
  orgRelayId: Scalars["String"];
  tagNames: Array<Scalars["String"]>;
};

export type RemoveOrgTagsMutationPayload = {
  __typename: "RemoveOrgTagsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent?: Maybe<EventParent>;
};

export type RescheduleBookingMutationInput = {
  body: RescheduleBookingBody;
  /** Id of booking */
  bookingId: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type RescheduleBookingBody = {
  /** End time of event in ISO 8601 format. */
  eventEndTime: Scalars["String"];
  /** Start time of event in ISO 8601 format. */
  eventStartTime: Scalars["String"];
  /** Optional reason for reschedule. */
  reasonForReschedule?: InputMaybe<Scalars["String"]>;
};

export type RescheduleBookingMutationPayload = {
  __typename: "RescheduleBookingMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RescheduleEventParentMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  eventTime: EventTimeInput;
  externalEventId: Scalars["String"];
  orgRelayId: Scalars["String"];
};

export type RescheduleEventParentMutationPayload = {
  __typename: "RescheduleEventParentMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent: EventParent;
};

export type SaveAsanaCredentialsInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Code recieved from Asana via redirect uri upon successful authentication. */
  code: Scalars["String"];
  /** org id */
  orgRelayId: Scalars["ID"];
  /** Redirect uri generated and used by the frontend for Oath. Required for future token exchange. */
  redirectUri: Scalars["String"];
};

export type SaveAsanaCredentialsPayload = {
  __typename: "SaveAsanaCredentialsPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type SaveTeamSettingsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  manageTeamCalendar?: InputMaybe<Scalars["Boolean"]>;
  minimumMinutesForSyncing?: InputMaybe<Scalars["Int"]>;
  noMeetingDayEmailOnScheduleOver?: InputMaybe<Scalars["Boolean"]>;
  noMeetingDayOfWeek?: InputMaybe<NoMeetingDayOfWeek>;
  orgRelayId: Scalars["String"];
  slackChannelId?: InputMaybe<Scalars["String"]>;
  slackChannelName?: InputMaybe<Scalars["String"]>;
  slackNotificationEnabled?: InputMaybe<Scalars["Boolean"]>;
  slackNotificationTimeSlot?: InputMaybe<TimeSlotEnum>;
  syncWFHEvents?: InputMaybe<Scalars["Boolean"]>;
  teamId: Scalars["String"];
  useNoMeetingDay?: InputMaybe<Scalars["Boolean"]>;
};

export type SaveTeamSettingsMutationPayload = {
  __typename: "saveTeamSettingsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  teamSettings: TeamSettings;
};

export type SaveTeamUserSettingsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  teamId: Scalars["String"];
  useNoMeetingDay?: InputMaybe<Scalars["Boolean"]>;
  useTeamCalendar?: InputMaybe<Scalars["Boolean"]>;
};

export type SaveTeamUserSettingsMutationPayload = {
  __typename: "saveTeamUserSettingsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  teamUserSettings: TeamUserSettings;
};

export type SaveUninstallResponseMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  considerClockwiseFuture?: InputMaybe<Scalars["String"]>;
  more?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  reason?: InputMaybe<Scalars["String"]>;
};

export type SaveUninstallResponseMutationPayload = {
  __typename: "SaveUninstallResponseMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type ScheduleNewEventMutationInput = {
  attendees?: InputMaybe<Array<Scalars["String"]>>;
  calendarId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  conflictResolutionDefragId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  duration: Scalars["Int"];
  includeZoomLink?: InputMaybe<Scalars["Boolean"]>;
  location?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  recurrenceOption?: RecurrenceOption;
  startSlot: DayTimeSlotInput;
  timeZone: Scalars["String"];
  title?: InputMaybe<Scalars["String"]>;
};

export enum RecurrenceOption {
  Bimonthly = "Bimonthly",
  Biweekly = "Biweekly",
  Monthly = "Monthly",
  None = "None",
  Weekly = "Weekly",
}

export type ScheduleNewEventMutationPayload = {
  __typename: "ScheduleNewEventMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent: EventParent;
};

export type ScheduleNewEventV2MutationInput = {
  attendees?: InputMaybe<Array<Scalars["String"]>>;
  calendarId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  conflictResolutionDefragId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  includeZoomLink?: InputMaybe<Scalars["Boolean"]>;
  location?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  recurrenceOption?: RecurrenceOption;
  timeRange: TimeRangeInput;
  timeZone: Scalars["String"];
  title?: InputMaybe<Scalars["String"]>;
};

export type TimeRangeInput = {
  endTime?: InputMaybe<EventTimeInput>;
  id: Scalars["ID"];
  startTime?: InputMaybe<EventTimeInput>;
};

export type ScheduleNewEventV2MutationPayload = {
  __typename: "ScheduleNewEventV2MutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent: EventParent;
};

export type ScheduleNewSmartHoldMutationInput = {
  calendarId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  smartHoldType: SmartHoldTypeEnum;
  timeRange: TimeRangeInput;
};

export enum SmartHoldTypeEnum {
  FocusTime = "FocusTime",
  Lunch = "Lunch",
  MeetingRelief = "MeetingRelief",
  MissingPriority = "MissingPriority",
  NoMeetingDay = "NoMeetingDay",
  OnboardingTestEvent = "OnboardingTestEvent",
  Pain = "Pain",
  PrepTime = "PrepTime",
  ShadowCalendar = "ShadowCalendar",
  SyncedEvent = "SyncedEvent",
  TeamEvent = "TeamEvent",
  TravelTime = "TravelTime",
}

export type ScheduleNewSmartHoldMutationPayload = {
  __typename: "ScheduleNewSmartHoldMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent: EventParent;
};

export type SendBillingGroupRequestEmailMutationInput = {
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  personId: Scalars["String"];
};

export type SendBillingGroupRequestEmailMutationPayload = {
  __typename: "SendBillingGroupRequestEmailMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type SendCalAuditInviteEmailInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  recipientEmail: Scalars["String"];
};

export type SendCalAuditInviteEmailPayload = {
  __typename: "SendCalAuditInviteEmailPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type SetPreferredRoomsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId?: InputMaybe<Scalars["ID"]>;
  preferredRoomIds: Array<Scalars["String"]>;
};

export type SetPreferredRoomsMutationPayload = {
  __typename: "SetPreferredRoomsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  suggestedRoomPreferences: SuggestedRoomPreferences;
};

export type SetPrimaryTeamMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  teamId: Scalars["String"];
};

export type SetPrimaryTeamMutationPayload = {
  __typename: "setPrimaryTeamMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  team: Team;
};

export type SetWorkAddressForUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  rawAddress?: InputMaybe<Scalars["String"]>;
};

export type SetWorkAddressForUserMutationPayload = {
  __typename: "SetWorkAddressForUserMutationPayload";
  address?: Maybe<Address>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type SubmitHubspotFormMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  formFields: Array<HubspotFormFieldInput>;
  formId: Scalars["String"];
};

export type HubspotFormFieldInput = {
  key: Scalars["String"];
  value: Scalars["String"];
};

export type SubmitHubspotFormMutationPayload = {
  __typename: "SubmitHubspotFormMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type SudoDeactivateUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
};

export type SudoDeactivateUserMutationPayload = {
  __typename: "SudoDeactivateUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type SudoDeleteEverythingMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type SudoDeleteEverythingMutationPayload = {
  __typename: "SudoDeleteEverythingMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type SudoModifyUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  status: Scalars["String"];
};

export type SudoModifyUserMutationPayload = {
  __typename: "SudoModifyUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  viewer?: Maybe<Viewer>;
};

export type SudoResetFlowStateMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  flowKey: Scalars["String"];
  orgRelayId?: InputMaybe<Scalars["String"]>;
};

export type SudoResetFlowStateMutationPayload = {
  __typename: "SudoResetFlowStateMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  flowState?: Maybe<FlowState>;
  viewer?: Maybe<Viewer>;
};

export type SudoSwitchUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  jwtType: Scalars["String"];
};

export type SudoSwitchUserMutationPayload = {
  __typename: "SudoSwitchUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  viewer?: Maybe<Viewer>;
};

export type SudoTriggerClientUpdateMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  force: Scalars["Boolean"];
};

export type SudoTriggerClientUpdateMutationPayload = {
  __typename: "SudoTriggerClientUpdateMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  sudo?: Maybe<Sudo>;
};

export type SudoUpdateWaitlistMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  enabled: Scalars["Boolean"];
};

export type SudoUpdateWaitlistMutationPayload = {
  __typename: "SudoUpdateWaitlistMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  sudo?: Maybe<Sudo>;
};

export type SudoUpdateWhitelistedDomainsMutationInput = {
  action?: InputMaybe<Action>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  domain: Scalars["String"];
};

export enum Action {
  Add = "Add",
  Remove = "Remove",
}

export type SudoUpdateWhitelistedDomainsMutationPayload = {
  __typename: "SudoUpdateWhitelistedDomainsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  sudo?: Maybe<Sudo>;
};

export type SudoUpdateWhitelistedEmailsMutationInput = {
  action: UpdateWhitelistEmailsAction;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
};

export enum UpdateWhitelistEmailsAction {
  Add = "Add",
  Remove = "Remove",
}

export type SudoUpdateWhitelistedEmailsMutationPayload = {
  __typename: "SudoUpdateWhitelistedEmailsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  sudo?: Maybe<Sudo>;
};

export type ToggleAutoSyncForBillingGroupMutationInput = {
  billingGroupId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  isAutoSyncEnabled: Scalars["Boolean"];
  orgRelayId: Scalars["String"];
  teamId?: InputMaybe<Scalars["String"]>;
};

export type ToggleAutoSyncForBillingGroupMutationPayload = {
  __typename: "ToggleAutoSyncForBillingGroupMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type TriggerDefragRunMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
};

export type TriggerDefragRunMutationPayload = {
  __typename: "TriggerDefragRunMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UnpauseEventMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  externalEventId: Scalars["String"];
  orgRelayId: Scalars["String"];
};

export type UnpauseEventMutationPayload = {
  __typename: "UnpauseEventMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent?: Maybe<EventParent>;
};

export type UnsubscribeEmailInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  token: Scalars["String"];
};

export type UnsubscribeEmailPayload = {
  __typename: "UnsubscribeEmailPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UnsyncFocusTimeBlockMutationInput = {
  calendarId?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  externalEventId?: InputMaybe<Scalars["String"]>;
  isPaused?: InputMaybe<Scalars["Boolean"]>;
  orgRelayId: Scalars["String"];
  timeRange: TimeRangeInput;
};

export type UnsyncFocusTimeBlockMutationPayload = {
  __typename: "UnsyncFocusTimeBlockMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UnsyncFocusTimeEventMutationInput = {
  calendarId?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  externalEventId?: InputMaybe<Scalars["String"]>;
  isPaused?: InputMaybe<Scalars["Boolean"]>;
  orgRelayId: Scalars["String"];
  timeRange: TimeRangeInput;
};

export type UnsyncFocusTimeEventMutationPayload = {
  __typename: "UnsyncFocusTimeEventMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateDeviceTokenInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** A unique identifier for the calling device */
  deviceId: Scalars["String"];
  /** The registration token that allows us to send push notifications to the device */
  registrationToken: Scalars["String"];
};

export type UpdateDeviceTokenPayload = {
  __typename: "UpdateDeviceTokenPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type EventColoringSettingsMutationsInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  eventCategoryColorings: Array<InputMaybe<EventCategoryColoringInput>>;
  /** The front-end ID for the organization we're saving event coloring settings for */
  orgRelayId: Scalars["String"];
};

export type EventCategoryColoringInput = {
  active: Scalars["Boolean"];
  eventCategory: Scalars["String"];
  googleColorKey?: InputMaybe<Scalars["String"]>;
  isUserSet: Scalars["Boolean"];
};

export type EventColoringSettingsMutationsPayload = {
  __typename: "EventColoringSettingsMutationsPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventColoringSettings?: Maybe<EventColoringSettings>;
};

export type UpdateEventResponseStatusMutationInput = {
  calendarId: Scalars["String"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  externalEventId: Scalars["String"];
  orgRelayId: Scalars["String"];
  responseStatus: ResponseStatusEnum;
};

export type UpdateEventResponseStatusMutationPayload = {
  __typename: "UpdateEventResponseStatusMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventParent: EventParent;
};

export type UpdateFlagsForUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  enable: Scalars["Boolean"];
  flagNames: Array<InputMaybe<Scalars["String"]>>;
  flagNamespace: Scalars["String"];
};

export type UpdateFlagsForUserMutationPayload = {
  __typename: "UpdateFlagsForUserMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  flags?: Maybe<Flags>;
};

export type UpdateUserFlowMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  flowKey: Scalars["String"];
  newState: Scalars["String"];
};

export type UpdateUserFlowMutationPayload = {
  __typename: "UpdateUserFlowMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  flowState?: Maybe<FlowState>;
};

export type UpdateUserOrgFlowMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  flowKey: Scalars["String"];
  newState: Scalars["String"];
  orgRelayId: Scalars["String"];
};

export type UpdateUserOrgFlowMutationPayload = {
  __typename: "UpdateUserOrgFlowMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  flowState?: Maybe<FlowState>;
  org?: Maybe<Org>;
  user?: Maybe<User>;
};

export type UpdateLinkActiveInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  slug: Scalars["String"];
};

export type UpdateLinkActivePayload = {
  __typename: "updateLinkActivePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  meetingSettingsErrorable?: Maybe<MeetingSettingsErrorable>;
};

export type UpdateMeetingSettingsInput = {
  body?: InputMaybe<MeetingSettingsInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type UpdateMeetingSettingsPayload = {
  __typename: "UpdateMeetingSettingsPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  meetingSettingsErrorable?: Maybe<MeetingSettingsErrorable>;
};

export type UpdateOrgInviteInput = {
  calendarIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  note?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  productType?: InputMaybe<ProductType>;
};

export enum ProductType {
  Defender = "Defender",
  Defrag = "Defrag",
}

export type UpdateOrgInvitePayload = {
  __typename: "UpdateOrgInvitePayload";
  calendarIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  org?: Maybe<Org>;
};

export type UpdateSettingMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  setting: SettingInput;
  value: Array<InputMaybe<Scalars["String"]>>;
};

export type SettingInput = {
  id: Scalars["ID"];
  key?: InputMaybe<SettingKeyInput>;
  type?: InputMaybe<SettingTypeInput>;
  value?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type SettingKeyInput = {
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  scope?: InputMaybe<UrnInput>;
  target?: InputMaybe<UrnInput>;
};

export type SettingTypeInput = {
  containerType?: InputMaybe<ContainerType>;
  id: Scalars["ID"];
  required?: InputMaybe<Scalars["Boolean"]>;
  valueType?: InputMaybe<ValueType>;
};

export type UpdateSettingMutationPayload = {
  __typename: "UpdateSettingMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  setting?: Maybe<Setting>;
};

export type UpdateSettingsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  settings: Array<SettingInput>;
};

export type UpdateSettingsMutationPayload = {
  __typename: "UpdateSettingsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  setting?: Maybe<Array<Maybe<Setting>>>;
};

export type UpdateShadowCalendarSettingsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  enabled: Scalars["Boolean"];
  /** The front-end ID for the organization we're saving shadow cal settings for */
  orgRelayId: Scalars["String"];
};

export type UpdateShadowCalendarSettingsMutationPayload = {
  __typename: "UpdateShadowCalendarSettingsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  shadowCalendarSettings?: Maybe<ShadowCalendarSettings>;
};

export type UpdateSlackAccountMutationInput = {
  action: SlackUpdateAction;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  slackAccountRelayId: Scalars["String"];
};

export enum SlackUpdateAction {
  Delete = "Delete",
}

export type UpdateSlackAccountMutationPayload = {
  __typename: "UpdateSlackAccountMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateSlackAccountForTeamMutationInput = {
  action: SlackForTeamUpdateAction;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  teamId: Scalars["String"];
};

export enum SlackForTeamUpdateAction {
  Delete = "Delete",
}

export type UpdateSlackAccountForTeamMutationPayload = {
  __typename: "UpdateSlackAccountForTeamMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateSmartHoldSyncSettingsMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  focusTimeExternalTransparency?: InputMaybe<FocusTimeExternalTransparency>;
  focusTimeIdealMinutesPerWeek?: InputMaybe<Scalars["Int"]>;
  focusTimeRemindersEnabled?: InputMaybe<Scalars["Boolean"]>;
  focusTimeSyncAll?: InputMaybe<Scalars["Boolean"]>;
  focusTimeSyncEnabled?: InputMaybe<Scalars["Boolean"]>;
  lunchRemindersEnabled?: InputMaybe<Scalars["Boolean"]>;
  lunchSyncEnabled?: InputMaybe<Scalars["Boolean"]>;
  orgRelayId: Scalars["String"];
  travelTimeRemindersEnabled?: InputMaybe<Scalars["Boolean"]>;
  travelTimeSyncEnabled?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateSmartHoldSyncSettingsMutationPayload = {
  __typename: "UpdateSmartHoldSyncSettingsMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  shadowCalendarSettings: ShadowCalendarSettings;
};

export type UpdateSuggestedOrgInviteInput = {
  calendarIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  note?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  resolution?: InputMaybe<SuggestedOrgInviteResolution>;
};

export type UpdateSuggestedOrgInvitePayload = {
  __typename: "UpdateSuggestedOrgInvitePayload";
  calendarIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  clientMutationId?: Maybe<Scalars["String"]>;
  org?: Maybe<Org>;
};

export type UpdateTeamMutationInput = {
  addedTeamMembers?: InputMaybe<Array<TeamRoleAndPersonIdInput>>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  newTeamName?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  removedTeamMembers?: InputMaybe<Array<Scalars["String"]>>;
  teamId: Scalars["String"];
};

export type UpdateTeamMutationPayload = {
  __typename: "updateTeamMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  team: Team;
};

export type ToggleEventColoringSettingsMutationsInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  enabled: Scalars["Boolean"];
  eventCategoryColorings: Array<InputMaybe<EventCategoryColoringInput>>;
  /** The front-end ID for the organization we're saving event coloring settings for */
  orgRelayId: Scalars["String"];
};

export type ToggleEventColoringSettingsMutationsPayload = {
  __typename: "ToggleEventColoringSettingsMutationsPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  eventColoringSettings?: Maybe<EventColoringSettings>;
};

export type UpdateUserDefinedTeamMutationInput = {
  calendarIds: Array<InputMaybe<Scalars["String"]>>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  userDefinedTeamRelayId: Scalars["String"];
};

export type UpdateUserDefinedTeamMutationPayload = {
  __typename: "UpdateUserDefinedTeamMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  userDefinedTeam?: Maybe<UserDefinedTeam>;
};

export type UpdateUserShortnameInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The new shortname for the User. */
  shortname: Scalars["String"];
};

export type UpdateUserShortnamePayload = {
  __typename: "UpdateUserShortnamePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  userErrorable?: Maybe<UserErrorable>;
};

export type UserErrorable = GraphEntityError | User;

export type UpdateWorkingHoursMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** if true, will be saved as both Base and Meeting, regardless of the type on the working hours argument */
  saveMeetingAndWorkingHours?: InputMaybe<Scalars["Boolean"]>;
  workingHours: WorkingHoursInput;
};

export type WorkingHoursInput = {
  dayOverrides?: InputMaybe<Array<InputMaybe<DayOverrideInput>>>;
  daySettings?: InputMaybe<Array<InputMaybe<DaySettingInput>>>;
  id: Scalars["ID"];
  timeZone?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<WorkingHoursTypeEnum>;
};

export type DayOverrideInput = {
  date?: InputMaybe<Scalars["String"]>;
  setting?: InputMaybe<WorkingSettingInput>;
};

export type WorkingSettingInput = {
  excludedSlots?: InputMaybe<Array<InputMaybe<ExcludedSlots>>>;
  maxSlot?: InputMaybe<MaxSlot>;
  minSlot?: InputMaybe<MinSlot>;
};

export type DaySettingInput = {
  day?: InputMaybe<Day>;
  setting?: InputMaybe<WorkingSettingInput>;
};

export type UpdateWorkingHoursMutationPayload = {
  __typename: "UpdateWorkingHoursMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  updatedOrgMeetingHours?: Maybe<WorkingHours>;
  updatedUserMeetingHours?: Maybe<WorkingHours>;
  updatedUserWorkingHours?: Maybe<WorkingHours>;
  userWorkingHours?: Maybe<UserWorkingHours>;
};

export type UpsertEmailTriageMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  options: GoalPatchEmailTriageOptionsInput;
  orgId: Scalars["String"];
};

export type GoalPatchEmailTriageOptionsInput = {
  minutesDuration?: InputMaybe<Scalars["Int"]>;
  nameOverride?: InputMaybe<Scalars["String"]>;
  syncToGoogle?: InputMaybe<Scalars["Boolean"]>;
};

export type UpsertEmailTriageMutationPayload = {
  __typename: "UpsertEmailTriageMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  goal?: Maybe<Goal>;
  goalEdge?: Maybe<GoalEdge>;
  org?: Maybe<Org>;
};

export type UpsertFocusTimeMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  options: GoalPatchFocusTimeOptionsInput;
  orgId: Scalars["String"];
};

export type GoalPatchFocusTimeOptionsInput = {
  maxMinutesPerBlock?: InputMaybe<Scalars["Int"]>;
  syncToGoogle?: InputMaybe<Scalars["Boolean"]>;
};

export type UpsertFocusTimeMutationPayload = {
  __typename: "UpsertFocusTimeMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  goal?: Maybe<Goal>;
  goalEdge?: Maybe<GoalEdge>;
  org?: Maybe<Org>;
};

export type UpsertLunchMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  options: GoalPatchLunchOptionsInput;
  orgId: Scalars["String"];
};

export type GoalPatchLunchOptionsInput = {
  idealMinutesDuration?: InputMaybe<Scalars["Int"]>;
  maxTimeSlot?: InputMaybe<TimeSlot>;
  minimumMinutesDuration?: InputMaybe<Scalars["Int"]>;
  minTimeSlot?: InputMaybe<TimeSlot>;
  syncToGoogle?: InputMaybe<Scalars["Boolean"]>;
};

export type UpsertLunchMutationPayload = {
  __typename: "UpsertLunchMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  goal?: Maybe<Goal>;
  goalEdge?: Maybe<GoalEdge>;
  org?: Maybe<Org>;
};

export type UpsertMeetingReliefMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  options: GoalPatchMeetingReliefOptionsInput;
  orgId: Scalars["String"];
};

export type GoalPatchMeetingReliefOptionsInput = {
  fatigueThresholdMinutes?: InputMaybe<Scalars["Int"]>;
  meetingReliefBreakMinutes?: InputMaybe<Scalars["Int"]>;
};

export type UpsertMeetingReliefMutationPayload = {
  __typename: "UpsertMeetingReliefMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  goal?: Maybe<Goal>;
  goalEdge?: Maybe<GoalEdge>;
  org?: Maybe<Org>;
};

export type UpsertNonUserDefragEmailResponseInput = {
  additionalInformation?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  emailInstanceId: Scalars["String"];
  responseType: NonUserDefragEmailResponseType;
};

export type UpsertNonUserDefragEmailResponsePayload = {
  __typename: "UpsertNonUserDefragEmailResponsePayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  nonUserDefragEmailResponse?: Maybe<NonUserDefragEmailResponse>;
};

export type UpsertPreferredWorkMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  options: GoalPatchPreferredWorkOptionsInput;
  orgId: Scalars["String"];
};

export type GoalPatchPreferredWorkOptionsInput = {
  keepEndOfDayOpen?: InputMaybe<Scalars["Boolean"]>;
  keepStartOfDayOpen?: InputMaybe<Scalars["Boolean"]>;
  preferredWorkType?: InputMaybe<PreferredWorkType>;
};

export type UpsertPreferredWorkMutationPayload = {
  __typename: "UpsertPreferredWorkMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  goal?: Maybe<Goal>;
  goalEdge?: Maybe<GoalEdge>;
  org?: Maybe<Org>;
};

export type UpsertTravelTimeMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  options: GoalPatchTravelTimeOptionsInput;
  orgId: Scalars["String"];
};

export type GoalPatchTravelTimeOptionsInput = {
  syncToGoogle?: InputMaybe<Scalars["Boolean"]>;
};

export type UpsertTravelTimeMutationPayload = {
  __typename: "UpsertTravelTimeMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  goal?: Maybe<Goal>;
  goalEdge?: Maybe<GoalEdge>;
  org?: Maybe<Org>;
};

export type SaveUserSurveyResponsesMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  userSurveyResponses?: InputMaybe<Array<InputMaybe<UserSurveyResponseInput>>>;
};

export type UserSurveyResponseInput = {
  freeformResponse?: InputMaybe<Scalars["String"]>;
  questionText?: InputMaybe<Scalars["String"]>;
  questionType?: InputMaybe<QuestionType>;
  responseText?: InputMaybe<Scalars["String"]>;
  responseType?: InputMaybe<ResponseType>;
};

export type SaveUserSurveyResponsesMutationPayload = {
  __typename: "SaveUserSurveyResponsesMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  userSurveyResponse?: Maybe<UserSurveyResponse>;
};

export type SaveUserSurveyResponseWrapperMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  userSurveyResponseWrapper: UserSurveyResponseWrapperInput;
};

export type UserSurveyResponseWrapperInput = {
  id: Scalars["ID"];
  userSurveyResponses: Array<UserSurveyResponseInput>;
};

export type SaveUserSurveyResponseWrapperMutationPayload = {
  __typename: "SaveUserSurveyResponseWrapperMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  userSurveyResponseWrapper: UserSurveyResponseWrapper;
};

export type ValidateSlackChannelBySendingMessageMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  orgRelayId: Scalars["String"];
  slackChannelName: Scalars["String"];
  teamId: Scalars["String"];
};

export type ValidateSlackChannelBySendingMessageMutationPayload = {
  __typename: "ValidateSlackChannelBySendingMessageMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  validateSlackChannelResponse: ValidateSlackChannelResponse;
};

/** DESCRIBE NEW FIELD HERE */
export type ValidateSlackChannelResponse = {
  __typename: "ValidateSlackChannelResponse";
  channel?: Maybe<SlackChannel>;
  /** The ID of an object */
  id: Scalars["ID"];
  isValid: Scalars["Boolean"];
};

export type WeeklySummaryResponseMutationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  feedback?: InputMaybe<WeeklySummaryFeedback>;
  maxDate: Scalars["String"];
  minDate: Scalars["String"];
  orgRelayId: Scalars["ID"];
};

export enum WeeklySummaryFeedback {
  No = "No",
  NoOpinion = "NoOpinion",
  Yes = "Yes",
}

export type WeeklySummaryResponseMutationPayload = {
  __typename: "WeeklySummaryResponseMutationPayload";
  clientMutationId?: Maybe<Scalars["String"]>;
  response?: Maybe<Scalars["Boolean"]>;
};

export type Subscription = {
  __typename: "Subscription";
  updateEventInNearbyWeekChanges?: Maybe<EventInNearbyWeekChange>;
  updateEventParentBaseWrapper?: Maybe<EventParentBaseWrapper>;
  updateEventParentWrappers: UpdateEventParentWrappersSubscriptionPayload;
  updateFlowState: UpdateFlowStateSubscriptionPayload;
  updateOrgFlowState: UpdateOrgFlowStateSubscriptionPayload;
  updateTeamCalendarState: UpdateTeamCalendarStateSubscriptionPayload;
};

export type SubscriptionUpdateEventInNearbyWeekChangesArgs = {
  input: UpdateEventInNearbyWeekChangeInput;
};

export type SubscriptionUpdateEventParentBaseWrapperArgs = {
  input: UpdateEventParentBaseWrappersSubscriptionInput;
};

export type SubscriptionUpdateEventParentWrappersArgs = {
  input: UpdateEventParentWrappersSubscriptionInput;
};

export type SubscriptionUpdateFlowStateArgs = {
  input: UpdateFlowStateSubscriptionInput;
};

export type SubscriptionUpdateOrgFlowStateArgs = {
  input: UpdateOrgFlowStateSubscriptionInput;
};

export type SubscriptionUpdateTeamCalendarStateArgs = {
  input: UpdateTeamCalendarStateSubscriptionInput;
};

export type UpdateEventInNearbyWeekChangeInput = {
  calendarIds: Array<Scalars["String"]>;
  orgRelayId: Scalars["ID"];
};

export type EventInNearbyWeekChange = {
  __typename: "EventInNearbyWeekChange";
  affectedWeeks: Array<Scalars["String"]>;
  calendarId: Scalars["String"];
  currentMillis: Scalars["Float"];
};

export type UpdateEventParentBaseWrappersSubscriptionInput = {
  calendarIds: Array<Scalars["String"]>;
  dates: Array<Scalars["LocalDate"]>;
  includeAllDay?: InputMaybe<Scalars["Boolean"]>;
  orgRelayId: Scalars["ID"];
  timeZone: Scalars["String"];
};

export type UpdateEventParentWrappersSubscriptionInput = {
  calendarIds: Array<Scalars["String"]>;
  dates: Array<Scalars["LocalDate"]>;
  includeAllDay?: InputMaybe<Scalars["Boolean"]>;
  orgRelayId: Scalars["ID"];
  timeZone: Scalars["String"];
};

export type UpdateEventParentWrappersSubscriptionPayload = {
  __typename: "UpdateEventParentWrappersSubscriptionPayload";
  eventParentBases: Array<EventParentBase>;
  eventParentWrappers?: Maybe<Array<EventParentWrapper>>;
};

export type UpdateFlowStateSubscriptionInput = {
  flowStateRelayId: Scalars["ID"];
};

export type UpdateFlowStateSubscriptionPayload = {
  __typename: "UpdateFlowStateSubscriptionPayload";
  flowState?: Maybe<FlowState>;
};

export type UpdateOrgFlowStateSubscriptionInput = {
  flowStateRelayId: Scalars["ID"];
};

export type UpdateOrgFlowStateSubscriptionPayload = {
  __typename: "UpdateOrgFlowStateSubscriptionPayload";
  flowState?: Maybe<FlowState>;
};

export type UpdateTeamCalendarStateSubscriptionInput = {
  orgRelayId: Scalars["ID"];
  teamId: Scalars["String"];
};

export type UpdateTeamCalendarStateSubscriptionPayload = {
  __typename: "UpdateTeamCalendarStateSubscriptionPayload";
  teamCalendarState?: Maybe<TeamCalendarState>;
};

/** The state of a team calendar */
export type TeamCalendarState = {
  __typename: "TeamCalendarState";
  calendarId: Scalars["String"];
};
